import * as i0 from '@angular/core';
import { Injectable, Component, Input, ViewChild, Pipe, EventEmitter, Output, Directive, ViewChildren, Inject, HostListener, ViewEncapsulation, NgModule } from '@angular/core';
import * as i5 from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipConfig, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpClientModule } from '@angular/common/http';
import * as i4 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i3 from 'ng-apexcharts';
import { NgApexchartsModule } from 'ng-apexcharts';
import * as i3$1 from '@angular/forms';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { trigger, state, style, AUTO_STYLE, transition, group, animate } from '@angular/animations';
import * as i6 from 'ng-multiselect-dropdown';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Subscription } from 'rxjs';

var summary$i = {
	lrPrice: "Valor spot Eurotax",
	avgStockDays: "Dias anunciado",
	desirability: "Deseabilidad",
	avgMileage: "Kilometraje",
	avgPriceChanges: "Cambios de precio",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$i = {
	graph: {
		liveRetailPrice: "Valor spot Eurotax",
		lrp: "Valor spot Eurotax",
		avg: "MEDIA:"
	},
	heading: {
		zip: "C.POSTAL"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$i = {
	mileage: "Kilometraje",
	year: "Año",
	keywords: "Palabras clave",
	engineSize: "Motor",
	fuel: "Combustible",
	body: "Carrocería",
	transmission: "Transmisión",
	drive: "Tracción",
	power: "Potencia",
	distance: "Distancia",
	seller: "Vendedor",
	dealerSeller: "Distribuidor",
	privateSeller: "Privado",
	vehicles: "Vehiculos",
	onSaleVehicles: "En venta",
	soldVehicles: "Vendidos (60 days)",
	showFilters: "Mostrar filtros",
	hideFilters: "Ocultar filtros",
	buttonSearch: "Buscar",
	nullValid: "Todas",
	wholeCountry: "Todo el pais",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$i = {
	exact: "Exacta",
	best: "Muy alta",
	close: "alta",
	similar: "media",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$i = {
	ownVehicle: "Su vehiculo",
	adLinks: "Links",
	vehicle: "Vehiculo",
	askPrice: "Precio anunciado",
	diffPrice: "VS",
	lrPrice: "Valor spot Eurotax",
	similarity: "Parecido",
	distance: "Distancia",
	odometer: "Km",
	regDate: "Matriculación",
	company: "Compañia",
	stockDays: "Días anunciado",
	priceChanges: "Histórial precios",
	tooltips: {
		vhDescription: {
			header: "Descripción completa",
			make: "Marca",
			modelSeries: "Modelo",
			type: "Versión",
			body: "Carrocería",
			doors: "Puertas",
			seats: "Plazas",
			fuel: "Combustible",
			powerKW: "Kw",
			powerHP: "cv",
			cylCubic: "cc",
			cylinders: "Disposición",
			gearBox: "Caja de cambios",
			noOfGears: "Nº de marchas",
			drive: "Tracción",
			engineType: "Tipo de motor",
			wheelBase: "Batalla",
			totalWeight: "P.M.A",
			payload: "Carga útil",
			importBegin: "Inicio comercialización",
			importEnd: "Fin comercialización",
			vhType: "Tipo de vehículo",
			nationalCode: "Natcode"
		},
		priceDiff: {
			header: "Precio de oferta Eurotax al detalle",
			standardVh: "Precio base según ofertas vigentes",
			standardVhOdometer: "Kilometraje medio",
			standardVhRegDate: "Edad media",
			thisVh: "Este vehículo",
			odometerEffect: "Corrección de kilometraje",
			ageEffect: "Correción de edad",
			regionalEffect: "Corrección regional",
			options: "Equipamiento",
			equipmentAverage: "Avg options value - detailed options n/a",
			totalEffects: "Total correcciónes",
			regionalAskingPrice: "Precio de oferta Eurotax",
			regional: "Precio de oferta Eurotax",
			askingPrice: "Precio de publicación",
			priceDifference: "Diferencia de precio",
			underpriced: "Infravalorado",
			overpriced: "Sobreprecio",
			noOptions: "No afecta al precio"
		},
		priceHistory: {
			header: "Historial Precios",
			dateAdRemoved: "Último día de oferta",
			removed: "Anuncio eliminado",
			"new": "Nuevo anuncio",
			priceCh: "Cambio de precio",
			original: "Anuncio original"
		}
	}
};
var config$v = {
	monthsTraslation: "Meses"
};
var errorCode$i = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var es_ES = {
	summary: summary$i,
	report: report$i,
	filters: filters$i,
	matches: matches$i,
	results: results$i,
	config: config$v,
	errorCode: errorCode$i
};

var summary$h = {
	lrPrice: "Live retail price",
	avgStockDays: "Avg. stock days",
	desirability: "desirablity",
	avgMileage: "Avg. mileage",
	avgPriceChanges: "Avg. price changes",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$h = {
	graph: {
		liveRetailPrice: "LIVE RETAIL PRICE",
		lrp: "LRP",
		avg: "AVG."
	},
	heading: {
		zip: "ZIP"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$h = {
	mileage: "Mileage",
	year: "Year",
	keywords: "Keyword(s)",
	engineSize: "Engine size",
	fuel: "Fuel",
	body: "Body",
	transmission: "Transmission",
	drive: "Drivetrain",
	power: "Power",
	distance: "Distance",
	seller: "Seller",
	dealerSeller: "Dealer",
	privateSeller: "Private",
	vehicles: "Vehicles",
	onSaleVehicles: "On sale",
	soldVehicles: "Sold (60 days)",
	showFilters: "Show filtering options",
	hideFilters: "Hide filtering options",
	buttonSearch: "Search",
	nullValid: "All",
	wholeCountry: "Whole Country",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$h = {
	exact: "Exact",
	best: "Best",
	close: "Close",
	similar: "Similar",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$h = {
	ownVehicle: "Own vehicle",
	adLinks: "Ad Link",
	vehicle: "Vehicle",
	askPrice: "Ask. Price",
	diffPrice: "VS",
	lrPrice: "Live Retail",
	similarity: "Match",
	distance: "distance",
	odometer: "Km",
	regDate: "reg. date",
	company: "company",
	stockDays: "stock days",
	priceChanges: "price changes",
	tooltips: {
		vhDescription: {
			header: "Vehicle Description",
			make: "Make",
			modelSeries: "Model series",
			type: "Type",
			body: "Body type",
			doors: "Doors",
			seats: "Seats",
			fuel: "Fuel type",
			powerKW: "Engine power kW",
			powerHP: "Engine power HP",
			cylCubic: "Engine size",
			cylinders: "Cylinders",
			gearBox: "Transmission",
			noOfGears: "No. of gears",
			drive: "Drivetrain",
			engineType: "Engine type",
			wheelBase: "Wheelbase",
			totalWeight: "Total weight",
			payload: "Pay load",
			importBegin: "Introduced",
			importEnd: "Discontinued",
			vhType: "Vehicle type",
			nationalCode: "National code"
		},
		priceDiff: {
			header: "LIVE Retail in Detail",
			standardVh: "Basis offer price according to current offers",
			standardVhOdometer: "Avg. Mileage",
			standardVhRegDate: "Avg. Reg.Date",
			thisVh: "This Vehicle",
			odometerEffect: "Mileage Correction",
			ageEffect: "Age Correction",
			regionalEffect: "Regional Correction",
			options: "Equipment:",
			equipmentAverage: "Avg options value - detailed options n/a",
			totalEffects: "Corrections Total",
			regionalAskingPrice: "LIVE RETAIL",
			regional: "Glass's LIVE Retail",
			askingPrice: "Asking Price",
			priceDifference: "Price Difference",
			underpriced: "Underpriced",
			overpriced: "Overpriced",
			noOptions: "No Effect in Price"
		},
		priceHistory: {
			header: "Price History",
			dateAdRemoved: "Date last advertised",
			removed: "Advert removed",
			"new": "New advert",
			priceCh: "Price change",
			original: "Original advert"
		}
	}
};
var config$u = {
	monthsTraslation: "Months"
};
var errorCode$h = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var en_ES = {
	summary: summary$h,
	report: report$h,
	filters: filters$h,
	matches: matches$h,
	results: results$h,
	config: config$u,
	errorCode: errorCode$h
};

var summary$g = {
	lrPrice: "Live retail price",
	avgStockDays: "stock days",
	desirability: "desirablity",
	avgMileage: "mileage",
	avgPriceChanges: "price changes",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$g = {
	graph: {
		liveRetailPrice: "LIVE RETAIL PRICE",
		lrp: "LRP",
		avg: "AVG."
	},
	heading: {
		zip: "ZIP"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$g = {
	mileage: "Mileage",
	year: "Year",
	keywords: "Keyword(s)",
	engineSize: "Engine size",
	fuel: "Fuel",
	body: "Body",
	transmission: "Transmission",
	drive: "Drivetrain",
	power: "Power",
	distance: "Distance",
	seller: "Seller",
	dealerSeller: "Dealer",
	privateSeller: "Private",
	vehicles: "Vehicles",
	onSaleVehicles: "On sale",
	soldVehicles: "Sold (60 days)",
	showFilters: "Show filtering options",
	hideFilters: "Hide filtering options",
	buttonSearch: "Search",
	nullValid: "All",
	wholeCountry: "Whole Country",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$g = {
	exact: "Exact",
	best: "Best",
	close: "Close",
	similar: "Similar",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$g = {
	ownVehicle: "Own vehicle",
	adLinks: "Ad Link",
	vehicle: "Vehicle",
	askPrice: "Asking Price",
	diffPrice: "VS",
	lrPrice: "Live Retail",
	similarity: "Match",
	distance: "distance",
	odometer: "Mileage",
	regDate: "REGISTRATION",
	company: "company",
	stockDays: "stock days",
	priceChanges: "price changes",
	tooltips: {
		vhDescription: {
			header: "full Description",
			make: "Make",
			modelSeries: "Model series",
			type: "Type",
			body: "Body type",
			doors: "Doors",
			seats: "Seats",
			fuel: "Fuel type",
			powerKW: "Engine power kW",
			powerHP: "Engine power HP",
			cylCubic: "Engine size",
			cylinders: "Cylinders",
			gearBox: "Transmission",
			noOfGears: "No. of gears",
			drive: "Drivetrain",
			engineType: "Engine type",
			wheelBase: "Wheelbase",
			totalWeight: "Total weight",
			payload: "Pay load",
			importBegin: "Introduced",
			importEnd: "Discontinued",
			vhType: "Vehicle type",
			nationalCode: "National code"
		},
		priceDiff: {
			header: "LIVE Retail in Detail",
			standardVh: "Standard Vehicle",
			standardVhOdometer: "Avg. Mileage",
			standardVhRegDate: "Avg. Reg.Date",
			thisVh: "This Vehicle",
			odometerEffect: "Mileage Correction",
			ageEffect: "Age Correction",
			regionalEffect: "Regional Correction",
			options: "Equipment:",
			equipmentAverage: "Avg options value - detailed options n/a",
			totalEffects: "Corrections Total",
			regionalAskingPrice: "Glass's LIVE Retail",
			regional: "Glass's LIVE Retail",
			askingPrice: "Asking Price",
			priceDifference: "Price Difference",
			underpriced: "Underpriced",
			overpriced: "Overpriced",
			noOptions: "No Effect in Price"
		},
		priceHistory: {
			header: "Price History",
			dateAdRemoved: "Date last advertised",
			removed: "Advert removed",
			"new": "New advert",
			priceCh: "Price change",
			original: "Original advert"
		}
	}
};
var config$t = {
	monthsTraslation: "Months"
};
var errorCode$g = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var en_UK = {
	summary: summary$g,
	report: report$g,
	filters: filters$g,
	matches: matches$g,
	results: results$g,
	config: config$t,
	errorCode: errorCode$g
};

var summary$f = {
	lrPrice: "Valor spot eurotax",
	avgStockDays: "Dias anunciado (media)",
	desirability: "Conveniencia",
	avgMileage: "Kilometraje (media)",
	avgPriceChanges: "Cambios de precio (media)",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$f = {
	graph: {
		liveRetailPrice: "LIVE RETAIL PRICE",
		lrp: "lrp",
		avg: "AVG."
	},
	heading: {
		zip: "ZIP"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$f = {
	mileage: "Kilometraje",
	year: "Año",
	keywords: "Palabras clave",
	engineSize: "Motor",
	fuel: "Combustible",
	body: "Carrocería",
	transmission: "Transmisión",
	drive: "Tracción",
	power: "Potencia",
	distance: "Distancia",
	seller: "Vendedor",
	dealerSeller: "Distribuidor",
	privateSeller: "Privado",
	vehicles: "vehicles",
	onSaleVehicles: "En venta",
	soldVehicles: "Vendidos (60 days)",
	showFilters: "Mostrar filtros",
	hideFilters: "Ocultar filtros",
	buttonSearch: "Buscar",
	nullValid: "Tots",
	wholeCountry: "Tot el país",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$f = {
	exact: "Exacte",
	best: "Molt alta",
	close: "Alta",
	similar: "Mitjana",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$f = {
	ownVehicle: "El seu vehicle",
	adLinks: "Links",
	vehicle: "vehicle",
	askPrice: "Preu d'anunci",
	diffPrice: "VS",
	lrPrice: "Valor spot Eurotax",
	similarity: "Semblant",
	distance: "Disténcia",
	odometer: "Km",
	regDate: "Data de Matrícula",
	company: "Cod. Postal",
	stockDays: "Díes anunciat",
	priceChanges: "Històric de preus",
	tooltips: {
		vhDescription: {
			header: "Descripció completa",
			make: "Marca",
			modelSeries: "Model",
			type: "Versió",
			body: "Carrossería",
			doors: "Portes",
			seats: "Seients",
			fuel: "Combustible",
			powerKW: "Kw",
			powerHP: "cv",
			cylCubic: "cc",
			cylinders: "Disposición",
			gearBox: "Caixa de canvis",
			noOfGears: "Nombre de marxes",
			drive: "Tracció",
			engineType: "Tipus de motor",
			wheelBase: "Batalla",
			totalWeight: "P.M.A",
			payload: "Carga útil",
			importBegin: "Inici comercializació",
			importEnd: "Fi comercializació",
			vhType: "Tipus de vehículo",
			nationalCode: "Natcode"
		},
		priceDiff: {
			header: "Valor Spot Eurotax al detall",
			standardVh: "Valor base según ofertas vigentes",
			standardVhOdometer: "Quilometratge mitjé",
			standardVhRegDate: "Edat mitjana",
			thisVh: "Aquest vehicle",
			odometerEffect: "Corrección de quilometratge",
			ageEffect: "Correció d'edat",
			regionalEffect: "Correcció regional",
			options: "Equipament:",
			equipmentAverage: "Avg options value - detailed options n/a",
			totalEffects: "Total correccions",
			regionalAskingPrice: "Valor Spot Eurotax",
			regional: "Valor Spot Eurotax",
			askingPrice: "Preu de publicación",
			priceDifference: "Diferencia de preu",
			underpriced: "Infravalorat",
			overpriced: "Sobrepreu",
			noOptions: "No afecta al preu"
		},
		priceHistory: {
			header: "Històric de preus",
			dateAdRemoved: "Último día de oferta",
			removed: "Data de retirada del anunci",
			"new": "Nou anunci",
			priceCh: "Canvi de preu",
			original: "Anunci original"
		}
	}
};
var config$s = {
	monthsTraslation: "Meses"
};
var errorCode$f = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var ca_ES = {
	summary: summary$f,
	report: report$f,
	filters: filters$f,
	matches: matches$f,
	results: results$f,
	config: config$s,
	errorCode: errorCode$f
};

var summary$e = {
	lrPrice: "EurotaxTageskurs",
	avgStockDays: "STANDTAGE",
	desirability: "NACHFRAGE",
	avgMileage: "LAUFLEISTUNG",
	avgPriceChanges: "PREISÄNDERUNGEN",
	summaryTooltip: {
		header: "EurotaxTageskurs - Echtzeitbewertungen",
		content: "Diese Funktion vergleicht Ihren Angebotspreis mit vergleichbaren Fahrzeugen aus den Online-Börsen. Der SCHWACKE Tagespreis zeigt auf einen Blick, welche Fahrzeuge zu hoch bzw. zu niedrig bepreist sind. Dabei werden die Fahrzeuge gemäß Ausstattung, Alter und Laufleistung gleichgestellt.",
		content2: "Hinweis: Obwohl versch. Fahrzeuge sehr ähnlich erscheinen können, sind sie niemals komplett gleich und dies führt zu Preisdifferenzen.",
		list: {
			first: "Standtage – Durchschnittliche Standtage aller vergleichbaren Fahrzeuge.",
			second: "Laufleistung – Durchschnittliche Laufleistung aller vergleichbaren Fahrzeuge.",
			third: "Nachfrage – Gibt an, wie stark ein Fahrzeug am Markt nachgefragt wird (Hoch – Gut – Durchschnittlich – Gering).",
			fourth: "Preisänderungen – Durchschnittliche Anzahl an Preisänderungen aller vergleichbaren Fahrzeuge."
		}
	}
};
var report$e = {
	graph: {
		liveRetailPrice: "EurotaxTageskurs",
		lrp: "Basierend auf Ihrer gefilterten Liste",
		avg: "DURCHSCHN."
	},
	heading: {
		zip: "PLZ"
	},
	scatterTooltip: {
		header: "EurotaxTageskurs Preisvergleichs-Grafik",
		content: "Wenn Sie die Maus über das Grafik-Icon bewegen, öffnet sich eine Preisvergleichs-Grafik. Diese zeigt einen Überblick vergleichbarer Fahrzeuge (inkl. Ihres Fahrzeugs) und deren Preisdifferenz zum EurotaxTageskurs. Jedes Fahrzeug wird anhand einer farbigen Raute dargestellt. Mit Klick auf die Raute öffnet sich die jeweilige Fahrzeuganzeige.",
		list: {
			first: "Grün: Eindeutig",
			second: "Blau: Sehr hoch",
			third: "Gelb: Hoch",
			fourth: "Grau: Aktuelles Fahrzeug"
		}
	}
};
var filters$e = {
	mileage: "Laufleistung:",
	year: "EZ (Jahr):",
	keywords: "Stichwörter:",
	engineSize: "Hubraum (ccm):",
	fuel: "Kraftstoff:",
	body: "Karosserie:",
	transmission: "Getriebe:",
	drive: "Antrieb:",
	power: "Leistung (kW):",
	distance: "Umkreis:",
	seller: "Verkäufer:",
	dealerSeller: "Händler",
	privateSeller: "Privat",
	vehicles: "Fahrzeuge:",
	onSaleVehicles: "Angeboten",
	soldVehicles: "Verkauft (60 Tage)",
	showFilters: "Filter anzeigen",
	hideFilters: "Filter ausblenden",
	buttonSearch: "Suche",
	nullValid: "Alle",
	wholeCountry: "National",
	filtersTooltip: {
		content: "Über die Filter der Angebotstabelle können die angezeigten Fahrzeuge eingeschränkt werden.",
		list: {
			first: "Laufleistung",
			second: "Erstzulassungsdatum",
			third: "Kraftstoffart",
			fourth: "Getriebeart",
			fifth: "Motorleistung",
			sixth: "Ausführung (z. B. Zetec, TDi Sport, S Line)",
			seventh: "Hubraum (CCM)",
			eighth: "Aufbauart",
			ninth: "Antriebsart",
			tenth: "Umkreis (km)"
		}
	}
};
var matches$e = {
	exact: "EINDEUTIGE",
	best: "SEHR HOHE",
	close: "HOHE",
	similar: "MITTLERE",
	matchesTooltip: {
		content: "Diese Icons geben an, wie sehr das aktuelle Fahrzeug mit dem jeweiligen in den Börsen angebotenen Fahrzeug übereinstimmt. Die gleichen Farben werden auch in der Preisvergleichs-Grafik verwendet. Die Fahrzeuge in der Tabelle können mit Klick auf die jeweilige Spalte nach deren Inhalt sortiert werden."
	}
};
var results$e = {
	ownVehicle: "Eigenes Fahrzeug",
	adLinks: "Anzeige",
	vehicle: "Fahrzeug",
	askPrice: "Angebots- preis",
	diffPrice: "Abweichung",
	lrPrice: "Eurotax- Tageskurs",
	similarity: "OVEREENKOMST",
	distance: "Umkreis",
	odometer: "KM",
	regDate: "EZL",
	company: "Händler",
	stockDays: "Angebotsdauer",
	priceChanges: "Historische Preisinformation",
	tooltips: {
		vhDescription: {
			header: "Vollständige Beschreibung",
			make: "Marke",
			modelSeries: "Modellreihe",
			type: "Typ",
			body: "Aufbauart",
			doors: "Türen",
			seats: "Plätze",
			fuel: "Kraftstoff",
			powerKW: "KW",
			powerHP: "PS",
			cylCubic: "Hubraum",
			cylinders: "Zylinder",
			gearBox: "Getriebeart",
			noOfGears: "Gänge",
			drive: "Antriebsart",
			engineType: "Motorart",
			wheelBase: "Radstand",
			totalWeight: "Gesamtgewicht",
			payload: "Nutzlast",
			importBegin: "Importbeginn",
			importEnd: "Importende",
			vhType: "Fahrzeugart",
			nationalCode: "Nationaler Code"
		},
		priceDiff: {
			header: "EurotaxTageskurs im Detail:",
			standardVh: "Standard Fahrzeug",
			standardVhOdometer: "ø Laufleistung",
			standardVhRegDate: "ø EZL",
			thisVh: "gewähltes Fahrzeug",
			odometerEffect: "Kilometerkorrektur",
			ageEffect: "Monatskorrektur(Alter)",
			regionalEffect: "regionale Korrektur",
			options: "Sonderausstattung:",
			equipmentAverage: "Durchschn. Ausstattungswert - detaillierte Ausstattung nicht verfügbar",
			totalEffects: "alle Korrekturen",
			regionalAskingPrice: "Regionaler Angebotspreis",
			regional: "EurotaxTageskurs",
			askingPrice: "Angebotspreis",
			priceDifference: "Preisdifferenz",
			underpriced: "Abweichung (-)",
			overpriced: "Abweichung (+)",
			noOptions: "keine Auswirkung auf den Preis"
		},
		priceHistory: {
			header: "Historische Preisinformation",
			dateAdRemoved: "Letzter angebotstag",
			removed: "Angebot gelöscht",
			"new": "Neues Angebot",
			priceCh: "Preisänderung",
			original: "Original Angebot"
		}
	}
};
var config$r = {
	monthsTraslation: "Monate"
};
var errorCode$e = {
	wrongAskingOrMileage: "Der Angebotspreis und/oder der Kilometerstand werden benötigt und dürfen nicht 0 sein, damit der Schwacke Tagespreis ermittelt werden kann. Sollten weitere Probleme auftreten, dann wenden Sie sich bitte an unsere Hotline.",
	onlyOwnVh: "Mit den von Ihnen gewählten Filteroptionen können keine vergleichbaren Fahrzeuge gefunden werden. Bitte ändern Sie Ihre Filterkriterien, z.B. den Radius der Suche (Umkreis) und versuchen Sie es erneut."
};
var de_UK = {
	summary: summary$e,
	report: report$e,
	filters: filters$e,
	matches: matches$e,
	results: results$e,
	config: config$r,
	errorCode: errorCode$e
};

var summary$d = {
	lrPrice: "ANGEBOTSKURS",
	sellingSpotPrice: "Eurotax Verkaufskurs",
	avgStockDays: "STANDTAGE",
	desirability: "NACHFRAGE",
	avgMileage: "LAUFLEISTUNG",
	avgPriceChanges: "PREISÄNDERUNGEN",
	summaryTooltip: {
		header: "SCHWACKE Tagespreis - Echtzeitbewertungen",
		content: "Diese Funktion vergleicht Ihren Angebotspreis mit vergleichbaren Fahrzeugen aus den Online-Börsen. Der SCHWACKE Tagespreis zeigt auf einen Blick, welche Fahrzeuge zu hoch bzw. zu niedrig bepreist sind. Dabei werden die Fahrzeuge gemäß Ausstattung, Alter und Laufleistung gleichgestellt.",
		content2: "Hinweis: Obwohl versch. Fahrzeuge sehr ähnlich erscheinen können, sind sie niemals komplett gleich und dies führt zu Preisdifferenzen.",
		list: {
			first: "Standtage – Durchschnittliche Standtage aller vergleichbaren Fahrzeuge.",
			second: "Laufleistung – Durchschnittliche Laufleistung aller vergleichbaren Fahrzeuge.",
			third: "Nachfrage – Gibt an, wie stark ein Fahrzeug am Markt nachgefragt wird (Hoch – Gut – Durchschnittlich – Gering).",
			fourth: "Preisänderungen – Durchschnittliche Anzahl an Preisänderungen aller vergleichbaren Fahrzeuge."
		}
	}
};
var report$d = {
	graph: {
		liveRetailPrice: "ANGEBOTSKURS",
		lrp: "LRP",
		avg: "DURCHSCHN."
	},
	heading: {
		zip: "PLZ"
	},
	scatterTooltip: {
		header: "SCHWACKE Tagespreis Preisvergleichs-Grafik",
		content: "Wenn Sie die Maus über das Grafik-Icon bewegen, öffnet sich eine Preisvergleichs-Grafik. Diese zeigt einen Überblick vergleichbarer Fahrzeuge (inkl. Ihres Fahrzeugs) und deren Preisdifferenz zum SCHWACKE Tagespreis. Jedes Fahrzeug wird anhand einer farbigen Raute dargestellt. Mit Klick auf die Raute öffnet sich die jeweilige Fahrzeuganzeige.",
		list: {
			first: "Grün: Eindeutig",
			second: "Blau: Sehr hoch",
			third: "Gelb: Hoch",
			fourth: "Grau: Aktuelles Fahrzeug"
		}
	}
};
var filters$d = {
	mileage: "Laufleistung:",
	year: "EZ (Jahr):",
	keywords: "Stichwörter:",
	engineSize: "Hubraum (ccm):",
	fuel: "Kraftstoff:",
	body: "Karosserie:",
	transmission: "Getriebe:",
	drive: "Antrieb:",
	power: "Leistung (kW):",
	distance: "Umkreis:",
	seller: "Verkäufer:",
	dealerSeller: "Händler",
	privateSeller: "Privat",
	vehicles: "Fahrzeuge:",
	onSaleVehicles: "Angeboten",
	soldVehicles: "Verkauft (60 Tage)",
	showFilters: "Filter anzeigen",
	hideFilters: "Filter ausblenden",
	buttonSearch: "Suche",
	nullValid: "Alle",
	wholeCountry: "Ganz Österreich",
	filtersTooltip: {
		content: "Über die Filter der Angebotstabelle können die angezeigten Fahrzeuge eingeschränkt werden.",
		list: {
			first: "Laufleistung",
			second: "Erstzulassungsdatum",
			third: "Kraftstoffart",
			fourth: "Getriebeart",
			fifth: "Motorleistung",
			sixth: "Ausführung (z. B. Zetec, TDi Sport, S Line)",
			seventh: "Hubraum (CCM)",
			eighth: "Aufbauart",
			ninth: "Antriebsart",
			tenth: "Umkreis (km)"
		}
	}
};
var matches$d = {
	exact: "EINDEUTIG",
	best: "SEHR HOCH",
	close: "HOCH",
	similar: "MITTEL",
	matchesTooltip: {
		content: "Diese Icons geben an, wie sehr das aktuelle Fahrzeug mit dem jeweiligen in den Börsen angebotenen Fahrzeug übereinstimmt. Die gleichen Farben werden auch in der Preisvergleichs-Grafik verwendet. Die Fahrzeuge in der Tabelle können mit Klick auf die jeweilige Spalte nach deren Inhalt sortiert werden."
	}
};
var results$d = {
	ownVehicle: "Eigenes Fahrzeug",
	adLinks: "Anzeige",
	vehicle: "Fahrzeug",
	askPrice: "Angebotspreis",
	diffPrice: "VS",
	lrPrice: "Angebotskurs",
	similarity: "ÜBEREIN-STIMMUNG",
	distance: "Umkreis",
	odometer: "KM",
	regDate: "EZL",
	company: "Anbieter",
	stockDays: "Dauer Tage",
	priceChanges: "PREISÄNDERUNGEN",
	tooltips: {
		vhDescription: {
			header: "Vollständige Beschreibung",
			make: "Marke",
			modelSeries: "Modellreihe",
			type: "Typ",
			body: "Aufbauart",
			doors: "Türen",
			seats: "Sitzplätze",
			fuel: "Kraftstoff",
			powerKW: "kW",
			powerHP: "PS",
			cylCubic: "Hubraum",
			cylinders: "Zylinder",
			gearBox: "Getriebeart",
			noOfGears: "Gänge",
			drive: "Antriebsart",
			engineType: "Motorart",
			wheelBase: "Radstand",
			totalWeight: "Gesamtgewicht",
			payload: "Nutzlast",
			importBegin: "Importbeginn",
			importEnd: "Importende",
			vhType: "Fahrzeugart",
			nationalCode: "SchwackeCode"
		},
		priceDiff: {
			header: "EurotaxAngebotskurs im Detail:",
			standardVh: "Basis Angebotspreis lt. aktuellen Angeboten",
			standardVhOdometer: "ø Laufleistung",
			standardVhRegDate: "ø  EZL",
			thisVh: "Gewähltes Fahrzeug",
			odometerEffect: "Kilometerkorrektur",
			ageEffect: "Monatskorrektur(Alter)",
			regionalEffect: "Regionale Korrektur",
			options: "Sonderausstattung:",
			equipmentAverage: "Durchschn. Ausstattungswert - detaillierte Ausstattung nicht verfügbar",
			totalEffects: "Summe Korrekturen",
			regionalAskingPrice: "Eurotax Angebotskurs",
			regional: "Eurotax Angebotskurs",
			askingPrice: "Angebotspreis laut Börse",
			priceDifference: "Preisdifferenz",
			underpriced: "Abweichung (-)",
			overpriced: "Abweichung (+)",
			noOptions: "Keine Auswirkung auf den Preis",
			priceDiffPercentage: "Abweichung zum Angebotskurs (%)"
		},
		priceHistory: {
			header: "Historische Preisinformation",
			dateAdRemoved: "Letzter angebotstag",
			removed: "Angebot gelöscht",
			"new": "Neues Angebot",
			priceCh: "Preisänderung",
			original: "Original Angebot"
		}
	}
};
var config$q = {
	monthsTraslation: "Monate"
};
var errorCode$d = {
	wrongAskingOrMileage: "Der Angebotspreis und/oder der Kilometerstand werden benötigt und dürfen nicht 0 sein, damit der Schwacke Tagespreis ermittelt werden kann. Sollten weitere Probleme auftreten, dann wenden Sie sich bitte an unsere Hotline.",
	onlyOwnVh: "Mit den von Ihnen gewählten Filteroptionen können keine vergleichbaren Fahrzeuge gefunden werden. Bitte ändern Sie Ihre Filterkriterien, z.B. den Radius der Suche (Umkreis) und versuchen Sie es erneut."
};
var de_AT = {
	summary: summary$d,
	report: report$d,
	filters: filters$d,
	matches: matches$d,
	results: results$d,
	config: config$q,
	errorCode: errorCode$d
};

var summary$c = {
	lrPrice: "Live Retail Preis",
	avgStockDays: "STANDTAGE",
	desirability: "NACHFRAGE",
	avgMileage: "LAUFLEISTUNG",
	avgPriceChanges: "PREISÄNDERUNGEN",
	summaryTooltip: {
		header: "Live Retail Preis - Echtzeitbewertungen",
		content: "Diese Funktion vergleicht Ihren Angebotspreis mit vergleichbaren Fahrzeugen aus den Online-Börsen. Der Live Retail Preis zeigt auf einen Blick, welche Fahrzeuge zu hoch bzw. zu niedrig bepreist sind. Dabei werden die Fahrzeuge gemäß Ausstattung, Alter und Laufleistung gleichgestellt.",
		content2: "Hinweis: Obwohl versch. Fahrzeuge sehr ähnlich erscheinen können, sind sie niemals komplett gleich und dies führt zu Preisdifferenzen.",
		list: {
			first: "Standtage – Durchschnittliche Standtage aller vergleichbaren Fahrzeuge.",
			second: "Laufleistung – Durchschnittliche Laufleistung aller vergleichbaren Fahrzeuge.",
			third: "Nachfrage – Gibt an, wie stark ein Fahrzeug am Markt nachgefragt wird (Hoch – Gut – Durchschnittlich – Gering).",
			fourth: "Preisänderungen – Durchschnittliche Anzahl an Preisänderungen aller vergleichbaren Fahrzeuge."
		}
	}
};
var report$c = {
	graph: {
		liveRetailPrice: "Live Retail Preis",
		lrp: "Live Retail Preis",
		avg: "DURCHSCHN."
	},
	heading: {
		zip: "PLZ"
	},
	scatterTooltip: {
		header: "Live Retail Preis Preisvergleichs-Grafik",
		content: "Wenn Sie die Maus über das Grafik-Icon bewegen, öffnet sich eine Preisvergleichs-Grafik. Diese zeigt einen Überblick vergleichbarer Fahrzeuge (inkl. Ihres Fahrzeugs) und deren Preisdifferenz zum Live Retail Preis. Jedes Fahrzeug wird anhand einer farbigen Raute dargestellt. Mit Klick auf die Raute öffnet sich die jeweilige Fahrzeuganzeige.",
		list: {
			first: "Grün: Eindeutig",
			second: "Blau: Sehr hoch",
			third: "Gelb: Hoch",
			fourth: "Grau: Aktuelles Fahrzeug"
		}
	}
};
var filters$c = {
	mileage: "Laufleistung:",
	year: "Jahr",
	keywords: "Stichwörter:",
	engineSize: "Motorgrösse:",
	fuel: "Treibstoff:",
	body: "Karosserie:",
	transmission: "Getriebe:",
	drive: "Antrieb:",
	power: "Leistung (kW):",
	distance: "Umkreis:",
	seller: "Verkäufer:",
	dealerSeller: "Händler",
	privateSeller: "Privat",
	vehicles: "Fahrzeuge:",
	onSaleVehicles: "Zum Verkauf",
	soldVehicles: "Verkauft (60 Tage)",
	showFilters: "Filter anzeigen",
	hideFilters: "Filter ausblenden",
	buttonSearch: "Suche",
	nullValid: "Alle",
	wholeCountry: "Ganze Schweiz",
	filtersTooltip: {
		content: "Über die Filter der Angebotstabelle können die angezeigten Fahrzeuge eingeschränkt werden.",
		list: {
			first: "Laufleistung",
			second: "Erstzulassungsdatum",
			third: "Kraftstoffart",
			fourth: "Getriebeart",
			fifth: "Motorleistung",
			sixth: "Ausführung (z. B. Zetec, TDi Sport, S Line)",
			seventh: "Hubraum (CCM)",
			eighth: "Aufbauart",
			ninth: "Antriebsart",
			tenth: "Umkreis (km)"
		}
	}
};
var matches$c = {
	exact: "EINDEUTIGE",
	best: "SEHR HOHE",
	close: "HOHE",
	similar: "MITTLERE",
	matchesTooltip: {
		content: "Diese Icons geben an, wie sehr das aktuelle Fahrzeug mit dem jeweiligen in den Börsen angebotenen Fahrzeug übereinstimmt. Die gleichen Farben werden auch in der Preisvergleichs-Grafik verwendet. Die Fahrzeuge in der Tabelle können mit Klick auf die jeweilige Spalte nach deren Inhalt sortiert werden."
	}
};
var results$c = {
	ownVehicle: "Eigenes Fahrzeug",
	adLinks: "Fahrzeuganzeigen",
	vehicle: "Fahrzeug",
	askPrice: "Angebots-preis",
	diffPrice: "VS",
	lrPrice: "Live Retail Preis",
	similarity: "ÜBEREIN-STIMMUNG",
	distance: "Umkreis",
	odometer: "Km",
	regDate: "EZL",
	company: "Händler",
	stockDays: "Dauer Tage",
	priceChanges: "PREIS ÄNDERUNGEN",
	tooltips: {
		vhDescription: {
			header: "Vollständige Beschreibung",
			make: "Marke",
			modelSeries: "Modellreihe",
			type: "Typ",
			body: "Aufbauart",
			doors: "Türen",
			seats: "Plätze",
			fuel: "Treibstoff",
			powerKW: "kW",
			powerHP: "PS",
			cylCubic: "Hubraum",
			cylinders: "Zylinder",
			gearBox: "Getriebeart",
			noOfGears: "Gänge",
			drive: "Antriebsart",
			engineType: "Motorart",
			wheelBase: "Radstand",
			totalWeight: "Gesamtgewicht",
			payload: "Nutzlast",
			importBegin: "Importbeginn",
			importEnd: "Importende",
			vhType: "Fahrzeugart",
			nationalCode: "Eurotax Code"
		},
		priceDiff: {
			header: "Live Retail Preis im Detail:",
			standardVh: "Standard Fahrzeug",
			standardVhOdometer: "ø Laufleistung",
			standardVhRegDate: "ø Erstzulassung",
			thisVh: "Gewähltes Fahrzeug",
			odometerEffect: "Kilometerkorrektur",
			ageEffect: "Monatskorrektur(Alter)",
			regionalEffect: "Regionale Korrektur",
			options: "Sonderausstattung:",
			equipmentAverage: "Durchschn. Ausstattungswert - detaillierte Ausstattung nicht verfügbar",
			totalEffects: "Alle Korrekturen",
			regionalAskingPrice: "Live Retail Preis",
			regional: "Live Retail Preis",
			askingPrice: "Angebotspreis",
			priceDifference: "Preisdifferenz",
			underpriced: "Abweichung (-)",
			overpriced: "Abweichung (+)",
			noOptions: "Keine Auswirkung auf den Preis"
		},
		priceHistory: {
			header: "Historische Preisinformation",
			dateAdRemoved: "Letzter angebotstag",
			removed: "Angebot gelöscht",
			"new": "Neues Angebot",
			priceCh: "Preisänderung",
			original: "Original Angebot"
		},
		directImportFlag: {
			header: "Direkt Import",
			content: "Das Fahrzeug wurde direkt importiert"
		}
	}
};
var config$p = {
	monthsTraslation: "Monate"
};
var errorCode$c = {
	wrongAskingOrMileage: "Der Angebotspreis und/oder der Kilometerstand werden benötigt und dürfen nicht 0 sein, damit der Schwacke Tagespreis ermittelt werden kann. Sollten weitere Probleme auftreten, dann wenden Sie sich bitte an unsere Hotline.",
	onlyOwnVh: "Mit den von Ihnen gewählten Filteroptionen können keine vergleichbaren Fahrzeuge gefunden werden. Bitte ändern Sie Ihre Filterkriterien, z.B. den Radius der Suche (Umkreis) und versuchen Sie es erneut."
};
var de_CH = {
	summary: summary$c,
	report: report$c,
	filters: filters$c,
	matches: matches$c,
	results: results$c,
	config: config$p,
	errorCode: errorCode$c
};

var summary$b = {
	lrPrice: "SCHWACKE TAGESPREIS",
	avgStockDays: "STANDTAGE",
	desirability: "NACHFRAGE",
	avgMileage: "LAUFLEISTUNG",
	avgPriceChanges: "PREISÄNDERUNGEN",
	summaryTooltip: {
		header: "SCHWACKE Tagespreis - Echtzeitbewertungen",
		content: "Diese Funktion vergleicht Ihren Angebotspreis mit vergleichbaren Fahrzeugen aus den Online-Börsen. Der SCHWACKE Tagespreis zeigt auf einen Blick, welche Fahrzeuge zu hoch bzw. zu niedrig bepreist sind. Dabei werden die Fahrzeuge gemäß Ausstattung, Alter und Laufleistung gleichgestellt.",
		content2: "Hinweis: Obwohl versch. Fahrzeuge sehr ähnlich erscheinen können, sind sie niemals komplett gleich und dies führt zu Preisdifferenzen.",
		list: {
			first: "Standtage – Durchschnittliche Standtage aller vergleichbaren Fahrzeuge.",
			second: "Laufleistung – Durchschnittliche Laufleistung aller vergleichbaren Fahrzeuge.",
			third: "Nachfrage – Gibt an, wie stark ein Fahrzeug am Markt nachgefragt wird (Hoch – Gut – Durchschnittlich – Gering).",
			fourth: "Preisänderungen – Durchschnittliche Anzahl an Preisänderungen aller vergleichbaren Fahrzeuge."
		}
	}
};
var report$b = {
	graph: {
		liveRetailPrice: "SCHWACKE TAGESPREIS",
		lrp: "SCHWACKE TAGESPREIS",
		avg: "DURCHSCHN."
	},
	heading: {
		zip: "PLZ"
	},
	scatterTooltip: {
		header: "SCHWACKE Tagespreis Preisvergleichs-Grafik",
		content: "Wenn Sie die Maus über das Grafik-Icon bewegen, öffnet sich eine Preisvergleichs-Grafik. Diese zeigt einen Überblick vergleichbarer Fahrzeuge (inkl. Ihres Fahrzeugs) und deren Preisdifferenz zum SCHWACKE Tagespreis. Jedes Fahrzeug wird anhand einer farbigen Raute dargestellt. Mit Klick auf die Raute öffnet sich die jeweilige Fahrzeuganzeige.",
		list: {
			first: "Grün: Eindeutig",
			second: "Blau: Sehr hoch",
			third: "Gelb: Hoch",
			fourth: "Grau: Aktuelles Fahrzeug"
		}
	}
};
var filters$b = {
	mileage: "Laufleistung:",
	year: "EZ (Jahr):",
	keywords: "Stichwörter:",
	engineSize: "Hubraum (ccm):",
	fuel: "Kraftstoff:",
	body: "Karosserie:",
	transmission: "Getriebe:",
	drive: "Antrieb:",
	power: "Leistung (kW):",
	distance: "Umkreis:",
	seller: "Verkäufer:",
	dealerSeller: "Händler",
	privateSeller: "Privat",
	vehicles: "Fahrzeuge:",
	onSaleVehicles: "Angeboten",
	soldVehicles: "Verkauft (60 Tage)",
	showFilters: "Filter anzeigen",
	hideFilters: "Filter ausblenden",
	buttonSearch: "Suche",
	nullValid: "Alle",
	wholeCountry: "Ganz Deutschland",
	filtersTooltip: {
		content: "Über die Filter der Angebotstabelle können die angezeigten Fahrzeuge eingeschränkt werden.",
		list: {
			first: "Laufleistung",
			second: "Erstzulassungsdatum",
			third: "Kraftstoffart",
			fourth: "Getriebeart",
			fifth: "Motorleistung",
			sixth: "Ausführung (z. B. Zetec, TDi Sport, S Line)",
			seventh: "Hubraum (CCM)",
			eighth: "Aufbauart",
			ninth: "Antriebsart",
			tenth: "Umkreis (km)"
		}
	}
};
var matches$b = {
	exact: "EINDEUTIG",
	best: "SEHR HOCH",
	close: "HOCH",
	similar: "MITTEL",
	matchesTooltip: {
		content: "Diese Icons geben an, wie sehr das aktuelle Fahrzeug mit dem jeweiligen in den Börsen angebotenen Fahrzeug übereinstimmt. Die gleichen Farben werden auch in der Preisvergleichs-Grafik verwendet. Die Fahrzeuge in der Tabelle können mit Klick auf die jeweilige Spalte nach deren Inhalt sortiert werden."
	}
};
var results$b = {
	ownVehicle: "Eigenes Fahrzeug",
	adLinks: "Anzeige",
	vehicle: "Fahrzeug",
	askPrice: "Angebotspreis",
	diffPrice: "VS",
	lrPrice: "Schwacke Tagespreis",
	similarity: "ÜBEREIN-STIMMUNG",
	distance: "Umkreis",
	odometer: "KM",
	regDate: "EZ",
	company: "Anbieter",
	stockDays: "Dauer Tage",
	priceChanges: "PREISÄNDERUNGEN",
	tooltips: {
		vhDescription: {
			header: "Vollständige Beschreibung",
			make: "Marke",
			modelSeries: "Modellreihe",
			type: "Typ",
			body: "Aufbauart",
			doors: "Türen",
			seats: "Sitzplätze",
			fuel: "Kraftstoff",
			powerKW: "kW",
			powerHP: "PS",
			cylCubic: "Hubraum",
			cylinders: "Zylinder",
			gearBox: "Getriebeart",
			noOfGears: "Gänge",
			drive: "Antriebsart",
			engineType: "Motorart",
			wheelBase: "Radstand",
			totalWeight: "Gesamtgewicht",
			payload: "Nutzlast",
			importBegin: "Importbeginn",
			importEnd: "Importende",
			vhType: "Fahrzeugart",
			nationalCode: "SchwackeCode"
		},
		priceDiff: {
			header: "Schwacke Tagespreis im Detail:",
			standardVh: "Basis Angebotspreis lt. aktuellen Angeboten",
			standardVhOdometer: "ø Laufleistung",
			standardVhRegDate: "ø Erstzulassung",
			thisVh: "Gewähltes Fahrzeug",
			odometerEffect: "Kilometerkorrektur",
			ageEffect: "Monatskorrektur(Alter)",
			regionalEffect: "Regionale Korrektur",
			options: "Sonderausstattung:",
			equipmentAverage: "Durchschn. Ausstattungswert - detaillierte Ausstattung nicht verfügbar",
			totalEffects: "Summe Korrekturen",
			regionalAskingPrice: "Schwacke Tagespreis",
			regional: "Regionaler Angebotspreis",
			askingPrice: "Angebotspreis (Börsenangebot)",
			priceDifference: "Preisdifferenz",
			underpriced: "Abweichung (-)",
			overpriced: "Abweichung (+)",
			noOptions: "Keine Auswirkung auf den Preis"
		},
		priceHistory: {
			header: "Historische Preisinformation",
			dateAdRemoved: "Letzter angebotstag",
			removed: "Angebot gelöscht",
			"new": "Neues Angebot",
			priceCh: "Preisänderung",
			original: "Original Angebot"
		}
	}
};
var config$o = {
	monthsTraslation: "Monate"
};
var errorCode$b = {
	wrongAskingOrMileage: "Der Angebotspreis und/oder der Kilometerstand werden benötigt und dürfen nicht 0 sein, damit der Schwacke Tagespreis ermittelt werden kann. Sollten weitere Probleme auftreten, dann wenden Sie sich bitte an unsere Hotline.",
	onlyOwnVh: "Mit den von Ihnen gewählten Filteroptionen können keine vergleichbaren Fahrzeuge gefunden werden. Bitte ändern Sie Ihre Filterkriterien, z.B. den Radius der Suche (Umkreis) und versuchen Sie es erneut."
};
var de_DE = {
	summary: summary$b,
	report: report$b,
	filters: filters$b,
	matches: matches$b,
	results: results$b,
	config: config$o,
	errorCode: errorCode$b
};

var summary$a = {
	lrPrice: "Autovista Aluehinta",
	avgStockDays: "Avg. stock days",
	desirability: "desirablity",
	avgMileage: "Avg. mileage",
	avgPriceChanges: "Avg. price changes",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$a = {
	graph: {
		liveRetailPrice: "Autovista Aluehinta",
		lrp: "Autovista Aluehinta",
		avg: "AVG."
	},
	heading: {
		zip: "ZIP"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$a = {
	mileage: "Ajomäärä",
	year: "Rekisteröinti-\nvuosi",
	keywords: "Hakusana(t)",
	engineSize: "Moottorin tilavuus",
	fuel: "Polttoaine",
	body: "Korimalli",
	transmission: "Vaihteisto",
	drive: "Vetotapa",
	power: "Teho",
	distance: "Etäisyys",
	seller: "Myyjä",
	dealerSeller: "Autoliike",
	privateSeller: "Yksityinen",
	vehicles: "Autot",
	onSaleVehicles: "Myynnissä",
	soldVehicles: "Myyty (2kk)",
	showFilters: "Näytä hakuvalikot",
	hideFilters: "Piilota hakuvalikot",
	buttonSearch: "Hae autot",
	nullValid: "Kaikki",
	wholeCountry: "Koko maa",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$a = {
	exact: "Exact",
	best: "Best",
	close: "Close",
	similar: "Similar",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$a = {
	ownVehicle: "Oma auto",
	adLinks: "Ad Link",
	vehicle: "Auton tiedot",
	askPrice: "Pyyntihinta",
	diffPrice: "Erotus",
	lrPrice: "Autovista Aluehinta",
	similarity: "Similarity",
	distance: "Etäisyys",
	odometer: "Km",
	regDate: "Rek.pvm",
	company: "Myyjä",
	stockDays: "Päiviä varastossa",
	priceChanges: "Hintamuutoshistoria",
	tooltips: {
		vhDescription: {
			header: "Täydellinen kuvaus",
			make: "Merkki",
			modelSeries: "Mallisarja",
			type: "Tyyppi",
			body: "Korimalli",
			doors: "Ovet",
			seats: "Matkustajat",
			fuel: "Polttoaine",
			powerKW: "Teho kW",
			powerHP: "Teho hv",
			cylCubic: "Sylinteritilavuus",
			cylinders: "Sylinterien määrä",
			gearBox: "Vaihteisto",
			noOfGears: "Vaihteiden määrä",
			drive: "Vetotapa",
			engineType: "Moottorityyppi",
			wheelBase: "Akselien etäisyys",
			totalWeight: "Kokonaispaino",
			payload: "Hyötykuorma",
			importBegin: "Maahantuonnin alkamispvm",
			importEnd: "Maahantuonnin päättymispvm",
			vhType: "Ajoneuvotyyppi",
			nationalCode: "Tyyppikoodi"
		},
		priceDiff: {
			header: "Autovista Aluehinnassa huomioitu",
			standardVh: "Autotyypin perusauto",
			standardVhOdometer: "Keskim. km",
			standardVhRegDate: "Keskim. ikä",
			thisVh: "Tämä auto",
			odometerEffect: "Km-korjaus",
			ageEffect: "Ikäkorjaus",
			regionalEffect: "Aluekorjaus",
			options: "Varusteet:",
			equipmentAverage: "Varusteet ei tiedossa - keskimääräinen varustearvo",
			totalEffects: "Hintakorjaukset yht",
			regionalAskingPrice: "Aluehinta",
			regional: "Aluehinta",
			askingPrice: "Pyyntihinta",
			priceDifference: "Hintojen ero",
			underpriced: "Alihinta",
			overpriced: "Ylihinta",
			noOptions: "Ei hintavaikutusta "
		},
		priceHistory: {
			header: "Hintamuutoshistoria",
			dateAdRemoved: "Viimeinen ilmoituspäivä",
			removed: "Ilmoitus poistettu",
			"new": "Uusi ilmoitus",
			priceCh: "Hintamuutos",
			original: "Uusi ilmoitus"
		}
	}
};
var config$n = {
	monthsTraslation: "Kuukaudet"
};
var errorCode$a = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var fi_FI = {
	summary: summary$a,
	report: report$a,
	filters: filters$a,
	matches: matches$a,
	results: results$a,
	config: config$n,
	errorCode: errorCode$a
};

var summary$9 = {
	lrPrice: "VALEUR REGIONALE",
	avgStockDays: "JOURS DE PUBLICATION",
	desirability: "desirablity",
	avgMileage: "KILOMETRAGE",
	avgPriceChanges: "NOMBRE DE CHANGEMENT DE PRIX",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$9 = {
	graph: {
		liveRetailPrice: "VALEUR REGIONALE",
		lrp: "Base sur l'échantillon présent",
		avg: "MOY."
	},
	heading: {
		zip: "CODE POSTAL"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$9 = {
	mileage: "Kilométrage",
	year: "Année",
	keywords: "Mots-clés",
	engineSize: "Taille de moteur",
	fuel: "Carburant",
	body: "Carrosserie",
	transmission: "Boîte de vitesses",
	drive: "Mode de transmission",
	power: "Puissance",
	distance: "Rayon",
	seller: "Vendeur",
	dealerSeller: "Concessionnaire",
	privateSeller: "Privé",
	vehicles: "Véhicules",
	onSaleVehicles: "en vente",
	soldVehicles: "Vendu (60 jours)",
	showFilters: "Show filtering options",
	hideFilters: "Hide filtering options",
	buttonSearch: "Recherche",
	nullValid: "Tous",
	wholeCountry: "National",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$9 = {
	exact: "IDENTIQUE",
	best: "TRÈS FORTE",
	close: "FORTE",
	similar: "SIMILAIRE",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$9 = {
	ownVehicle: "Own vehicle",
	adLinks: "Publicité",
	vehicle: "véhicule",
	askPrice: "Prix demandé",
	diffPrice: "VS",
	lrPrice: "Valeur Régionale",
	similarity: "Similarité",
	distance: "Distance",
	odometer: "Km",
	regDate: "Première<br>mise en<br>circulation",
	company: "Société",
	stockDays: "Jours de publication",
	priceChanges: "CHANGEMENTS DE PRIX",
	tooltips: {
		vhDescription: {
			header: "Description complète",
			make: "Marque",
			modelSeries: "Modèle",
			type: "Type",
			body: "Carrosserie",
			doors: "Portes",
			seats: "Sièges",
			fuel: "Carburant",
			powerKW: "kW",
			powerHP: "PS",
			cylCubic: "Cylindrée",
			cylinders: "Cylinders",
			gearBox: "Boîte de vitesse",
			noOfGears: "Vitesses",
			drive: "Mode de transmission",
			engineType: "Type de moteur",
			wheelBase: "Empattement",
			totalWeight: "Poids total",
			payload: "Charge utile",
			importBegin: "Début de production",
			importEnd: "Fin de production",
			vhType: "Type de véhicule",
			nationalCode: "Code Eurotax"
		},
		priceDiff: {
			header: "Valeur régionale détaillée",
			standardVh: "Véhicule standard",
			standardVhOdometer: "Kilométrage moyen",
			standardVhRegDate: "Date Pivot",
			thisVh: "Ce véhicule",
			odometerEffect: "Ajustement kilométrique",
			ageEffect: "Ajustement mensuelle",
			regionalEffect: "Ajustement régional",
			options: "Equipements:",
			equipmentAverage: "Détail des options indisponible - Valeur moyenne affichée",
			totalEffects: "Correction totale",
			regionalAskingPrice: "Valeur régionale",
			regional: "Valeur régionale",
			askingPrice: "Prix publié",
			priceDifference: "Différence de prix",
			underpriced: "Prix sous-estimé",
			overpriced: "Prix surestimé",
			noOptions: "Aucun effet sur le prix"
		},
		priceHistory: {
			header: "Historique des changements de prix",
			dateAdRemoved: "Date de la dernière publication",
			removed: "Annonce supprimée",
			"new": "Nouvelle parution",
			priceCh: "Changement de prix",
			original: "Original advert"
		}
	}
};
var config$m = {
	monthsTraslation: "Mois"
};
var errorCode$9 = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var fr_BE = {
	summary: summary$9,
	report: report$9,
	filters: filters$9,
	matches: matches$9,
	results: results$9,
	config: config$m,
	errorCode: errorCode$9
};

var summary$8 = {
	lrPrice: "VALEUR REGIONALE",
	avgStockDays: "JOURS DE PUBLICATION",
	desirability: "désirabilité",
	avgMileage: "KILOMETRAGE",
	avgPriceChanges: "NOMBRE DE CHANGEMENT DE PRIX",
	summaryTooltip: {
		header: "Live Retail - évaluations en temps réel",
		content: "Cette fonction compare le prix demandé que vous avez défini au prix EurotaxLiveRetail pour des véhicules similaires en vente aujourd'hui sur le marché. LiveRetail est un guide qui indique les véhicules sur-évalués ou sous-évalués, en tenant compte de caractéristiques telles que l'âge exact et le kilométrage, afin d'évaluer chaque véhicule individuellement.",
		content2: "Note : Bien que les véhicules puissent être très similaires, ils ne sont jamais totalement identiques, ce qui entraîne des différences de prix.",
		list: {
			first: "Jours de stock - Nombre moyen de jours pendant lesquels le véhicule a été en stock.",
			second: "Kilométrage - Nombre moyen de kilomètres accumulés.",
			third: "Désirabilité - Le véhicule le plus souhaitable pour générer des marges et des bénéfices. Excellent - Bon - Moyen - Médiocre.",
			fourth: "Changements de prix - Le nombre moyen de changements de prix pour ce véhicule."
		}
	}
};
var report$8 = {
	graph: {
		liveRetailPrice: "VALEUR REGIONALE",
		lrp: "Base sur l'échantillon présent",
		avg: "MOY."
	},
	heading: {
		zip: "CODE POSTAL"
	},
	scatterTooltip: {
		header: "Comparaison visuelle des prix de vente",
		content: "Le passage du curseur de la souris sur l'icône du graphique permet d'ouvrir une comparaison visuelle des prix. Cela donne un aperçu des véhicules annoncés et de leur différence de prix par rapport à Eurotax Live Retail. Chaque point de couleur dans le graphique représente un véhicule et avec un clic, l'annonce du véhicule s'affiche.",
		list: {
			first: "Vert: exacte",
			second: "Bleu: très proche",
			third: "Jaune: forte concordance",
			fourth: "Noir: ce véhicule"
		}
	}
};
var filters$8 = {
	mileage: "Kilométrage",
	year: "Année",
	keywords: "Mots-clés",
	engineSize: "Taille de moteur",
	fuel: "Carburant",
	body: "Carrosserie",
	transmission: "Boîte de vitesses",
	drive: "Mode de transmission",
	power: "Puissance",
	distance: "Rayon",
	seller: "Vendeur",
	dealerSeller: "Concessionnaire",
	privateSeller: "Privé",
	vehicles: "Véhicules",
	onSaleVehicles: "en vente",
	soldVehicles: "Vendu (60 jours)",
	showFilters: "Afficher les options de filtrage",
	hideFilters: "Cacher les options de filtrage",
	buttonSearch: "Recherche",
	nullValid: "Tous",
	wholeCountry: "Toute la Suisse",
	filtersTooltip: {
		content: "La fonctionnalité de recherche de LiveRetail permet aux utilisateurs de filtrer les résultats affichés comme suit.",
		list: {
			first: "Kilométrage",
			second: "Date d'enregistrement",
			third: "Type de carburant",
			fourth: "Boute de vitesse",
			fifth: "Puissance du moteur",
			sixth: "Mots clés (par exemple Zetec, TDi Sport, S Line)",
			seventh: "Cylindrée du moteur (CCM)",
			eighth: "Type de carrosserie",
			ninth: "Type de transmission",
			tenth: "Distance du concessionnaire"
		}
	}
};
var matches$8 = {
	exact: "IDENTIQUE",
	best: "TRÈS FORTE",
	close: "FORTE",
	similar: "SIMILAIRE",
	matchesTooltip: {
		content: "Ces icônes indiquent dans quelle mesure chaque véhicule figurant dans la liste ci-dessous correspond à votre véhicule. Les icônes de la même couleur sont également utilisées dans la comparaison visuelle du graphique en nuage de points. Les véhicules de la liste peuvent être classés en cliquant sur chaque en-tête de colonne."
	}
};
var results$8 = {
	ownVehicle: "Propre\nvéhicule",
	adLinks: "Publicité",
	vehicle: "véhicule",
	askPrice: "Prix d'offre",
	diffPrice: "VS",
	lrPrice: "EurotaxLiveRetail",
	similarity: "similaire",
	distance: "Distance",
	odometer: "Km",
	regDate: "DPMC",
	company: "Revendeur",
	stockDays: "Durée<br>jours",
	priceChanges: "CHANGEMENTS DE PRIX",
	tooltips: {
		vhDescription: {
			header: "Descriptif complet",
			make: "Marque",
			modelSeries: "Modèle",
			type: "Type",
			body: "Carrosserie",
			doors: "Portes",
			seats: "Sièges",
			fuel: "Carburant",
			powerKW: "kW",
			powerHP: "PS",
			cylCubic: "Cylindrée",
			cylinders: "Cylinders",
			gearBox: "Boîte de vitesse",
			noOfGears: "Vitesses",
			drive: "Mode de transmission",
			engineType: "Type de moteur",
			wheelBase: "Empattement",
			totalWeight: "Poids total",
			payload: "Charge utile",
			importBegin: "Début de production",
			importEnd: "Fin de production",
			vhType: "Type de véhicule",
			nationalCode: "Code Eurotax"
		},
		priceDiff: {
			header: "EurotaxSpotPrice en détail",
			standardVh: "Véhicule standard",
			standardVhOdometer: "ø kilométrique",
			standardVhRegDate: "ø première mise en circulation",
			thisVh: "Véhicule sélectionné",
			odometerEffect: "Correction kilométrique",
			ageEffect: "Correction mensuelle (âge)",
			regionalEffect: "Correction régionale",
			options: "Equipements spéciaux:",
			equipmentAverage: "Valeur moyenne des options - options specifiques ne pas disponibles",
			totalEffects: "Toutes les corrections",
			regionalAskingPrice: "Prix régional d'offre",
			regional: "LiveRetailPrice",
			askingPrice: "Prix d'offre",
			priceDifference: "Différence de prix",
			underpriced: "Ecart -",
			overpriced: "Ecart +",
			noOptions: "Pas d'effet sur le prix"
		},
		priceHistory: {
			header: "Historique de l'information de prix",
			dateAdRemoved: "Dernier Jour D'OFFRE",
			removed: "Offre supprimée",
			"new": "Nouvelle parution",
			priceCh: "Changement de prix",
			original: "Offre d'origine"
		},
		directImportFlag: {
			header: "Importation directe",
			content: "Le véhicule a été importé directement"
		}
	}
};
var config$l = {
	monthsTraslation: "Mois"
};
var errorCode$8 = {
	wrongAskingOrMileage: "Le prix demandé et/ou le kilométrage sont obligatoires et ne peuvent pas être 0 pour que la fonctionnalité LiveRetail fonctionne. Veuillez les modifier. Si vous rencontrez d'autres problèmes, veuillez contacter notre équipe d'assistance à la clientèle.",
	onlyOwnVh: "Il n'y a pas de véhicules similaires selon les options de filtrage que vous avez choisies. Veuillez modifier vos critères de filtrage, par exemple le rayon de la recherche en utilisant le filtre de distance, et réessayez."
};
var fr_CH = {
	summary: summary$8,
	report: report$8,
	filters: filters$8,
	matches: matches$8,
	results: results$8,
	config: config$l,
	errorCode: errorCode$8
};

var summary$7 = {
	lrPrice: "VALEUR REGIONALE",
	avgStockDays: "JOURS DE PUBLICATION",
	desirability: "desirablity",
	avgMileage: "KILOMETRAGE",
	avgPriceChanges: "NOMBRE DE CHANGEMENT DE PRIX",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$7 = {
	graph: {
		liveRetailPrice: "VALEUR REGIONALE",
		lrp: "Base sur l'échantillon présent",
		avg: "MOY."
	},
	heading: {
		zip: "CODE POSTAL"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$7 = {
	mileage: "Kilométrage",
	year: "Année",
	keywords: "Mots-clés",
	engineSize: "Taille de moteur",
	fuel: "Carburant",
	body: "Carrosserie",
	transmission: "Boîte de vitesses",
	drive: "Mode de transmission",
	power: "Puissance",
	distance: "Rayon",
	seller: "Vendeur",
	dealerSeller: "Concessionnaire",
	privateSeller: "Privé",
	vehicles: "Véhicules",
	onSaleVehicles: "en vente",
	soldVehicles: "Vendu (60 jours)",
	showFilters: "Show filtering options",
	hideFilters: "Hide filtering options",
	buttonSearch: "Recherche",
	nullValid: "Tous",
	wholeCountry: "National",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$7 = {
	exact: "IDENTIQUE",
	best: "TRÈS FORTE",
	close: "FORTE",
	similar: "SIMILAIRE",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$7 = {
	ownVehicle: "Own vehicle",
	adLinks: "Publicité",
	vehicle: "Vehicle",
	askPrice: "Prix demandé",
	diffPrice: "VS",
	lrPrice: "Valeur Régionale",
	similarity: "Similarité",
	distance: "Distance",
	odometer: "Km",
	regDate: "Première mise en circulation",
	company: "Société",
	stockDays: "Jours de publication",
	priceChanges: "CHANGEMENTS DE PRIX",
	tooltips: {
		vhDescription: {
			header: "Description complète",
			make: "Marque",
			modelSeries: "Modèle",
			type: "Type",
			body: "Carrosserie",
			doors: "Portes",
			seats: "Sièges",
			fuel: "Carburant",
			powerKW: "kW",
			powerHP: "PS",
			cylCubic: "Cylindrée",
			cylinders: "Cylinders",
			gearBox: "Boîte de vitesse",
			noOfGears: "Vitesses",
			drive: "Mode de transmission",
			engineType: "Type de moteur",
			wheelBase: "Empattement",
			totalWeight: "Poids total",
			payload: "Charge utile",
			importBegin: "Début de production",
			importEnd: "Fin de production",
			vhType: "Type de véhicule",
			nationalCode: "Code Eurotax"
		},
		priceDiff: {
			header: "Valeur régionale détaillée",
			standardVh: "Véhicule standard",
			standardVhOdometer: "Kilométrage moyen",
			standardVhRegDate: "Date Pivot",
			thisVh: "Ce véhicule",
			odometerEffect: "Ajustement kilométrique",
			ageEffect: "Ajustement mensuelle",
			regionalEffect: "Ajustement régional",
			options: "Equipements:",
			equipmentAverage: "Valeur moyenne des options - options détaillées n / a",
			totalEffects: "Correction totale",
			regionalAskingPrice: "Valeur régionale",
			regional: "Valeur régionale",
			askingPrice: "Prix publié",
			priceDifference: "Différence de prix",
			underpriced: "Prix sous-estimé",
			overpriced: "Prix surestimé",
			noOptions: "Aucun effet sur le prix"
		},
		priceHistory: {
			header: "Historique des changements de prix",
			dateAdRemoved: "Date de la dernière publication",
			removed: "Annonce supprimée",
			"new": "Nouvelle parution",
			priceCh: "Changement de prix",
			original: "Original advert"
		}
	}
};
var config$k = {
	monthsTraslation: "Mois"
};
var errorCode$7 = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var fr_FR = {
	summary: summary$7,
	report: report$7,
	filters: filters$7,
	matches: matches$7,
	results: results$7,
	config: config$k,
	errorCode: errorCode$7
};

var summary$6 = {
	lrPrice: "Live Retail Prezzo",
	avgStockDays: "GIORNI DI PERMANENZA",
	desirability: "RICHIESTA",
	avgMileage: "PRESTAZIONI DI CORSA",
	avgPriceChanges: "VARIAZIONI DI PREZZO",
	summaryTooltip: {
		header: "Live Retail Prezzo - Valutazioni in tempo reale",
		content: "Questa funzione confronta il prezzo della tua offerta con quello di veicoli comparabili presenti nelle borse online. Il prezzo al dettaglio in tempo reale mostra a colpo d'occhio quali veicoli hanno un prezzo troppo alto o troppo basso. I veicoli vengono confrontati in base all'equipaggiamento, all'età e al chilometraggio.",
		content2: "Nota: sebbene veicoli diversi possano sembrare molto simili. I veicoli possono apparire molto simili, ma non sono mai del tutto identici e questo comporta delle differenze di prezzo.",
		list: {
			first: "Giorni di servizio - Giorni medi di servizio di tutti i veicoli comparabili.",
			second: "Chilometraggio - Chilometraggio medio di tutti i veicoli comparabili.",
			third: "Domanda - Indica il livello di domanda di un veicolo sul mercato (Alta - Buona - Media - Bassa).",
			fourth: "Variazioni di prezzo - Numero medio di variazioni di prezzo di tutti i veicoli comparabili."
		}
	}
};
var report$6 = {
	graph: {
		liveRetailPrice: "Live Retail Prezzo",
		lrp: "Live Retail Prezzo",
		avg: "INTERFACCIA."
	},
	heading: {
		zip: "CAP"
	},
	scatterTooltip: {
		header: "Live Retail Prezzo Grafico di confronto in tempo reale",
		content: "Se passi il mouse sull'icona del grafico, si apre un grafico di confronto dei prezzi. Questo mostra una panoramica dei veicoli comparabili (incluso il tuo) e la loro differenza di prezzo rispetto al prezzo di vendita al pubblico. Ogni veicolo è rappresentato da un diamante colorato. Cliccando sul diamante si apre la visualizzazione del veicolo corrispondente.",
		list: {
			first: "Verde: inequivocabile",
			second: "Blu: Molto alto",
			third: "Giallo: Alto",
			fourth: "Grigio: veicolo attuale"
		}
	}
};
var filters$6 = {
	mileage: "Chilometraggio:",
	year: "Anno",
	keywords: "Parole chiave:",
	engineSize: "Dimensioni del motore:",
	fuel: "Carburante:",
	body: "Carrozzeria:",
	transmission: "Cambio:",
	drive: "Guida:",
	power: "Potenza (kW):",
	distance: "Perimetro:",
	seller: "Venditore:",
	dealerSeller: "Rivenditore",
	privateSeller: "Privato",
	vehicles: "Veicoli:",
	onSaleVehicles: "In vendita",
	soldVehicles: "Venduto (60 giorni)",
	showFilters: "Mostra filtro",
	hideFilters: "Nascondi il filtro",
	buttonSearch: "Ricerca",
	nullValid: "Tutti",
	wholeCountry: "Tutta la Svizzera",
	filtersTooltip: {
		content: "I veicoli visualizzati possono essere limitati utilizzando i filtri della tabella delle offerte.",
		list: {
			first: "Chilometraggio",
			second: "Data della prima registrazione",
			third: "Tipo di carburante",
			fourth: "Tipo di cambio",
			fifth: "Potenza del motore",
			sixth: "Versione (ad es. Zetec, TDi Sport, S Line)",
			seventh: "Capacità cubica (CCM)",
			eighth: "Tipo di corpo",
			ninth: "Tipo di unità",
			tenth: "Perimetro (km)"
		}
	}
};
var matches$6 = {
	exact: "UNICO",
	best: "MOLTO ALTO",
	close: "ALTO",
	similar: "MEDIO",
	matchesTooltip: {
		content: "Queste icone indicano la corrispondenza tra il veicolo attuale e il rispettivo veicolo offerto in borsa. Gli stessi colori sono utilizzati anche nella tabella di confronto dei prezzi. I veicoli della tabella possono essere ordinati in base al loro contenuto cliccando sulla rispettiva colonna."
	}
};
var results$6 = {
	ownVehicle: "Veicolo proprio",
	adLinks: "Annunci di veicoli",
	vehicle: "Veicolo",
	askPrice: "Prezzo dell'offerta",
	diffPrice: "VS",
	lrPrice: "Live Retail Prezzo",
	similarity: "CONSENSO",
	distance: "Perimetro",
	odometer: "Km",
	regDate: "EZL",
	company: "Rivenditore",
	stockDays: "Durata Giorni",
	priceChanges: "VARIAZIONI DI PREZZO",
	tooltips: {
		vhDescription: {
			header: "Descrizione completa",
			make: "Marchio",
			modelSeries: "Gamma di modelli",
			type: "Tipo",
			body: "Tipo di corpo",
			doors: "Porte",
			seats: "Luoghi",
			fuel: "Carburante",
			powerKW: "kW",
			powerHP: "PS",
			cylCubic: "Spostamento",
			cylinders: "Cilindro",
			gearBox: "Tipo di cambio",
			noOfGears: "Ingranaggi",
			drive: "Tipo di unità",
			engineType: "Tipo di motore",
			wheelBase: "Passo",
			totalWeight: "Peso totale",
			payload: "Carico utile",
			importBegin: "Inizio dell'importazione",
			importEnd: "Fine dell'importazione",
			vhType: "Tipo di veicolo",
			nationalCode: "Codice Eurotax"
		},
		priceDiff: {
			header: "Live Retail Prezzo in diretta:",
			standardVh: "Veicolo standard",
			standardVhOdometer: "ø Chilometraggio",
			standardVhRegDate: "ø Prima registrazione",
			thisVh: "Veicolo selezionato",
			odometerEffect: "Correzione dei chilometri",
			ageEffect: "Correzione mensile (età)",
			regionalEffect: "Correzione regionale",
			options: "Equipaggiamento speciale:",
			equipmentAverage: "Valore medio dell'attrezzatura - attrezzatura dettagliata non disponibile",
			totalEffects: "Tutte le correzioni",
			regionalAskingPrice: "Live Retail Prezzo",
			regional: "Live Retail Prezzo",
			askingPrice: "Prezzo dell'offerta",
			priceDifference: "Differenza di prezzo",
			underpriced: "Deviazione (-)",
			overpriced: "Deviazione (+)",
			noOptions: "Nessun effetto sul prezzo"
		},
		priceHistory: {
			header: "Informazioni sui prezzi storici",
			dateAdRemoved: "Ultimo giorno di offerta",
			removed: "Offerta annullata",
			"new": "Nuova offerta",
			priceCh: "Variazione di prezzo",
			original: "Offerta originale"
		},
		directImportFlag: {
			header: "Importazione diretta",
			content: "Il veicolo è stato importato direttamente"
		}
	}
};
var config$j = {
	monthsTraslation: "Mesi"
};
var errorCode$6 = {
	wrongAskingOrMileage: "Il prezzo dell'offerta e/o il chilometraggio sono obbligatori e non devono essere pari a 0 per poter determinare il prezzo giornaliero Schwacke. Se riscontri ulteriori problemi, contatta la nostra hotline.",
	onlyOwnVh: "Non sono stati trovati veicoli comparabili con le opzioni di filtro selezionate. Cambia i criteri di filtraggio, ad esempio il raggio di ricerca (radius) e riprova."
};
var it_CH = {
	summary: summary$6,
	report: report$6,
	filters: filters$6,
	matches: matches$6,
	results: results$6,
	config: config$j,
	errorCode: errorCode$6
};

var summary$5 = {
	lrPrice: "Autovista SpotPrice",
	avgStockDays: "stock days",
	desirability: "desirablity",
	avgMileage: "mileage",
	avgPriceChanges: "price changes",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$5 = {
	graph: {
		liveRetailPrice: "Autovista SpotPrice",
		lrp: "Autovista SpotPrice",
		avg: "AVG."
	},
	heading: {
		zip: "ZIP"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$5 = {
	mileage: "Chilometraggio",
	year: "Anno",
	keywords: "Parole chiave",
	engineSize: "Dimensioni motore",
	fuel: "Carburante",
	body: "Carrozzeria",
	transmission: "Trasmissione",
	drive: "Gruppo propulsore",
	power: "Prestazione",
	distance: "Raggio",
	seller: "Venditore:",
	dealerSeller: "Commerciante",
	privateSeller: "Privato",
	vehicles: "Veicoli:",
	onSaleVehicles: "in vendita",
	soldVehicles: "Venduto (60 giorni)",
	showFilters: "Visualizza filtri",
	hideFilters: "Nascondi filtri",
	buttonSearch: "Cerca",
	nullValid: "Tutti",
	wholeCountry: "Totale Italia",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$5 = {
	exact: "netta",
	best: "Molto elevata",
	close: "elevata",
	similar: "media",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$5 = {
	ownVehicle: "Veicolo proprio",
	adLinks: "Annunci veicoli",
	vehicle: "Vehicle",
	askPrice: "Prezzo di offerta",
	diffPrice: "VS",
	lrPrice: "Autovista SpotPrice",
	similarity: "Simile",
	distance: "Raggio",
	odometer: "km",
	regDate: "Prima imm.",
	company: "Concessionario",
	stockDays: "Durata giorni",
	priceChanges: "Storica del prezzo",
	tooltips: {
		vhDescription: {
			header: "Descrizione completa",
			make: "Marca",
			modelSeries: "Serie modello",
			type: "Tipo",
			body: "Forma",
			doors: "Porte",
			seats: "Posti",
			fuel: "Carburante",
			powerKW: "kW",
			powerHP: "CV",
			cylCubic: "Cilindrata",
			cylinders: "Cilindri",
			gearBox: "Cambio",
			noOfGears: "Marce",
			drive: "Trasmissione",
			engineType: "Tipo motore",
			wheelBase: "Passo",
			totalWeight: "Peso totale",
			payload: "Carico utile",
			importBegin: "Inizio importazione",
			importEnd: "Fine importazione",
			vhType: "Tipo veicolo",
			nationalCode: "Natcode"
		},
		priceDiff: {
			header: "Autovista SpotPrice in dettaglio",
			standardVh: "Veicolo standard",
			standardVhOdometer: "ø chilometraggio",
			standardVhRegDate: "ø prima immatricolazione",
			thisVh: "Veicolo scelto",
			odometerEffect: "Correzione chilometri",
			ageEffect: "Correzione mese (età)",
			regionalEffect: "Correzione regionale",
			options: "Dotazione speciale:",
			equipmentAverage: "Valore media dei accessori - accessori specifici non disponibile",
			totalEffects: "Tutte le correzioni",
			regionalAskingPrice: "Autovista SpotPrice",
			regional: "Autovista SpotPrice",
			askingPrice: "Prezzo di offerta",
			priceDifference: "Differenza prezzo",
			underpriced: "Sottoprezzo -",
			overpriced: "Sovrapprezzo +",
			noOptions: "Nessun effetto sul prezzo"
		},
		priceHistory: {
			header: "Informazione storica del prezzo",
			dateAdRemoved: "Ultimo giorno dell'offerta",
			removed: "Offerta cancellata",
			"new": "Nuova offerta",
			priceCh: "Modifica prezzo",
			original: "Offerta originale"
		}
	}
};
var config$i = {
	monthsTraslation: "Mesi"
};
var errorCode$5 = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var it_IT = {
	summary: summary$5,
	report: report$5,
	filters: filters$5,
	matches: matches$5,
	results: results$5,
	config: config$i,
	errorCode: errorCode$5
};

var summary$4 = {
	lrPrice: "Spotwaarde",
	avgStockDays: "GEADVERTEERDE DAGEN",
	desirability: "DESIRABILITY",
	avgMileage: "KILOMETERSTAND",
	avgPriceChanges: "AANTAL PRIJSWIJZIGINGEN",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$4 = {
	graph: {
		liveRetailPrice: "SPOTWAARDE",
		lrp: "Op basis van uw gefilterde lijst",
		avg: "GEM."
	},
	heading: {
		zip: "POSTCODE"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$4 = {
	mileage: "Kilometerstand",
	year: "Jaar",
	keywords: "Sleutelwoorden",
	engineSize: "Motorinhoud",
	fuel: "Brandstof",
	body: "Koetswerk",
	transmission: "Versnellingsbak",
	drive: "Type aandrijving",
	power: "Vermogen",
	distance: "Afstand",
	seller: "Verkoper",
	dealerSeller: "Dealer",
	privateSeller: "Privé",
	vehicles: "Voertuigen",
	onSaleVehicles: "In verkoop",
	soldVehicles: "Verkocht (60 dagen)",
	showFilters: "Toon filters",
	hideFilters: "Verberg filters",
	buttonSearch: "Zoeken",
	nullValid: "alle",
	wholeCountry: "Nationaal",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$4 = {
	exact: "Identiek",
	best: "Zeer sterk",
	close: "Sterk",
	similar: "GELIJKEND",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$4 = {
	ownVehicle: "Uw voertuig",
	adLinks: "Toon voertuig",
	vehicle: "voertuig",
	askPrice: "Vraagprijs",
	diffPrice: "VS",
	lrPrice: "Spotwaarde",
	similarity: "OVEREENKOMST",
	distance: "Afstand",
	odometer: "KM",
	regDate: "inschrijvings-datum",
	company: "Firma",
	stockDays: "Geadverteerde dagen",
	priceChanges: "PRIJSAANPASSING",
	tooltips: {
		vhDescription: {
			header: "Volledige beschrijving",
			make: "Make",
			modelSeries: "Model",
			type: "Type",
			body: "Koetswerk",
			doors: "Deuren",
			seats: "Zetels",
			fuel: "Brandstof",
			powerKW: "kW",
			powerHP: "PK",
			cylCubic: "Cilinderinhoud",
			cylinders: "Cilinders",
			gearBox: "Versnellingsbak",
			noOfGears: "Versnellingen",
			drive: "Type aandrijving",
			engineType: "Type motor",
			wheelBase: "Wielbasis",
			totalWeight: "Totaal gewicht",
			payload: "Payload",
			importBegin: "Begin productie",
			importEnd: "Eind productie",
			vhType: "Type voertuig",
			nationalCode: "Eurotax Code"
		},
		priceDiff: {
			header: "Gedetailleerde Spotwaarde",
			standardVh: "Standaardvoertuig",
			standardVhOdometer: "Gemiddelde kilometerstand",
			standardVhRegDate: "Gemiddelde inschrijvingsdatum",
			thisVh: "Dit voertuig",
			odometerEffect: "Kilometerstandcorrectie",
			ageEffect: "Leeftijdcorrectie",
			regionalEffect: "Regiocorrectie",
			options: "Uitrusting:",
			equipmentAverage: "Gedetailleerde opties niet beschikbaar - Gemiddelde waarde van de opties getoont",
			totalEffects: "Totale correctie",
			regionalAskingPrice: "Regionale waarde (dagwaarde)",
			regional: "Regionale waarde (dagwaarde)",
			askingPrice: "Gepubliceerde vraagprijs",
			priceDifference: "Prijsverschil",
			underpriced: "Ondergewaardeerd",
			overpriced: "Overgewaardeerd",
			noOptions: "Geen enkel effect op de waarde"
		},
		priceHistory: {
			header: "Prijshistoriek",
			dateAdRemoved: "Laatst geadverteerd op",
			removed: "Verwijderde advertentie",
			"new": "Nieuwe advertentie",
			priceCh: "Prijswijziging",
			original: "Originele advertentie"
		}
	}
};
var config$h = {
	monthsTraslation: "Maanden"
};
var errorCode$4 = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var nl_BE = {
	summary: summary$4,
	report: report$4,
	filters: filters$4,
	matches: matches$4,
	results: results$4,
	config: config$h,
	errorCode: errorCode$4
};

var summary$3 = {
	lrPrice: "Indeks Live Retail",
	avgStockDays: "ŚR. CZAS OGŁOSZENIA",
	desirability: "INDEKS POPYTU",
	avgMileage: "ŚR. PRZEBIEG",
	avgPriceChanges: "ŚR. ILOŚĆ ZMIAN CEN",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$3 = {
	graph: {
		liveRetailPrice: "INDEKS LIVE RETAIL",
		lrp: "ILR",
		avg: "ŚR. "
	},
	heading: {
		zip: "KOD POCZTOWY"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$3 = {
	mileage: "Przebieg",
	year: "Rok",
	keywords: "Słowa kluczowe",
	engineSize: "Poj. silnika",
	fuel: "Paliwo",
	body: "Nadwozie",
	transmission: "Skrzynia biegów",
	drive: "Rodzaj napędu",
	power: "Moc",
	distance: "Odległość",
	seller: "Sprzedający",
	dealerSeller: "Dealer",
	privateSeller: "Osoba prywatna",
	vehicles: "Pojazdy",
	onSaleVehicles: "W sprzedaży",
	soldVehicles: "Sprzedane (60 dni)",
	showFilters: "Pokaż filtry",
	hideFilters: "Ukryj filtry",
	buttonSearch: "Szukaj",
	nullValid: "Wszystko",
	wholeCountry: "Cały kraj",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$3 = {
	exact: "Dokładne dopasowanie",
	best: "Bardzo duże",
	close: "Duże",
	similar: "Średnie",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$3 = {
	ownVehicle: "Twój\npojazd",
	adLinks: "Ogłoszenie",
	vehicle: "Vehicle",
	askPrice: "Cena wywoławcza",
	diffPrice: "VS",
	lrPrice: "Indeks Eurotax",
	similarity: "DOPASOWANIE",
	distance: "Odległość",
	odometer: "Przebieg",
	regDate: "Data pierwszej rejestracji",
	company: "Firma",
	stockDays: "Czas ogłoszenia",
	priceChanges: "Historia zmiany cen",
	tooltips: {
		vhDescription: {
			header: "Pełny opis",
			make: "Marka",
			modelSeries: "Model",
			type: "Typ",
			body: "Nadwozie",
			doors: "Drzwi",
			seats: "Ilośc siedzeń",
			fuel: "Rodzaj paliwa",
			powerKW: "Moc silnika (kW)",
			powerHP: "Moc silnika (KM)",
			cylCubic: "Pojemność silnika",
			cylinders: "Cylindry",
			gearBox: "Rodzaj skrzyni biegów",
			noOfGears: "Ilośc biegów",
			drive: "Rodzaj napędu",
			engineType: "Rodzaj silnika",
			wheelBase: "Rozstaw osi",
			totalWeight: "Masa całkowita",
			payload: "Ładowność",
			importBegin: "Początek sprzedaży",
			importEnd: "Koniec sprzedaży",
			vhType: "Rodzaj pojazdu",
			nationalCode: "Kod EC"
		},
		priceDiff: {
			header: "Index Eurotax - szczegóły",
			standardVh: "Pojazd modelowy",
			standardVhOdometer: "Przebieg standardowy",
			standardVhRegDate: "Data pierwszej rejestracji",
			thisVh: "Wybrany pojazd",
			odometerEffect: "Korekta kilometrowa",
			ageEffect: "Korekta na datę rejestracji",
			regionalEffect: "Korekta regionalna",
			options: "Equipment:",
			equipmentAverage: "Avg options value - detailed options n/a",
			totalEffects: "Suma korekt",
			regionalAskingPrice: "Indeks Eurotax",
			regional: "Indeks Eurotax",
			askingPrice: "Cena wywoławcza",
			priceDifference: "RÃ³óżnica cen",
			underpriced: "Różnica do ceny wywoławczej (PLN)",
			overpriced: "Różnica do ceny wywoławczej (PLN)",
			noOptions: "No Effect in Price"
		},
		priceHistory: {
			header: "Historia",
			dateAdRemoved: "Ostatnia data ogłoszenia",
			removed: "Ogłoszenie usunięte",
			"new": "Nowe ogłoszenie",
			priceCh: "Zmiana ceny",
			original: "Oryginalne ogłoszenie"
		}
	}
};
var config$g = {
	monthsTraslation: "miesięcy"
};
var errorCode$3 = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var pl_PL = {
	summary: summary$3,
	report: report$3,
	filters: filters$3,
	matches: matches$3,
	results: results$3,
	config: config$g,
	errorCode: errorCode$3
};

var summary$2 = {
	lrPrice: "Live retail price",
	avgStockDays: "stock days",
	desirability: "desirablity",
	avgMileage: "mileage",
	avgPriceChanges: "price changes",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$2 = {
	graph: {
		liveRetailPrice: "LIVE RETAIL PRICE",
		lrp: "LRP",
		avg: "AVG."
	},
	heading: {
		zip: "ZIP"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$2 = {
	mileage: "Mileage",
	year: "Year",
	keywords: "Keyword(s)",
	engineSize: "Engine size",
	fuel: "Fuel",
	body: "Body",
	transmission: "Transmission",
	drive: "Drivetrain",
	power: "Power",
	distance: "Distance",
	seller: "Seller",
	dealerSeller: "Dealer",
	privateSeller: "Private",
	vehicles: "Vehicles",
	onSaleVehicles: "On sale",
	soldVehicles: "Sold (60 days)",
	showFilters: "Show filtering options",
	hideFilters: "Hide filtering options",
	buttonSearch: "Search",
	nullValid: "All",
	wholeCountry: "Whole Country",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$2 = {
	exact: "Veículo exacto",
	best: "Muito grande",
	close: "Grande",
	similar: "média",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$2 = {
	ownVehicle: "Veículo\nproprio",
	adLinks: "Anuncio",
	vehicle: "Vehículo",
	askPrice: "Asking Price",
	diffPrice: "VS",
	lrPrice: "Eurotax Spot Price",
	similarity: "Similaridade",
	distance: "Distancia",
	odometer: "km",
	regDate: "Data da matricula",
	company: "Empresa",
	stockDays: "Dias anunciado",
	priceChanges: "Histórico do preço",
	tooltips: {
		vhDescription: {
			header: "Descrição completa",
			make: "Marca",
			modelSeries: "Modelo",
			type: "Type",
			body: "Body type",
			doors: "Portas",
			seats: "Lugares",
			fuel: "Combustivel",
			powerKW: "KW",
			powerHP: "HP",
			cylCubic: "Cilindrada",
			cylinders: "Cilindros",
			gearBox: "Caixa",
			noOfGears: "Velocidades",
			drive: "Tracção",
			engineType: "Disposição",
			wheelBase: "Distancia entre eixos",
			totalWeight: "Peso total",
			payload: "Capacidade Carga",
			importBegin: "Inicio de importação",
			importEnd: "Fim de Importação",
			vhType: "Tipo veículos",
			nationalCode: "Tylacode"
		},
		priceDiff: {
			header: "Detalhe do Eurotax Spot Price",
			standardVh: "Veículo Standard",
			standardVhOdometer: "Quilometragem média",
			standardVhRegDate: "Data de matricula média",
			thisVh: "Veículo selecionado",
			odometerEffect: "Correcção quilometrica",
			ageEffect: "Correcção mensal",
			regionalEffect: "=Correcção regional",
			options: "Equipamento:",
			equipmentAverage: "Avg options value - detailed options n/a",
			totalEffects: "Total de correcções",
			regionalAskingPrice: "Eurotax Spot Price",
			regional: "Eurotax Spot Price",
			askingPrice: "Asking Price",
			priceDifference: "Diferença de preço",
			underpriced: "Subvalorizado",
			overpriced: "Sobrevalorizado",
			noOptions: "Sem efeito no preço"
		},
		priceHistory: {
			header: "Histórico de alteraçães do preço",
			dateAdRemoved: "Data do ultimo anuncio",
			removed: "Novo anuncio",
			"new": "Novo anuncio",
			priceCh: "Alteração de preço",
			original: "Anuncio original"
		}
	}
};
var config$f = {
	monthsTraslation: "Meses"
};
var errorCode$2 = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var pt_PT = {
	summary: summary$2,
	report: report$2,
	filters: filters$2,
	matches: matches$2,
	results: results$2,
	config: config$f,
	errorCode: errorCode$2
};

var summary$1 = {
	lrPrice: "Live retail price",
	avgStockDays: "stock days",
	desirability: "desirablity",
	avgMileage: "mileage",
	avgPriceChanges: "price changes",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report$1 = {
	graph: {
		liveRetailPrice: "LIVE RETAIL PRICE",
		lrp: "LRP",
		avg: "AVG."
	},
	heading: {
		zip: "ZIP"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters$1 = {
	mileage: "Antal kilometer",
	year: "År",
	keywords: "Sökord",
	engineSize: "Motorstorlek",
	fuel: "Bränsle",
	body: "Kaross",
	transmission: "Växellåda",
	drive: "Drivning",
	power: "kW",
	distance: "Avstånd",
	seller: "Säljare",
	dealerSeller: "Handlare",
	privateSeller: "Privatperson",
	vehicles: "Fordon",
	onSaleVehicles: "Aktiva annonser",
	soldVehicles: "Borttagna (60 dagar)",
	showFilters: "Visa filter",
	hideFilters: "Dölj filter",
	buttonSearch: "Sök",
	nullValid: "Alla",
	wholeCountry: "Hela landet",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches$1 = {
	exact: "Exakt träff",
	best: "Mycket",
	close: "Delvis",
	similar: "Delvis olik",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results$1 = {
	ownVehicle: "Den egna\nbilen",
	adLinks: "Annons",
	vehicle: "Fordon",
	askPrice: "Begärt pris",
	diffPrice: "VS",
	lrPrice: "Autovista Spotpris",
	similarity: "likvärdig",
	distance: "Avstånd",
	odometer: "Mil",
	regDate: "Reg.datum",
	company: "Handlare",
	stockDays: "Dagar på nätet",
	priceChanges: "Historik",
	tooltips: {
		vhDescription: {
			header: "UtfÖrlig beskrivning",
			make: "Märke",
			modelSeries: "Modellversion",
			type: "Typ",
			body: "Kaross",
			doors: "Dörrar",
			seats: "Antal säten",
			fuel: "Bränsle",
			powerKW: "Motorstyrka kW",
			powerHP: "Motorstyrka hk",
			cylCubic: "Motorstorlek",
			cylinders: "Antal cylindrar",
			gearBox: "Växellåda",
			noOfGears: "Antal växlar",
			drive: "Drivning",
			engineType: "Motortyp",
			wheelBase: "Hjulbas",
			totalWeight: "Totalvikt",
			payload: "Lastvikt",
			importBegin: "Säljsstart",
			importEnd: "Avslutad",
			vhType: "Fordonstyp",
			nationalCode: "Internkod Autovista"
		},
		priceDiff: {
			header: "Detaljöversikt av Autovista Spotpris",
			standardVh: "Biltypen i grundutförande",
			standardVhOdometer: "Mil i medeltal",
			standardVhRegDate: "Ålder i medeltal",
			thisVh: "Den här bilen",
			odometerEffect: "Miljustering",
			ageEffect: "Åldersjustering",
			regionalEffect: "Regional justering",
			options: "Fabrikstillbehör::",
			equipmentAverage: "Genomsnittligt värde av utrustning - detaljerad utrustning ej tillämpligt",
			totalEffects: "Prisjustering totalt",
			regionalAskingPrice: "Regionalpris",
			regional: "Autovista Spotpris (regionalt)",
			askingPrice: "Begärt pris",
			priceDifference: "Prisdifferens",
			underpriced: "Underpris",
			overpriced: "/u00D6verpris",
			noOptions: "ingen prispåverkan"
		},
		priceHistory: {
			header: "Historik på prisförändringar",
			dateAdRemoved: "Sista annonseringsdagen",
			removed: "Annons borttagen",
			"new": "Ny annons",
			priceCh: "Prisförändring",
			original: "Ursprunglig annons"
		}
	}
};
var config$e = {
	monthsTraslation: "månader"
};
var errorCode$1 = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var se_SE = {
	summary: summary$1,
	report: report$1,
	filters: filters$1,
	matches: matches$1,
	results: results$1,
	config: config$e,
	errorCode: errorCode$1
};

var summary = {
	lrPrice: "Live retail price",
	avgStockDays: "stock days",
	desirability: "desirablity",
	avgMileage: "mileage",
	avgPriceChanges: "price changes",
	summaryTooltip: {
		header: "Live Retail - real-time valuations",
		content: "This function compares the asking price you have set to Glass’s LIVE Retail prices for similar vehicles for sale today in the market. Live Retail is a guide to indicate over and underpriced vehicles, taking into account characteristics such as exact age and mileage to individually value each vehicle.",
		content2: "Note: Although vehicles can be very similar, they are never fully identical resulting in price differences.",
		list: {
			first: "Stock days - Average number of days the vehicle has been in stock.",
			second: "Mileage - Average number of miles accumulated.",
			third: "Desirability - The most desirable vehicle for generating margin and profit. Excellent - Good - Fair - Poor.",
			fourth: "Price changes – The average number of retail price changes for this vehicle."
		}
	}
};
var report = {
	graph: {
		liveRetailPrice: "LIVE RETAIL PRICE",
		lrp: "LRP",
		avg: "AVG."
	},
	heading: {
		zip: "POST CODE"
	},
	scatterTooltip: {
		header: "Visual retail price comparison",
		content: "Moving the mouse cursor over the graph icon opens a visual price comparison. This gives an overview of advertised vehicles and their price difference from Glass’s Live Retail. Each coloured dot in the graph represents one vehicle and can be clicked to show the actual vehicle advert.",
		list: {
			first: "Green: Exact match",
			second: "Blue: Very close match",
			third: "Yellow: Close match",
			fourth: "Black: This Vehicle"
		}
	}
};
var filters = {
	mileage: "Mileage",
	year: "Year",
	keywords: "Keyword(s)",
	engineSize: "Engine size",
	fuel: "Fuel",
	body: "Body",
	transmission: "Transmission",
	drive: "Drivetrain",
	power: "Power",
	distance: "Distance",
	seller: "Seller",
	dealerSeller: "Dealer",
	privateSeller: "Private",
	vehicles: "Vehicles",
	onSaleVehicles: "On sale",
	soldVehicles: "Sold (60 days)",
	showFilters: "Show filtering options",
	hideFilters: "Hide filtering options",
	buttonSearch: "Search",
	nullValid: "All",
	wholeCountry: "Whole Country",
	filtersTooltip: {
		content: "The Live Retail search functionality allows users to filter the displayed vehicle results as follows.",
		list: {
			first: "Mileage",
			second: "Registration date",
			third: "Fuel type",
			fourth: "Transmission",
			fifth: "Engine Power",
			sixth: "Keywords (eg Zetec, TDi Sport, S Line)",
			seventh: "Engine displacement (CCM)",
			eighth: "Body type",
			ninth: "Drive type",
			tenth: "Distance from dealership"
		}
	}
};
var matches = {
	exact: "Exact",
	best: "Best",
	close: "Close",
	similar: "Similar",
	matchesTooltip: {
		content: "These icons illustrate how closely each vehicle shown in the list below matches your vehicle. The same colour icons are also used in the visual scatter graph comparison. The vehicles in the list can be ordered by clicking on each of the column headers."
	}
};
var results = {
	ownVehicle: "Own vehicle",
	adLinks: "Ad Link",
	vehicle: "Vehicle",
	askPrice: "Asking Price",
	diffPrice: "VS",
	lrPrice: "Live Retail",
	similarity: "Match",
	distance: "distance",
	odometer: "Mileage",
	regDate: "REGISTRATION",
	company: "company",
	stockDays: "stock days",
	priceChanges: "price changes",
	tooltips: {
		vhDescription: {
			header: "full Description",
			make: "Make",
			modelSeries: "Model series",
			type: "Type",
			body: "Body type",
			doors: "Doors",
			seats: "Seats",
			fuel: "Fuel type",
			powerKW: "Engine power kW",
			powerHP: "Engine power HP",
			cylCubic: "Engine size",
			cylinders: "Cylinders",
			gearBox: "Transmission",
			noOfGears: "No. of gears",
			drive: "Drivetrain",
			engineType: "Engine type",
			wheelBase: "Wheelbase",
			totalWeight: "Total weight",
			payload: "Pay load",
			importBegin: "Introduced",
			importEnd: "Discontinued",
			vhType: "Vehicle type",
			nationalCode: "National code"
		},
		priceDiff: {
			header: "LIVE Retail in Detail",
			standardVh: "Standard Vehicle",
			standardVhOdometer: "Avg. Mileage",
			standardVhRegDate: "Avg. Reg.Date",
			thisVh: "This Vehicle",
			odometerEffect: "Mileage Correction",
			ageEffect: "Age Correction",
			regionalEffect: "Regional Correction",
			options: "Equipment:",
			equipmentAverage: "Avg options value - detailed options n/a",
			totalEffects: "Corrections Total",
			regionalAskingPrice: "Glass's LIVE Retail",
			regional: "Glass's LIVE Retail",
			askingPrice: "Asking Price",
			priceDifference: "Price Difference",
			underpriced: "Underpriced",
			overpriced: "Overpriced",
			noOptions: "No Effect in Price"
		},
		priceHistory: {
			header: "Price History",
			dateAdRemoved: "Date last advertised",
			removed: "Advert removed",
			"new": "New advert",
			priceCh: "Price change",
			original: "Original advert"
		}
	}
};
var config$d = {
	monthsTraslation: "Months"
};
var errorCode = {
	wrongAskingOrMileage: "Asking price and/or mileage are mandatory and cannot be 0 for live retail functionality to work. Please amend. If you experience further issues, then please contact our Customer Support team.",
	onlyOwnVh: "There are no similar vehicles based on your chosen filtering options. Please change your filtering criteria, e.g. the radius of the search using the distance filter and try again."
};
var default_localize = {
	summary: summary,
	report: report,
	filters: filters,
	matches: matches,
	results: results,
	config: config$d,
	errorCode: errorCode
};

var config$c = {
	currencySymbol: "£",
	datePattern: "dd/MM/yyyy",
	valueSeparator: ",",
	averageSeparator: ",",
	odometerSeparator: ",",
	odometerAbbreviation: "Miles"
};
var UK_mkt = {
	config: config$c
};

var config$b = {
	currencySymbol: "€",
	datePattern: "dd.MM.yyyy",
	valueSeparator: ".",
	averageSeparator: ",",
	odometerSeparator: ".",
	odometerAbbreviation: "Km"
};
var AT_mkt = {
	config: config$b
};

var config$a = {
	currencySymbol: "€",
	datePattern: "dd/MM/yyyy",
	valueSeparator: ".",
	averageSeparator: ",",
	odometerSeparator: ".",
	odometerAbbreviation: "Km"
};
var ES_mkt = {
	config: config$a
};

var config$9 = {
	currencySymbol: "€",
	datePattern: "dd.MM.yyyy",
	valueSeparator: ".",
	averageSeparator: ",",
	odometerSeparator: ".",
	odometerAbbreviation: "Km"
};
var DE_mkt = {
	config: config$9
};

var config$8 = {
	currencySymbol: "CHF",
	datePattern: "dd.MM.yyyy",
	valueSeparator: "'",
	averageSeparator: ".",
	odometerSeparator: "'",
	odometerAbbreviation: "Km"
};
var CH_mkt = {
	config: config$8
};

var config$7 = {
	currencySymbol: "€",
	datePattern: "dd/MM/yyyy",
	valueSeparator: ".",
	averageSeparator: ".",
	odometerSeparator: ".",
	odometerAbbreviation: "Km"
};
var BE_mkt = {
	config: config$7
};

var config$6 = {
	currencySymbol: "€",
	datePattern: "dd/MM/yyyy",
	valueSeparator: ".",
	averageSeparator: ",",
	odometerSeparator: ".",
	odometerAbbreviation: "Km"
};
var NL_mkt = {
	config: config$6
};

var config$5 = {
	currencySymbol: "PLN",
	datePattern: "dd.MM.yyyy",
	valueSeparator: " ",
	averageSeparator: ".",
	odometerSeparator: " ",
	odometerAbbreviation: "Km"
};
var PL_mkt = {
	config: config$5
};

var config$4 = {
	currencySymbol: "€",
	datePattern: "dd/MM/yyyy",
	valueSeparator: ".",
	averageSeparator: ",",
	odometerSeparator: ".",
	odometerAbbreviation: "Kms"
};
var PT_mkt = {
	config: config$4
};

var config$3 = {
	currencySymbol: "€",
	datePattern: "dd.MM.yyyy",
	valueSeparator: ".",
	averageSeparator: ".",
	odometerSeparator: "'",
	odometerAbbreviation: "Km"
};
var IT_mkt = {
	config: config$3
};

var config$2 = {
	currencySymbol: "€",
	datePattern: "dd/MM/yyyy",
	valueSeparator: " ",
	averageSeparator: ",",
	odometerSeparator: " ",
	odometerAbbreviation: "Km"
};
var FR_mkt = {
	config: config$2
};

var config$1 = {
	currencySymbol: "€",
	datePattern: "dd.MM.yyyy",
	valueSeparator: " ",
	averageSeparator: ",",
	odometerSeparator: " ",
	odometerAbbreviation: "Km"
};
var FI_mkt = {
	config: config$1
};

var config = {
	currencySymbol: "KR",
	datePattern: "yyyy-MM-dd",
	valueSeparator: " ",
	averageSeparator: ",",
	odometerSeparator: " ",
	odometerAbbreviation: "mil"
};
var SE_mkt = {
	config: config
};

class LiveRetailLibService {
    constructor() {
    }
    getLanguageConfig(lng, market) {
        if (lng && market)
            this.lngConfig = lng + "-" + market;
        // console.log(this.lngConfig)
        // this.lngConfig = ''; // SET UP HERE LANGUAGE DEMO FOR APP.PROPERTIES
        return this.lngConfig;
    }
    getCountry() {
        let market = this.lngConfig.slice(-2);
        return market;
    }
    getMarketConfig() {
        let market = this.lngConfig.slice(-2);
        // console.log(market)
        switch (market) {
            case 'UK':
            case 'GB': //support GB IsoCountry
                return UK_mkt;
            case 'AT':
                return AT_mkt;
            case 'ES':
                return ES_mkt;
            case 'DE':
                return DE_mkt;
            case 'CH':
                return CH_mkt;
            case 'BE':
                return BE_mkt;
            case 'FI':
                return FI_mkt;
            case 'FR':
                return FR_mkt;
            case 'IT':
                return IT_mkt;
            case 'NL':
                return NL_mkt;
            case 'PL':
                return PL_mkt;
            case 'PT':
                return PT_mkt;
            case 'SE':
                return SE_mkt;
        }
    }
    getLang() {
        let lng = this.lngConfig.slice(0, 2);
        // console.log(lng)
        return lng;
    }
    getLanguageProperties() {
        switch (this.getLanguageConfig()) {
            case 'en-UK':
            case 'en-GB': //support GB IsoCountry
                return en_UK;
            case 'en-ES':
                return en_ES;
            case 'es-ES':
                return es_ES;
            case 'ca-ES':
                return ca_ES;
            case 'de-UK':
            case 'de-GB':
                return de_UK;
            case 'de-AT':
                return de_AT;
            case 'de-CH':
                return de_CH;
            case 'de-DE':
                return de_DE;
            case 'fi-FI':
                return fi_FI;
            case 'fr-BE':
                return fr_BE;
            case 'fr-CH':
                return fr_CH;
            case 'fr-FR':
                return fr_FR;
            case 'it-CH':
                return it_CH;
            case 'it-IT':
                return it_IT;
            case 'nl-BE':
                return nl_BE;
            case 'pl-PL':
                return pl_PL;
            case 'pt-PT':
                return pt_PT;
            case 'se-SE':
                return se_SE;
            default:
                return default_localize;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: LiveRetailLibService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: LiveRetailLibService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: LiveRetailLibService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

const Headers = {
    headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    })
};

class AdvertsService {
    constructor(http) {
        this.http = http;
    }
    // this method returns list-of-items in form of Observable
    // every HTTTP call returns Observable object
    resolveAdverts(ownVhParams, searchParms) {
        if (ownVhParams) {
            this.liveRetailParamaters = ownVhParams;
        }
        if (searchParms) {
            this.searchParameters = searchParms;
        }
        else {
            this.searchParameters = {};
        }
        // URL which returns list of JSON items (API end-point URL)
        let URL = '/live-retail-api/adverts/' +
            this.liveRetailParamaters.ownVehicle.isoCountry + '/' +
            this.liveRetailParamaters.ownVehicle.natCode + '/' +
            this.liveRetailParamaters.ownVehicle.vehicleType;
        // console.log(URL);
        let body = Object.assign(this.liveRetailParamaters, this.searchParameters);
        // console.log('Request is sent!', body);	
        return this.http.post(URL, body, Headers);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: AdvertsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: AdvertsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: AdvertsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class ReportComponent {
    constructor(dataService) {
        this.dataService = dataService;
    }
    ngOnInit() {
        this.reportProps = this.dataService.getLanguageProperties().report;
        this.resultsProps = this.dataService.getLanguageProperties().results;
        this.mktProps = this.dataService.getMarketConfig().config;
    }
    ngOnChanges() {
        this.getGraphData();
    }
    getGraphData() {
        this.tooltipLoadingFlag = true;
        if (this.advertsObject) {
            this.minVh = this.advertsObject.minValueVehicle;
            this.maxVh = this.advertsObject.maxValueVehicle;
            this.ownVhPrice = this.advertsObject.liveRetailPrice;
            this.avgAskingPrice = Math.round(this.advertsObject.averageAskingPrice);
            this.graphConfig();
            // console.log(this.minVh, this.maxVh)
            if (this.minVh.askingPrice == null && this.maxVh.askingPrice == null) {
                this.tooltipLoadingFlag = true;
            }
            else {
                this.tooltipLoadingFlag = false;
            }
        }
        for (let i = 0; i < this.advertsObject?.vehicles.length; i++) {
            if (this.advertsObject.vehicles[i].isOwnVehicle === true) {
                this.ownVehicleObj = this.advertsObject.vehicles[i];
            }
        }
        // console.log(this.ownVehicleObj)
    }
    graphConfig() {
        // graph parameters
        var minValue = this.minVh.askingPrice;
        var maxValue = this.maxVh.askingPrice;
        var avgValue = this.avgAskingPrice;
        var ownVehiclePrice = this.ownVhPrice;
        var currencySymbol = this.mktProps.currencySymbol;
        var thousandSymbol = this.mktProps.valueSeparator;
        var graphTextAvg = this.reportProps.graph.avg;
        var graphTextLiveRetailPrice = this.reportProps.graph.liveRetailPrice.toUpperCase();
        var graphTextLrp = this.reportProps.graph.lrp.toUpperCase();
        var avgWithCommas = avgValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol);
        var ownVehicleWithCommas = ownVehiclePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol);
        var currencySymbolBefore = false;
        if (currencySymbol == '£') {
            currencySymbolBefore = true;
            var AVGLabelText = graphTextAvg + ' ' + currencySymbol + ' ' + avgWithCommas;
            var LRPLabelText = graphTextLiveRetailPrice + ' ' + currencySymbol + ' ' + ownVehicleWithCommas;
        }
        else {
            var AVGLabelText = graphTextAvg + ' ' + avgWithCommas + ' ' + currencySymbol;
            var LRPLabelText = graphTextLiveRetailPrice + ' ' + ownVehicleWithCommas + ' ' + currencySymbol;
        }
        var lrp;
        if (ownVehiclePrice > maxValue) {
            lrp = maxValue;
        }
        else {
            lrp = ownVehiclePrice;
        }
        ;
        if (ownVehiclePrice < minValue) {
            lrp = minValue;
        }
        ;
        this.chartOptions = {
            series: [{
                    name: 'ASKING PRICE',
                    data: [maxValue, lrp, minValue], //
                }],
            chart: {
                width: "100%",
                height: 200,
                type: 'line',
                zoom: {
                    enabled: false
                },
            },
            dataLabels: {
                enabled: false
            },
            colors: ["#232C32"],
            stroke: {
                width: 3,
                curve: 'smooth',
                dashArray: 5
            },
            xaxis: {
                show: false,
                categories: [' ', graphTextLrp, ' '],
                axisTicks: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                }
            },
            yaxis: {
                show: true,
                tickAmount: 1,
                min: minValue,
                max: maxValue,
                forceNiceScale: false,
                labels: {
                    show: true,
                    style: {
                        color: '#A1A9AC',
                        fontSize: '12px',
                    },
                    formatter: function numberWithCommas(x) {
                        if (currencySymbolBefore) {
                            return currencySymbol + ' ' + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol);
                        }
                        else {
                            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol) + ' ' + currencySymbol;
                        }
                    }
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: true,
                    borderType: 'solid',
                    color: '#B6C2C4',
                    width: 5,
                    offsetX: 0,
                    offsetY: 0
                },
            },
            tooltip: {
                enabled: false,
            },
            grid: {
                show: true,
                borderColor: '#ECEFF0',
                strokeDashArray: 0,
                position: 'back',
                xaxis: {
                    lines: {
                        show: true
                    }
                },
                yaxis: {
                    lines: {
                        show: true
                    }
                },
            },
            annotations: {
                position: 'front',
                yaxis: [
                    {
                        y: avgValue,
                        strokeDashArray: 5,
                        opacity: 1,
                        borderColor: "#008FC9",
                        label: {
                            borderColor: "#008FC9",
                            position: 'left',
                            offsetX: 70,
                            offsetY: 7.5,
                            style: {
                                color: "#fff",
                                background: "#008FC9",
                            },
                            text: AVGLabelText
                        },
                    },
                ],
                points: [
                    {
                        x: graphTextLrp,
                        y: lrp,
                        marker: {
                            size: 6,
                            fillColor: "#fff",
                            strokeColor: "#232C32",
                            radius: 2,
                        },
                        label: {
                            borderColor: "#232C32",
                            offsetY: 5,
                            style: {
                                color: "#fff",
                                background: "#232C32"
                            },
                            text: LRPLabelText
                        }
                    }
                ]
            }
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ReportComponent, deps: [{ token: LiveRetailLibService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: ReportComponent, selector: "app-report", inputs: { advertsObject: "advertsObject", annotations: "annotations", colors: "colors", dataLabels: "dataLabels", series: "series", stroke: "stroke", labels: "labels", tooltip: "tooltip", xaxis: "xaxis", yaxis: "yaxis", grid: "grid" }, viewQueries: [{ propertyName: "chart", first: true, predicate: ["chart"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "\r\n<!-- <div class=\"description--container\">DESCRIPTION</div> -->\r\n<div class=\"desc--container col\">\r\n    <div class=\"label\">\r\n        <span class=\"pic\">{{reportProps?.heading.zip}}</span>\r\n        <span class=\"info\">{{ownVehicleObj?.sellerZipCode}}</span>\r\n    </div>\r\n\r\n    <div class=\"label\">\r\n        <span class=\"pic\">{{ resultsProps?.regDate }}</span>\r\n        <span class=\"info\">{{ownVehicleObj?.regDate | date: mktProps.datePattern }}</span>\r\n    </div>\r\n    <span class=\"info tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"scatterTooltip\" tooltipClass=\"tooltip-style-1\">\r\n        <img src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQ1Ljk5OSA0NS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTM5LjI2NCw2LjczNmMtOC45ODItOC45ODEtMjMuNTQ1LTguOTgyLTMyLjUyOCwwYy04Ljk4Miw4Ljk4Mi04Ljk4MSwyMy41NDUsMCwzMi41MjhjOC45ODIsOC45OCwyMy41NDUsOC45ODEsMzIuNTI4LDAgICAgQzQ4LjI0NSwzMC4yODEsNDguMjQ0LDE1LjcxOSwzOS4yNjQsNi43MzZ6IE0yNS45OTksMzNjMCwxLjY1Ny0xLjM0MywzLTMsM3MtMy0xLjM0My0zLTNWMjFjMC0xLjY1NywxLjM0My0zLDMtM3MzLDEuMzQzLDMsM1YzM3ogICAgIE0yMi45NDYsMTUuODcyYy0xLjcyOCwwLTIuODgtMS4yMjQtMi44NDQtMi43MzVjLTAuMDM2LTEuNTg0LDEuMTE2LTIuNzcxLDIuODc5LTIuNzcxYzEuNzY0LDAsMi44OCwxLjE4OCwyLjkxNywyLjc3MSAgICBDMjUuODk3LDE0LjY0OCwyNC43NDYsMTUuODcyLDIyLjk0NiwxNS44NzJ6IiBmaWxsPSIjMDA4ZmM4IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg==\" />\r\n    </span>\r\n    <ng-template #scatterTooltip>\r\n        <div class=\"dc-style--tooltip\">\r\n            <h4>{{ reportProps?.scatterTooltip.header }}</h4>\r\n            <p>{{ reportProps?.scatterTooltip.content }}</p>\r\n            <ul>\r\n                <li>{{ reportProps?.scatterTooltip.list.first }}</li>\r\n                <li>{{ reportProps?.scatterTooltip.list.second }}</li>\r\n                <li>{{ reportProps?.scatterTooltip.list.third }}</li>\r\n                <li>{{ reportProps?.scatterTooltip.list.fourth }}</li>\r\n            </ul>\r\n        </div>  \r\n    </ng-template>\r\n</div>\r\n<div class=\"graph--container col\">\r\n    <div *ngIf=\"tooltipLoadingFlag\" class=\"loader--container\"><div class=\"lds-ellipsis\"><div></div><div></div><div></div><div></div></div></div>\r\n    <apx-chart *ngIf=\"!tooltipLoadingFlag\" style=\"width: 100%;height: 100%;\"\r\n        [series]=\"chartOptions.series\"\r\n        [chart]=\"chartOptions.chart\"\r\n        [xaxis]=\"chartOptions.xaxis\"\r\n        [yaxis]=\"chartOptions.yaxis\"\r\n        [dataLabels]=\"chartOptions.dataLabels\"\r\n        [labels]=\"chartOptions.labels\"\r\n        [colors]=\"chartOptions.colors\"\r\n        [tooltip]=\"chartOptions.tooltip\"\r\n        [stroke]=\"chartOptions.stroke\"\r\n        [grid]=\"chartOptions.grid\"\r\n        [annotations]=\"chartOptions.annotations\">\r\n    </apx-chart>\r\n   \r\n\r\n</div>", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}.desc--container{height:50px;display:flex;align-items:center;padding:0;position:relative}.desc--container span.tooltip-trigger{position:absolute;top:0;right:85px}.desc--container .label{margin-right:20px;font-family:Aileron semibold}.desc--container .label .pic{margin-right:5px;padding:3px 5px;border-radius:3px;background-color:#232c32;color:#fff}.graph--container{height:200px;border:1px solid #dae0e1;border-radius:5px;background:#dae0e1;padding:0}\n"], dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.ChartComponent, selector: "apx-chart", inputs: ["chart", "annotations", "colors", "dataLabels", "series", "stroke", "labels", "legend", "markers", "noData", "fill", "tooltip", "plotOptions", "responsive", "xaxis", "yaxis", "forecastDataPoints", "grid", "states", "title", "subtitle", "theme", "autoUpdateSeries"], outputs: ["chartReady"] }, { kind: "directive", type: i5.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { kind: "pipe", type: i4.DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ReportComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-report', template: "\r\n<!-- <div class=\"description--container\">DESCRIPTION</div> -->\r\n<div class=\"desc--container col\">\r\n    <div class=\"label\">\r\n        <span class=\"pic\">{{reportProps?.heading.zip}}</span>\r\n        <span class=\"info\">{{ownVehicleObj?.sellerZipCode}}</span>\r\n    </div>\r\n\r\n    <div class=\"label\">\r\n        <span class=\"pic\">{{ resultsProps?.regDate }}</span>\r\n        <span class=\"info\">{{ownVehicleObj?.regDate | date: mktProps.datePattern }}</span>\r\n    </div>\r\n    <span class=\"info tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"scatterTooltip\" tooltipClass=\"tooltip-style-1\">\r\n        <img src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQ1Ljk5OSA0NS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTM5LjI2NCw2LjczNmMtOC45ODItOC45ODEtMjMuNTQ1LTguOTgyLTMyLjUyOCwwYy04Ljk4Miw4Ljk4Mi04Ljk4MSwyMy41NDUsMCwzMi41MjhjOC45ODIsOC45OCwyMy41NDUsOC45ODEsMzIuNTI4LDAgICAgQzQ4LjI0NSwzMC4yODEsNDguMjQ0LDE1LjcxOSwzOS4yNjQsNi43MzZ6IE0yNS45OTksMzNjMCwxLjY1Ny0xLjM0MywzLTMsM3MtMy0xLjM0My0zLTNWMjFjMC0xLjY1NywxLjM0My0zLDMtM3MzLDEuMzQzLDMsM1YzM3ogICAgIE0yMi45NDYsMTUuODcyYy0xLjcyOCwwLTIuODgtMS4yMjQtMi44NDQtMi43MzVjLTAuMDM2LTEuNTg0LDEuMTE2LTIuNzcxLDIuODc5LTIuNzcxYzEuNzY0LDAsMi44OCwxLjE4OCwyLjkxNywyLjc3MSAgICBDMjUuODk3LDE0LjY0OCwyNC43NDYsMTUuODcyLDIyLjk0NiwxNS44NzJ6IiBmaWxsPSIjMDA4ZmM4IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg==\" />\r\n    </span>\r\n    <ng-template #scatterTooltip>\r\n        <div class=\"dc-style--tooltip\">\r\n            <h4>{{ reportProps?.scatterTooltip.header }}</h4>\r\n            <p>{{ reportProps?.scatterTooltip.content }}</p>\r\n            <ul>\r\n                <li>{{ reportProps?.scatterTooltip.list.first }}</li>\r\n                <li>{{ reportProps?.scatterTooltip.list.second }}</li>\r\n                <li>{{ reportProps?.scatterTooltip.list.third }}</li>\r\n                <li>{{ reportProps?.scatterTooltip.list.fourth }}</li>\r\n            </ul>\r\n        </div>  \r\n    </ng-template>\r\n</div>\r\n<div class=\"graph--container col\">\r\n    <div *ngIf=\"tooltipLoadingFlag\" class=\"loader--container\"><div class=\"lds-ellipsis\"><div></div><div></div><div></div><div></div></div></div>\r\n    <apx-chart *ngIf=\"!tooltipLoadingFlag\" style=\"width: 100%;height: 100%;\"\r\n        [series]=\"chartOptions.series\"\r\n        [chart]=\"chartOptions.chart\"\r\n        [xaxis]=\"chartOptions.xaxis\"\r\n        [yaxis]=\"chartOptions.yaxis\"\r\n        [dataLabels]=\"chartOptions.dataLabels\"\r\n        [labels]=\"chartOptions.labels\"\r\n        [colors]=\"chartOptions.colors\"\r\n        [tooltip]=\"chartOptions.tooltip\"\r\n        [stroke]=\"chartOptions.stroke\"\r\n        [grid]=\"chartOptions.grid\"\r\n        [annotations]=\"chartOptions.annotations\">\r\n    </apx-chart>\r\n   \r\n\r\n</div>", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}.desc--container{height:50px;display:flex;align-items:center;padding:0;position:relative}.desc--container span.tooltip-trigger{position:absolute;top:0;right:85px}.desc--container .label{margin-right:20px;font-family:Aileron semibold}.desc--container .label .pic{margin-right:5px;padding:3px 5px;border-radius:3px;background-color:#232c32;color:#fff}.graph--container{height:200px;border:1px solid #dae0e1;border-radius:5px;background:#dae0e1;padding:0}\n"] }]
        }], ctorParameters: () => [{ type: LiveRetailLibService }], propDecorators: { advertsObject: [{
                type: Input
            }], chart: [{
                type: ViewChild,
                args: ["chart"]
            }], annotations: [{
                type: Input
            }], colors: [{
                type: Input
            }], dataLabels: [{
                type: Input
            }], series: [{
                type: Input
            }], stroke: [{
                type: Input
            }], labels: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], xaxis: [{
                type: Input
            }], yaxis: [{
                type: Input
            }], grid: [{
                type: Input
            }] } });

class NumberLocalePipe {
    transform(value, symbol) {
        var userLang = navigator.language;
        if (value && symbol)
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, symbol);
        else
            return new Intl.NumberFormat(userLang).format(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: NumberLocalePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: NumberLocalePipe, name: "numberLocale" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: NumberLocalePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'numberLocale'
                }]
        }] });

class RoundPipe {
    transform(input) {
        let x;
        if (input) {
            x = parseFloat(input.toFixed(1)).toString().replace('.', ',');
            return x;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: RoundPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: RoundPipe, name: "round" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: RoundPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'round'
                }]
        }] });

class SummaryComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.currencySymbolBefore = false;
        this.tooltipLoadingFlag = true;
    }
    ngOnInit() {
        this.summaryProps = this.dataService.getLanguageProperties().summary;
        this.mktProps = this.dataService.getMarketConfig().config;
        if (this.mktProps.currencySymbol == '£') {
            this.currencySymbolBefore = true;
        }
        else {
            this.currencySymbolBefore = false;
        }
    }
    ngOnChanges() {
        if (this.advertsObject)
            this.tooltipLoadingFlag = false;
        else
            this.tooltipLoadingFlag = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: SummaryComponent, deps: [{ token: LiveRetailLibService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: SummaryComponent, selector: "app-summary", inputs: { advertsObject: "advertsObject" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"summary--content\">\r\n  <div>\r\n    <div style=\"display: flex; flex-direction: column;\">\r\n      <span class=\"hg-label\" style=\"margin-bottom: 15px;\">\r\n        {{ summaryProps.lrPrice | uppercase }}\r\n      </span>\r\n      <span class=\"st-item\" *ngIf=\"advertsObject?.sellingSpotPrice != null\">\r\n        {{ summaryProps.sellingSpotPrice | uppercase }}\r\n      </span>\r\n    </div>\r\n    <span *ngIf=\"tooltipLoadingFlag\" class=\"hg-value loader--container\">\r\n      <div class=\"lds-ellipsis\" style=\"margin-top:-25px;margin-right: 50px;\">\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n      </div>\r\n    </span>\r\n    <div *ngIf=\"!tooltipLoadingFlag\"style=\"display: flex; flex-direction: column;\">\r\n      <span class=\"hg-value\">\r\n        <ng-template [ngIf]=\"!currencySymbolBefore\">\r\n          {{advertsObject?.liveRetailPrice | numberLocale :mktProps.valueSeparator}} {{mktProps.currencySymbol}}\r\n        </ng-template>\r\n        <ng-template [ngIf]=\"currencySymbolBefore\">{{mktProps.currencySymbol}}\r\n          {{advertsObject?.liveRetailPrice | numberLocale :mktProps.valueSeparator}}</ng-template>\r\n      </span>\r\n      <span *ngIf=\"advertsObject?.sellingSpotPrice != null\" class=\"scnd-value\">\r\n        <ng-template [ngIf]=\"!currencySymbolBefore\">\r\n          {{advertsObject?.sellingSpotPrice | numberLocale :mktProps.valueSeparator}} {{mktProps.currencySymbol}}\r\n        </ng-template>\r\n        <ng-template [ngIf]=\"currencySymbolBefore\">{{mktProps.currencySymbol}}\r\n          {{advertsObject?.sellingSpotPrice | numberLocale :mktProps.valueSeparator}}</ng-template>\r\n      </span>\r\n    </div>\r\n   \r\n  </div>\r\n  <div class=\"separator\"></div>\r\n  <div class=\"item--container\">\r\n    <span class=\"st-item\"> {{ summaryProps.avgStockDays | uppercase }}</span>\r\n    <span *ngIf=\"!tooltipLoadingFlag\" class=\"st-value\">{{advertsObject?.avgSellingTime}}</span>\r\n  </div>\r\n  <div class=\"item--container\">\r\n    <span class=\"st-item\">{{ summaryProps.desirability | uppercase }}</span>\r\n    <span *ngIf=\"!tooltipLoadingFlag\" class=\"st-value desirability\" [ngClass]=\"{\r\n        desCode0: advertsObject?.desirabilityCategoryCode == 0,\r\n        desCode1: advertsObject?.desirabilityCategoryCode == 1,\r\n        desCode2: advertsObject?.desirabilityCategoryCode == 2,\r\n        desCode3: advertsObject?.desirabilityCategoryCode == 3,\r\n        desCode4: advertsObject?.desirabilityCategoryCode == 4}\">\r\n      {{ advertsObject?.desirabilityCategory}}\r\n    </span>\r\n  </div>\r\n  <div class=\"item--container\">\r\n    <span class=\"st-item\">{{ summaryProps.avgMileage | uppercase }}</span>\r\n    <span *ngIf=\"!tooltipLoadingFlag\"\r\n      class=\"st-value\">{{ advertsObject?.averageOdometer | numberLocale :mktProps.odometerSeparator}}\r\n      {{mktProps.odometerAbbreviation}}</span>\r\n  </div>\r\n  <div class=\"item--container\">\r\n    <span class=\"st-item\">{{ summaryProps.avgPriceChanges | uppercase }}</span>\r\n    <span *ngIf=\"!tooltipLoadingFlag\" class=\"st-value\">{{ advertsObject?.averageNumberOfPriceChanges | round }}</span>\r\n  </div>\r\n\r\n  <span class=\"info tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"summaryTooltip\" tooltipClass=\"tooltip-style-1\">\r\n    <img\r\n      src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQ1Ljk5OSA0NS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTM5LjI2NCw2LjczNmMtOC45ODItOC45ODEtMjMuNTQ1LTguOTgyLTMyLjUyOCwwYy04Ljk4Miw4Ljk4Mi04Ljk4MSwyMy41NDUsMCwzMi41MjhjOC45ODIsOC45OCwyMy41NDUsOC45ODEsMzIuNTI4LDAgICAgQzQ4LjI0NSwzMC4yODEsNDguMjQ0LDE1LjcxOSwzOS4yNjQsNi43MzZ6IE0yNS45OTksMzNjMCwxLjY1Ny0xLjM0MywzLTMsM3MtMy0xLjM0My0zLTNWMjFjMC0xLjY1NywxLjM0My0zLDMtM3MzLDEuMzQzLDMsM1YzM3ogICAgIE0yMi45NDYsMTUuODcyYy0xLjcyOCwwLTIuODgtMS4yMjQtMi44NDQtMi43MzVjLTAuMDM2LTEuNTg0LDEuMTE2LTIuNzcxLDIuODc5LTIuNzcxYzEuNzY0LDAsMi44OCwxLjE4OCwyLjkxNywyLjc3MSAgICBDMjUuODk3LDE0LjY0OCwyNC43NDYsMTUuODcyLDIyLjk0NiwxNS44NzJ6IiBmaWxsPSIjMDA4ZmM4IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg==\" />\r\n  </span>\r\n  <ng-template #summaryTooltip>\r\n    <div class=\"dc-style--tooltip\">\r\n      <h4>{{ summaryProps?.summaryTooltip.header }}</h4>\r\n      <p>{{ summaryProps?.summaryTooltip.content }}</p>\r\n      <p>{{ summaryProps?.summaryTooltip.content2 }}</p>\r\n      <ul>\r\n        <li>{{ summaryProps?.summaryTooltip.list.first }}</li>\r\n        <li>{{ summaryProps?.summaryTooltip.list.second }}</li>\r\n        <li>{{ summaryProps?.summaryTooltip.list.third }}</li>\r\n        <li>{{ summaryProps?.summaryTooltip.list.fourth }}</li>\r\n      </ul>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}.summary--content{display:flex;align-self:flex-end;justify-content:space-between;flex-direction:column;padding:20px;width:100%;height:100%;position:relative}.summary--content div{display:flex;justify-content:space-between}.summary--content span{display:flex;flex-direction:column}.summary--content span>small{font-size:14px;color:#a1a9ac}.summary--content .hg-label{color:#fff;font-family:Aileron bold;margin-right:20px;text-align:left;font-size:20px}.summary--content .hg-value{color:#fff;font-size:30px;text-align:right;white-space:nowrap}.summary--content .scnd-value{color:#fff;font-size:18px;text-align:right;white-space:nowrap}.summary--content div.item--container{line-height:30px}.summary--content .st-item{color:#a1a9ac;font-size:1em;font-family:Aileron;margin-right:20px}.summary--content .st-value{align-self:center;color:#fff;font-size:24px;font-family:Aileron}.summary--content .desirability{font-family:Aileron light;text-transform:uppercase;font-size:22px}.summary--content .desCode0{color:#fff}.summary--content .desCode1{color:#008fc9}.summary--content .desCode2{color:#00a76e}.summary--content .desCode3{color:#e1be2b}.summary--content .desCode4{color:#de4a39}.summary--content .separator{margin-top:10px;margin-bottom:10px;width:100%;border-top:1px solid dimgray}@media (max-width: 950px){.summary--content .hg-label{margin-right:10px;font-size:18px}.summary--content .hg-value{font-size:26px;text-align:right}.summary--content .st-item{font-size:14px;margin-right:10px}.summary--content .st-value{font-size:22px;font-family:Aileron}}span.tooltip-trigger{position:absolute;left:3px;top:-2px}.dc-style--tooltip{display:block!important}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { kind: "pipe", type: i4.UpperCasePipe, name: "uppercase" }, { kind: "pipe", type: NumberLocalePipe, name: "numberLocale" }, { kind: "pipe", type: RoundPipe, name: "round" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: SummaryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-summary', template: "<div class=\"summary--content\">\r\n  <div>\r\n    <div style=\"display: flex; flex-direction: column;\">\r\n      <span class=\"hg-label\" style=\"margin-bottom: 15px;\">\r\n        {{ summaryProps.lrPrice | uppercase }}\r\n      </span>\r\n      <span class=\"st-item\" *ngIf=\"advertsObject?.sellingSpotPrice != null\">\r\n        {{ summaryProps.sellingSpotPrice | uppercase }}\r\n      </span>\r\n    </div>\r\n    <span *ngIf=\"tooltipLoadingFlag\" class=\"hg-value loader--container\">\r\n      <div class=\"lds-ellipsis\" style=\"margin-top:-25px;margin-right: 50px;\">\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n      </div>\r\n    </span>\r\n    <div *ngIf=\"!tooltipLoadingFlag\"style=\"display: flex; flex-direction: column;\">\r\n      <span class=\"hg-value\">\r\n        <ng-template [ngIf]=\"!currencySymbolBefore\">\r\n          {{advertsObject?.liveRetailPrice | numberLocale :mktProps.valueSeparator}} {{mktProps.currencySymbol}}\r\n        </ng-template>\r\n        <ng-template [ngIf]=\"currencySymbolBefore\">{{mktProps.currencySymbol}}\r\n          {{advertsObject?.liveRetailPrice | numberLocale :mktProps.valueSeparator}}</ng-template>\r\n      </span>\r\n      <span *ngIf=\"advertsObject?.sellingSpotPrice != null\" class=\"scnd-value\">\r\n        <ng-template [ngIf]=\"!currencySymbolBefore\">\r\n          {{advertsObject?.sellingSpotPrice | numberLocale :mktProps.valueSeparator}} {{mktProps.currencySymbol}}\r\n        </ng-template>\r\n        <ng-template [ngIf]=\"currencySymbolBefore\">{{mktProps.currencySymbol}}\r\n          {{advertsObject?.sellingSpotPrice | numberLocale :mktProps.valueSeparator}}</ng-template>\r\n      </span>\r\n    </div>\r\n   \r\n  </div>\r\n  <div class=\"separator\"></div>\r\n  <div class=\"item--container\">\r\n    <span class=\"st-item\"> {{ summaryProps.avgStockDays | uppercase }}</span>\r\n    <span *ngIf=\"!tooltipLoadingFlag\" class=\"st-value\">{{advertsObject?.avgSellingTime}}</span>\r\n  </div>\r\n  <div class=\"item--container\">\r\n    <span class=\"st-item\">{{ summaryProps.desirability | uppercase }}</span>\r\n    <span *ngIf=\"!tooltipLoadingFlag\" class=\"st-value desirability\" [ngClass]=\"{\r\n        desCode0: advertsObject?.desirabilityCategoryCode == 0,\r\n        desCode1: advertsObject?.desirabilityCategoryCode == 1,\r\n        desCode2: advertsObject?.desirabilityCategoryCode == 2,\r\n        desCode3: advertsObject?.desirabilityCategoryCode == 3,\r\n        desCode4: advertsObject?.desirabilityCategoryCode == 4}\">\r\n      {{ advertsObject?.desirabilityCategory}}\r\n    </span>\r\n  </div>\r\n  <div class=\"item--container\">\r\n    <span class=\"st-item\">{{ summaryProps.avgMileage | uppercase }}</span>\r\n    <span *ngIf=\"!tooltipLoadingFlag\"\r\n      class=\"st-value\">{{ advertsObject?.averageOdometer | numberLocale :mktProps.odometerSeparator}}\r\n      {{mktProps.odometerAbbreviation}}</span>\r\n  </div>\r\n  <div class=\"item--container\">\r\n    <span class=\"st-item\">{{ summaryProps.avgPriceChanges | uppercase }}</span>\r\n    <span *ngIf=\"!tooltipLoadingFlag\" class=\"st-value\">{{ advertsObject?.averageNumberOfPriceChanges | round }}</span>\r\n  </div>\r\n\r\n  <span class=\"info tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"summaryTooltip\" tooltipClass=\"tooltip-style-1\">\r\n    <img\r\n      src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQ1Ljk5OSA0NS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTM5LjI2NCw2LjczNmMtOC45ODItOC45ODEtMjMuNTQ1LTguOTgyLTMyLjUyOCwwYy04Ljk4Miw4Ljk4Mi04Ljk4MSwyMy41NDUsMCwzMi41MjhjOC45ODIsOC45OCwyMy41NDUsOC45ODEsMzIuNTI4LDAgICAgQzQ4LjI0NSwzMC4yODEsNDguMjQ0LDE1LjcxOSwzOS4yNjQsNi43MzZ6IE0yNS45OTksMzNjMCwxLjY1Ny0xLjM0MywzLTMsM3MtMy0xLjM0My0zLTNWMjFjMC0xLjY1NywxLjM0My0zLDMtM3MzLDEuMzQzLDMsM1YzM3ogICAgIE0yMi45NDYsMTUuODcyYy0xLjcyOCwwLTIuODgtMS4yMjQtMi44NDQtMi43MzVjLTAuMDM2LTEuNTg0LDEuMTE2LTIuNzcxLDIuODc5LTIuNzcxYzEuNzY0LDAsMi44OCwxLjE4OCwyLjkxNywyLjc3MSAgICBDMjUuODk3LDE0LjY0OCwyNC43NDYsMTUuODcyLDIyLjk0NiwxNS44NzJ6IiBmaWxsPSIjMDA4ZmM4IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg==\" />\r\n  </span>\r\n  <ng-template #summaryTooltip>\r\n    <div class=\"dc-style--tooltip\">\r\n      <h4>{{ summaryProps?.summaryTooltip.header }}</h4>\r\n      <p>{{ summaryProps?.summaryTooltip.content }}</p>\r\n      <p>{{ summaryProps?.summaryTooltip.content2 }}</p>\r\n      <ul>\r\n        <li>{{ summaryProps?.summaryTooltip.list.first }}</li>\r\n        <li>{{ summaryProps?.summaryTooltip.list.second }}</li>\r\n        <li>{{ summaryProps?.summaryTooltip.list.third }}</li>\r\n        <li>{{ summaryProps?.summaryTooltip.list.fourth }}</li>\r\n      </ul>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}.summary--content{display:flex;align-self:flex-end;justify-content:space-between;flex-direction:column;padding:20px;width:100%;height:100%;position:relative}.summary--content div{display:flex;justify-content:space-between}.summary--content span{display:flex;flex-direction:column}.summary--content span>small{font-size:14px;color:#a1a9ac}.summary--content .hg-label{color:#fff;font-family:Aileron bold;margin-right:20px;text-align:left;font-size:20px}.summary--content .hg-value{color:#fff;font-size:30px;text-align:right;white-space:nowrap}.summary--content .scnd-value{color:#fff;font-size:18px;text-align:right;white-space:nowrap}.summary--content div.item--container{line-height:30px}.summary--content .st-item{color:#a1a9ac;font-size:1em;font-family:Aileron;margin-right:20px}.summary--content .st-value{align-self:center;color:#fff;font-size:24px;font-family:Aileron}.summary--content .desirability{font-family:Aileron light;text-transform:uppercase;font-size:22px}.summary--content .desCode0{color:#fff}.summary--content .desCode1{color:#008fc9}.summary--content .desCode2{color:#00a76e}.summary--content .desCode3{color:#e1be2b}.summary--content .desCode4{color:#de4a39}.summary--content .separator{margin-top:10px;margin-bottom:10px;width:100%;border-top:1px solid dimgray}@media (max-width: 950px){.summary--content .hg-label{margin-right:10px;font-size:18px}.summary--content .hg-value{font-size:26px;text-align:right}.summary--content .st-item{font-size:14px;margin-right:10px}.summary--content .st-value{font-size:22px;font-family:Aileron}}span.tooltip-trigger{position:absolute;left:3px;top:-2px}.dc-style--tooltip{display:block!important}\n"] }]
        }], ctorParameters: () => [{ type: LiveRetailLibService }], propDecorators: { advertsObject: [{
                type: Input
            }] } });

class FiltersOptionsService {
    constructor(http) {
        this.http = http;
        // URL which returns list of JSON items (API end-point URL)
        this.URL = '/live-retail-api/search-criteria';
    }
    // every HTTTP call returns Observable object
    resolveFiltersOptions(isoCountry, isoLanguage, natCode) {
        // console.log(this.URL + '/' + isoCountry + '/' + isoLanguage + '/' + natCode, Headers)
        return this.http.get(this.URL + '/' + isoCountry + '/' + isoLanguage + '/' + natCode, Headers);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FiltersOptionsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FiltersOptionsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FiltersOptionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

const animationTime = 350;
class FiltersComponent {
    constructor(dataService, filterOptionsService, formBuilder) {
        this.dataService = dataService;
        this.filterOptionsService = filterOptionsService;
        this.formBuilder = formBuilder;
        this.advertsUpdate = new EventEmitter();
        this.yearsInterval = [];
        this.fuelDisabled = false;
        this.bodyTypeDisabled = false;
        this.gearBoxDisabled = false;
        this.driveTypeDisabled = false;
        this.distanceMappedList = [];
        this.mileageList = [];
        this.limitSelection = false;
        this.selectedItems = [];
        this.dropdownSettings = {};
        this.dropdownSettingsSingle = {};
        this.showSellerFilters = true;
        this.collapseFilters = true;
        this.currentYear = new Date().getFullYear();
        this.filtersForm = this.formBuilder.group({
            keywords: new UntypedFormControl(),
            mileageFrom: new UntypedFormControl(''),
            mileageTo: new UntypedFormControl(''),
            yearFrom: new UntypedFormControl(''),
            yearTo: new UntypedFormControl(''),
            engineFrom: new UntypedFormControl(''),
            engineTo: new UntypedFormControl(''),
            fuelType: new UntypedFormControl(''),
            bodyType: new UntypedFormControl(''),
            transmission: new UntypedFormControl(''),
            drivetrain: new UntypedFormControl(''),
            powerFrom: new UntypedFormControl(''),
            powerTo: new UntypedFormControl(''),
            distance: new UntypedFormControl(''),
            onSaleCheck: new UntypedFormControl(''),
            soldCheck: new UntypedFormControl(''),
            dealerCheck: new UntypedFormControl(''),
            privateCheck: new UntypedFormControl(''),
        });
    }
    ngOnInit() {
        this.filtersProps = this.dataService.getLanguageProperties().filters;
        this.filtersLink = true;
        this.filtersLinkTxt = this.filtersProps.showFilters;
        this.getSearchCriteria();
        this.getYearsCounter();
        this.getMileageList();
        this.setFiltersValues();
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'code',
            textField: 'description',
            selectAllText: this.filtersProps.nullValid,
            unSelectAllText: this.filtersProps.nullValid,
            itemsShowLimit: 1,
            allowSearchFilter: false
        };
        this.dropdownSettingsSingle = {
            singleSelection: true,
            idField: 'code',
            textField: 'description',
            selectAllText: this.filtersProps.nullValid,
            unSelectAllText: this.filtersProps.nullValid,
            itemsShowLimit: 1,
            allowSearchFilter: false
        };
    }
    handleLimitSelection() {
        if (this.limitSelection) {
            this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: 2 });
        }
        else {
            this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: null });
        }
    }
    getSearchCriteria() {
        this.searchCriteria$ = this.filterOptionsService.resolveFiltersOptions(this.ownVehicle.ownVehicle.isoCountry, this.ownVehicle.ownVehicle.isoLanguage, this.ownVehicle.ownVehicle.natCode);
        this.searchCriteria$.subscribe((a) => {
            this.searchCriteria = a;
            // console.log("search criteria response: ", this.searchCriteria)
            for (let i = 0; i < this.searchCriteria.distanceList.length; i++) {
                if (this.searchCriteria.distanceList[i].isDefault === true) {
                    if (this.searchCriteria.distanceList[i].description == 'ALL') {
                        this.defaultDistance = this.searchCriteria.distanceList[i].code;
                        // this.defaultDistance = this.filtersProps.wholeCountry;
                    }
                    else {
                        this.defaultDistance = this.searchCriteria.distanceList[i].description;
                    }
                }
            }
            ;
            // console.log(this.defaultDistance)
            this.filtersForm.controls['onSaleCheck'].setValue(this.searchCriteria?.defaultInclude.vehiclesForSale);
            this.filtersForm.controls['soldCheck'].setValue(this.searchCriteria?.defaultInclude.vehiclesAlreadySold);
            this.filtersForm.controls['dealerCheck'].setValue(this.searchCriteria?.defaultInclude.dealerSales);
            this.filtersForm.controls['privateCheck'].setValue(this.searchCriteria?.defaultInclude.privateSales);
            this.filtersForm.controls['distance'].setValue(this.defaultDistance);
            this.bodyTypeDisabled = a.displayOptions.disableBodyFilter;
            this.driveTypeDisabled = a.displayOptions.disableDrivetrainFilter;
            this.fuelDisabled = a.displayOptions.disableFuelFilter;
            this.gearBoxDisabled = a.displayOptions.disableTransmissionFilter;
            if (a.displayOptions.showSellerFilter == false) {
                this.showSellerFilters = false;
                this.filtersForm.controls['dealerCheck'].setValue(undefined);
                this.filtersForm.controls['privateCheck'].setValue(undefined);
            }
        });
        return this.distanceMappedList;
    }
    getYearsCounter() {
        if (this.currentYear) {
            for (let i = 1986; i <= this.currentYear; i++) {
                this.yearsInterval.push(i);
            }
        }
        return this.yearsInterval.reverse();
    }
    getMileageList() {
        this.mileageList[0] = 25000;
        for (let i = 1; i < 12; i++) {
            this.mileageList[i] = this.mileageList[i - 1] + 25000;
        }
        return this.mileageList;
    }
    setFiltersValues() {
        this.filtersForm.controls['keywords'].setValue('');
        this.filtersForm.controls['mileageFrom'].setValue(undefined);
        this.filtersForm.controls['mileageTo'].setValue(undefined);
        this.filtersForm.controls['yearFrom'].setValue(undefined);
        this.filtersForm.controls['yearTo'].setValue(this.currentYear);
        this.filtersForm.controls['engineFrom'].setValue(undefined);
        this.filtersForm.controls['engineTo'].setValue(undefined);
        this.filtersForm.controls['fuelType'].setValue(null);
        this.filtersForm.controls['bodyType'].setValue(null);
        this.filtersForm.controls['transmission'].setValue(null);
        this.filtersForm.controls['drivetrain'].setValue(null);
        this.filtersForm.controls['powerFrom'].setValue(undefined);
        this.filtersForm.controls['powerTo'].setValue(undefined);
    }
    toggleFiltersLink() {
        this.collapseFilters = !this.collapseFilters;
        if (this.filtersLink == false &&
            this.collapseFiltersDiv.nativeElement.classList.contains('collapsing') == false) {
            this.filtersLinkTxt = this.filtersProps.showFilters;
            this.filtersLink = true;
        }
        else if (this.filtersLink == true &&
            this.collapseFiltersDiv.nativeElement.classList.contains('collapsing') == false) {
            this.filtersLinkTxt = this.filtersProps.hideFilters;
            this.filtersLink = false;
        }
    }
    postData() {
        let mileage = { from: null, to: null };
        let year = { from: null, to: this.currentYear.toString() };
        let enginePower = { from: null, to: null };
        let engineSize = { from: null, to: null };
        //
        let fuelTypeList = [];
        let bodyTypeList = [];
        let transmissionList = [];
        let driveList = [];
        if (this.filtersForm.value.mileageFrom == 'null' || !this.filtersForm.value.mileageFrom)
            mileage.from = null;
        else
            mileage.from = this.filtersForm.value.mileageFrom[0];
        if (this.filtersForm.value.mileageTo == 'null' || !this.filtersForm.value.mileageTo)
            mileage.to = null;
        else
            mileage.to = this.filtersForm.value.mileageTo[0];
        if (this.filtersForm.value.yearFrom == 'null' || !this.filtersForm.value.yearFrom)
            year.from = null;
        else
            year.from = this.filtersForm.value.yearFrom[0];
        if (this.filtersForm.value.yearTo == 'null' || !this.filtersForm.value.yearTo)
            year.to = this.currentYear.toString();
        else
            year.to = this.filtersForm.value.yearTo[0];
        if (this.filtersForm.value.powerFrom == 'null' || !this.filtersForm.value.powerFrom || !this.filtersForm.value.powerFrom[0])
            enginePower.from = null;
        else
            enginePower.from = this.filtersForm.value.powerFrom[0].code;
        if (this.filtersForm.value.powerTo == 'null' || !this.filtersForm.value.powerTo || !this.filtersForm.value.powerTo[0])
            enginePower.to = null;
        else
            enginePower.to = this.filtersForm.value.powerTo[0].code;
        if (this.filtersForm.value.engineFrom == 'null' || !this.filtersForm.value.engineFrom || !this.filtersForm.value.engineFrom[0])
            engineSize.from = null;
        else
            engineSize.from = this.filtersForm.value.engineFrom[0].code;
        if (this.filtersForm.value.engineTo == 'null' || !this.filtersForm.value.engineTo || !this.filtersForm.value.engineTo[0])
            engineSize.to = null;
        else
            engineSize.to = this.filtersForm.value.engineTo[0].code;
        //
        if (this.filtersForm.value.fuelType == null || this.filtersForm.value.fuelType == 'null')
            fuelTypeList = null;
        else {
            for (let i = 0; i < this.filtersForm.value.fuelType.length; i++) {
                fuelTypeList.push(this.filtersForm.value.fuelType[i].code);
            }
        }
        if (this.filtersForm.value.bodyType == null || this.filtersForm.value.bodyType == 'null')
            bodyTypeList = null;
        else {
            for (let i = 0; i < this.filtersForm.value.bodyType.length; i++) {
                bodyTypeList.push(this.filtersForm.value.bodyType[i].code);
            }
        }
        if (this.filtersForm.value.transmission == null || this.filtersForm.value.transmission == 'null')
            transmissionList = null;
        else {
            for (let i = 0; i < this.filtersForm.value.transmission.length; i++) {
                transmissionList.push(this.filtersForm.value.transmission[i].code);
            }
        }
        if (this.filtersForm.value.drivetrain == null || this.filtersForm.value.drivetrain == 'null')
            driveList = null;
        else {
            for (let i = 0; i < this.filtersForm.value.drivetrain.length; i++) {
                driveList.push(this.filtersForm.value.drivetrain[i].code);
            }
        }
        let searchParameters = {
            "searchCriteria": {
                "include": {
                    "vehiclesForSale": this.filtersForm.value.onSaleCheck, // Need to extract disabled checkbxes from searchCriteria and then send it like null
                    "vehiclesAlreadySold": this.filtersForm.value.soldCheck,
                    "privateSales": this.filtersForm.value.privateCheck,
                    "dealerSales": this.filtersForm.value.dealerCheck
                },
                mileage,
                year,
                enginePower,
                engineSize,
                fuelTypeList,
                bodyTypeList,
                transmissionList,
                driveList,
                "distance": this.filtersForm.value.distance,
                "keyword": this.filtersForm.value.keywords
            }
        };
        // console.log(searchParameters);
        this.advertsUpdate.emit(searchParameters);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FiltersComponent, deps: [{ token: LiveRetailLibService }, { token: FiltersOptionsService }, { token: i3$1.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: FiltersComponent, selector: "app-filters", inputs: { ownVehicle: "ownVehicle" }, outputs: { advertsUpdate: "advertsUpdate" }, viewQueries: [{ propertyName: "collapseFiltersDiv", first: true, predicate: ["collapseFiltersDiv"], descendants: true }], ngImport: i0, template: "<button type=\"button\" class=\"toggle-filters--btn\" (click)=\"toggleFiltersLink()\">\r\n  {{filtersLinkTxt}}\r\n</button>\r\n\r\n<form [@collapse]=\"collapseFilters\" [formGroup]=\"filtersForm\" (ngSubmit)=\"postData()\" class=\"collapsible-form\">\r\n  <div class=\"accordion--container\" #collapseFiltersDiv id=\"collapseFilters\">\r\n    <div class=\"filters--content row justify-content-between\">\r\n      <div class=\"items--container flex-column col-lg col-md-4 col-sm-6 input-group\">\r\n        <label for=\"\">{{ filtersProps.mileage | uppercase }}</label>\r\n        <div class=\"filter--item flex-row input-group\">\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"mileageFrom\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"mileageList\"\r\n            formControlName=\"mileageFrom\">\r\n          </ng-multiselect-dropdown>\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"mileageTo\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"mileageList\"\r\n            formControlName=\"mileageTo\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n        <div class=\"filter--item\">\r\n          <label for=\"searchTerm\">{{ filtersProps.keywords | uppercase }}</label>\r\n          <input type=\"text\" name=\"searchTerm\" class=\"form-control h35\" formControlName=\"keywords\">\r\n        </div>\r\n      </div>\r\n      <div class=\"items--container flex-column col-lg col-md-4 col-sm-6 input-group\">\r\n        <label for=\"\">{{ filtersProps.year | uppercase }}</label>\r\n        <div class=\"filter--item flex-row input-group\">\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"yearFrom\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"yearsInterval\"\r\n            formControlName=\"yearFrom\">\r\n          </ng-multiselect-dropdown>\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"yearTo\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"yearsInterval\"\r\n            formControlName=\"yearTo\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n        <label for=\"\">{{ filtersProps.engineSize | uppercase }}</label>\r\n        <div class=\"filter--item flex-row input-group\">\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"engineFrom\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"searchCriteria?.engineSizeList\"\r\n            formControlName=\"engineFrom\">\r\n          </ng-multiselect-dropdown>\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"engineTo\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"searchCriteria?.engineSizeList\"\r\n            formControlName=\"engineTo\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n\r\n      </div>\r\n      <div class=\"items--container flex-column col-lg col-md-4 col-sm-6 input-group\">\r\n        <label for=\"fuelType\">{{ filtersProps.fuel | uppercase }}</label>\r\n        <div class=\"filter--item\">\r\n          <ng-multiselect-dropdown class=\"h35\"\r\n            name=\"fuelType\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettings\"\r\n            [data]=\"searchCriteria?.fuelTypeList\"\r\n            formControlName=\"fuelType\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n        <label for=\"\">{{ filtersProps.body | uppercase }}</label>\r\n        <div class=\"filter--item\">\r\n          <ng-multiselect-dropdown class=\"h35\"\r\n            name=\"bodyType\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettings\"\r\n            [data]=\"searchCriteria?.bodyTypeList\"\r\n            formControlName=\"bodyType\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n      </div>\r\n      <div class=\"items--container flex-column col-lg col-md-6 col-sm-6 input-group\">\r\n        <label for=\"\">{{ filtersProps.transmission | uppercase }}</label>\r\n        <div class=\"filter--item\">\r\n          <ng-multiselect-dropdown class=\"h35\"\r\n            name=\"transmission\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettings\"\r\n            [data]=\"searchCriteria?.transmissionList\"\r\n            formControlName=\"transmission\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n        <label for=\"\">{{ filtersProps.drive | uppercase }}</label>\r\n        <div class=\"filter--item\">\r\n          <ng-multiselect-dropdown class=\"h35\"\r\n            name=\"drivetrain\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettings\"\r\n            [data]=\"searchCriteria?.driveList\"\r\n            formControlName=\"drivetrain\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n      </div>\r\n      <div class=\"items--container flex-column col-lg col-md-6 offset-md-0 col-sm-8 offset-sm-2 input-group\">\r\n        <label for=\"\">{{ filtersProps.power | uppercase }}</label>\r\n        <div class=\"filter--item flex-row input-group\">\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"powerFrom\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"searchCriteria?.enginePowerList\"\r\n            formControlName=\"powerFrom\">\r\n          </ng-multiselect-dropdown>\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"powerTo\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"searchCriteria?.enginePowerList\"\r\n            formControlName=\"powerTo\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n        <label for=\"\">{{ filtersProps.distance | uppercase }}</label>\r\n        <div class=\"filter--item\">\r\n          <select class=\"form-select h35\" id=\"inputGroupSelect13\" formControlName=\"distance\">\r\n            <option *ngFor=\"let distance of searchCriteria?.distanceList;let i = index\" [value]=\"distance.code\">\r\n                <span *ngIf=\"distance.description != 'ALL'\">{{distance.description}}</span>\r\n                <span *ngIf=\"distance.description == 'ALL'\">{{ filtersProps.wholeCountry }}</span>\r\n            </option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"filters--footer\">\r\n      <span class=\"info tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"filtersTooltip\" placement=\"bottom-left\" tooltipClass=\"tooltip-style-1\">\r\n        <img\r\n          src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQ1Ljk5OSA0NS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTM5LjI2NCw2LjczNmMtOC45ODItOC45ODEtMjMuNTQ1LTguOTgyLTMyLjUyOCwwYy04Ljk4Miw4Ljk4Mi04Ljk4MSwyMy41NDUsMCwzMi41MjhjOC45ODIsOC45OCwyMy41NDUsOC45ODEsMzIuNTI4LDAgICAgQzQ4LjI0NSwzMC4yODEsNDguMjQ0LDE1LjcxOSwzOS4yNjQsNi43MzZ6IE0yNS45OTksMzNjMCwxLjY1Ny0xLjM0MywzLTMsM3MtMy0xLjM0My0zLTNWMjFjMC0xLjY1NywxLjM0My0zLDMtM3MzLDEuMzQzLDMsM1YzM3ogICAgIE0yMi45NDYsMTUuODcyYy0xLjcyOCwwLTIuODgtMS4yMjQtMi44NDQtMi43MzVjLTAuMDM2LTEuNTg0LDEuMTE2LTIuNzcxLDIuODc5LTIuNzcxYzEuNzY0LDAsMi44OCwxLjE4OCwyLjkxNywyLjc3MSAgICBDMjUuODk3LDE0LjY0OCwyNC43NDYsMTUuODcyLDIyLjk0NiwxNS44NzJ6IiBmaWxsPSIjMDA4ZmM4IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg==\" />\r\n      </span>\r\n      <ng-template #filtersTooltip>\r\n        <div class=\"dc-style--tooltip\">\r\n          <p>{{ filtersProps?.filtersTooltip.content }}</p>\r\n          <ul>\r\n            <li>{{ filtersProps?.filtersTooltip.list.first }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.second }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.third }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.fourth }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.fifth }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.sixth }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.seventh}}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.eighth }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.ninth }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.tenth }}</li>\r\n          </ul>\r\n        </div>\r\n      </ng-template>\r\n      <button type=\"submit\" class=\"btn btn-md btn-search\">{{ filtersProps.buttonSearch | uppercase }}</button>\r\n      <div class=\"checkboxes--container\">\r\n        <div class=\"item-checkbox\">\r\n          <label for=\"vehicles\">{{ filtersProps.vehicles | uppercase }}:</label>\r\n          <span name=\"vehicles\" class=\"values--container\">\r\n            <input type=\"checkbox\" class=\"checkbox\" name=\"onSale\" formControlName=\"onSaleCheck\"\r\n              id=\"onSaleCheck\">{{ filtersProps.onSaleVehicles | uppercase }}\r\n            <input type=\"checkbox\" class=\"checkbox\" name=\"sold\" formControlName=\"soldCheck\"\r\n              id=\"soldCheck\">{{ filtersProps.soldVehicles | uppercase }}\r\n          </span>\r\n        </div>\r\n        <div class=\"item-checkbox\" *ngIf=\"showSellerFilters\">\r\n          <label for=\"seller\">{{ filtersProps.seller | uppercase }}:</label>\r\n          <span name=\"seller\" class=\"values--container\">\r\n            <input type=\"checkbox\" class=\"checkbox\" name=\"dealer\" formControlName=\"dealerCheck\"\r\n              id=\"dealerCheck\">{{ filtersProps.dealerSeller | uppercase }}\r\n            <input type=\"checkbox\" class=\"checkbox\" name=\"private\" formControlName=\"privateCheck\"\r\n              id=\"privateCheck\">{{ filtersProps.privateSeller | uppercase }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}.collapsible-form{padding:0 2px}.accordion--container{padding-bottom:40px}@media (max-width: 992px){.accordion--container{padding-bottom:20px}}.filters--content{font-family:Aileron semibold;padding-top:10px}.filter--item{margin-bottom:10px;flex-wrap:nowrap}.toggle-filters--btn{font-family:Aileron bold;font-size:18px;margin-left:-5px;border:none;outline:none;background:none;color:#008fc8}label{color:#a1a9ac;font-size:16px;letter-spacing:1px}select{cursor:pointer;background-color:#fff!important;border-radius:4px!important;border:1px solid #adadad}.form-select:focus{border-color:#adadad}input:disabled,select:disabled,.checkbox:disabled{cursor:not-allowed}input:not(.checkbox),select{box-sizing:border-box;height:35px;border-radius:2px;background-color:#f5f7f7;box-shadow:inset 0 1px 3px #232c3226}input:not(.checkbox):focus,select:focus{box-shadow:none}select{box-shadow:0 1px 2px #232c3240}.btn-search{width:200px;height:30px;display:flex;justify-content:center;align-items:center;background-color:#a1a9ac;font-family:Aileron bold;color:#fff;transition:background 1s,color 1s;-webkit-box-shadow:2px 2px 3px 1px rgba(0,0,0,.5);-moz-box-shadow:2px 2px 3px 1px rgba(0,0,0,.5);box-shadow:2px 2px 3px 1px #00000080}.btn-search:hover{background-color:#dae0e1;color:#232c32;transition:background 1s,color 1s}.btn-search:active{-webkit-box-shadow:2px 2px 3px 1px rgba(0,0,0,.9);-moz-box-shadow:2px 2px 3px 1px rgba(0,0,0,.9);box-shadow:2px 2px 3px 1px #000000e6}@media (max-width: 992px){.btn-search{width:100%}}.filters--footer{position:relative;display:flex;justify-content:space-between}@media (max-width: 992px){.filters--footer{flex-direction:column-reverse;justify-content:center;align-items:center}}.checkboxes--container{display:flex}@media (max-width: 992px){.checkboxes--container{margin-bottom:10px}}@media (max-width: 992px){.checkboxes--container{flex-direction:column}}.checkbox{margin-right:5px}.checkbox:not(:first-child){margin-left:10px}.values--container{display:flex;align-items:center;margin-right:10px}.item-checkbox{display:flex;align-items:center;font-family:Aileron semibold;font-size:14px}.item-checkbox label{margin-bottom:0;margin-right:5px}span.tooltip-trigger{position:absolute;left:210px;top:0}@media (max-width: 992px){span.tooltip-trigger{left:5px;top:30px}}\n"], dependencies: [{ kind: "directive", type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i5.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { kind: "component", type: i6.MultiSelectComponent, selector: "ng-multiselect-dropdown", inputs: ["placeholder", "disabled", "settings", "data"], outputs: ["onFilterChange", "onDropDownClose", "onSelect", "onDeSelect", "onSelectAll", "onDeSelectAll"] }, { kind: "pipe", type: i4.UpperCasePipe, name: "uppercase" }], animations: [
            trigger('collapse', [
                state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE, opacity: 1, overflow: 'initial' })),
                state('true', style({ height: '0', visibility: 'hidden', opacity: 0, overflow: 'hidden' })),
                transition('false => true', group([
                    animate(animationTime + 'ms ease-in', style({ height: '0', visibility: 'hidden', opacity: 0 })),
                    // overflow hidden just after animation starts
                    animate(animationTime + 'ms steps(1, start)', style({ overflow: 'hidden' }))
                ])),
                transition('true => false', group([
                    animate(animationTime + 'ms ease-out', style({ height: AUTO_STYLE, visibility: AUTO_STYLE, opacity: 1 })),
                    // overflow initial just before animation ends
                    animate(animationTime + 'ms steps(1, end)', style({ overflow: 'initial' }))
                ])),
            ])
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FiltersComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-filters', animations: [
                        trigger('collapse', [
                            state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE, opacity: 1, overflow: 'initial' })),
                            state('true', style({ height: '0', visibility: 'hidden', opacity: 0, overflow: 'hidden' })),
                            transition('false => true', group([
                                animate(animationTime + 'ms ease-in', style({ height: '0', visibility: 'hidden', opacity: 0 })),
                                // overflow hidden just after animation starts
                                animate(animationTime + 'ms steps(1, start)', style({ overflow: 'hidden' }))
                            ])),
                            transition('true => false', group([
                                animate(animationTime + 'ms ease-out', style({ height: AUTO_STYLE, visibility: AUTO_STYLE, opacity: 1 })),
                                // overflow initial just before animation ends
                                animate(animationTime + 'ms steps(1, end)', style({ overflow: 'initial' }))
                            ])),
                        ])
                    ], template: "<button type=\"button\" class=\"toggle-filters--btn\" (click)=\"toggleFiltersLink()\">\r\n  {{filtersLinkTxt}}\r\n</button>\r\n\r\n<form [@collapse]=\"collapseFilters\" [formGroup]=\"filtersForm\" (ngSubmit)=\"postData()\" class=\"collapsible-form\">\r\n  <div class=\"accordion--container\" #collapseFiltersDiv id=\"collapseFilters\">\r\n    <div class=\"filters--content row justify-content-between\">\r\n      <div class=\"items--container flex-column col-lg col-md-4 col-sm-6 input-group\">\r\n        <label for=\"\">{{ filtersProps.mileage | uppercase }}</label>\r\n        <div class=\"filter--item flex-row input-group\">\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"mileageFrom\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"mileageList\"\r\n            formControlName=\"mileageFrom\">\r\n          </ng-multiselect-dropdown>\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"mileageTo\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"mileageList\"\r\n            formControlName=\"mileageTo\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n        <div class=\"filter--item\">\r\n          <label for=\"searchTerm\">{{ filtersProps.keywords | uppercase }}</label>\r\n          <input type=\"text\" name=\"searchTerm\" class=\"form-control h35\" formControlName=\"keywords\">\r\n        </div>\r\n      </div>\r\n      <div class=\"items--container flex-column col-lg col-md-4 col-sm-6 input-group\">\r\n        <label for=\"\">{{ filtersProps.year | uppercase }}</label>\r\n        <div class=\"filter--item flex-row input-group\">\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"yearFrom\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"yearsInterval\"\r\n            formControlName=\"yearFrom\">\r\n          </ng-multiselect-dropdown>\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"yearTo\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"yearsInterval\"\r\n            formControlName=\"yearTo\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n        <label for=\"\">{{ filtersProps.engineSize | uppercase }}</label>\r\n        <div class=\"filter--item flex-row input-group\">\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"engineFrom\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"searchCriteria?.engineSizeList\"\r\n            formControlName=\"engineFrom\">\r\n          </ng-multiselect-dropdown>\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"engineTo\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"searchCriteria?.engineSizeList\"\r\n            formControlName=\"engineTo\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n\r\n      </div>\r\n      <div class=\"items--container flex-column col-lg col-md-4 col-sm-6 input-group\">\r\n        <label for=\"fuelType\">{{ filtersProps.fuel | uppercase }}</label>\r\n        <div class=\"filter--item\">\r\n          <ng-multiselect-dropdown class=\"h35\"\r\n            name=\"fuelType\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettings\"\r\n            [data]=\"searchCriteria?.fuelTypeList\"\r\n            formControlName=\"fuelType\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n        <label for=\"\">{{ filtersProps.body | uppercase }}</label>\r\n        <div class=\"filter--item\">\r\n          <ng-multiselect-dropdown class=\"h35\"\r\n            name=\"bodyType\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettings\"\r\n            [data]=\"searchCriteria?.bodyTypeList\"\r\n            formControlName=\"bodyType\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n      </div>\r\n      <div class=\"items--container flex-column col-lg col-md-6 col-sm-6 input-group\">\r\n        <label for=\"\">{{ filtersProps.transmission | uppercase }}</label>\r\n        <div class=\"filter--item\">\r\n          <ng-multiselect-dropdown class=\"h35\"\r\n            name=\"transmission\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettings\"\r\n            [data]=\"searchCriteria?.transmissionList\"\r\n            formControlName=\"transmission\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n        <label for=\"\">{{ filtersProps.drive | uppercase }}</label>\r\n        <div class=\"filter--item\">\r\n          <ng-multiselect-dropdown class=\"h35\"\r\n            name=\"drivetrain\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettings\"\r\n            [data]=\"searchCriteria?.driveList\"\r\n            formControlName=\"drivetrain\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n      </div>\r\n      <div class=\"items--container flex-column col-lg col-md-6 offset-md-0 col-sm-8 offset-sm-2 input-group\">\r\n        <label for=\"\">{{ filtersProps.power | uppercase }}</label>\r\n        <div class=\"filter--item flex-row input-group\">\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"powerFrom\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"searchCriteria?.enginePowerList\"\r\n            formControlName=\"powerFrom\">\r\n          </ng-multiselect-dropdown>\r\n          <ng-multiselect-dropdown class=\"h35 w100\"\r\n            name=\"powerTo\"\r\n            [placeholder]=\"filtersProps?.nullValid\"\r\n            [settings]=\"dropdownSettingsSingle\"\r\n            [data]=\"searchCriteria?.enginePowerList\"\r\n            formControlName=\"powerTo\">\r\n          </ng-multiselect-dropdown>\r\n        </div>\r\n        <label for=\"\">{{ filtersProps.distance | uppercase }}</label>\r\n        <div class=\"filter--item\">\r\n          <select class=\"form-select h35\" id=\"inputGroupSelect13\" formControlName=\"distance\">\r\n            <option *ngFor=\"let distance of searchCriteria?.distanceList;let i = index\" [value]=\"distance.code\">\r\n                <span *ngIf=\"distance.description != 'ALL'\">{{distance.description}}</span>\r\n                <span *ngIf=\"distance.description == 'ALL'\">{{ filtersProps.wholeCountry }}</span>\r\n            </option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"filters--footer\">\r\n      <span class=\"info tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"filtersTooltip\" placement=\"bottom-left\" tooltipClass=\"tooltip-style-1\">\r\n        <img\r\n          src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQ1Ljk5OSA0NS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTM5LjI2NCw2LjczNmMtOC45ODItOC45ODEtMjMuNTQ1LTguOTgyLTMyLjUyOCwwYy04Ljk4Miw4Ljk4Mi04Ljk4MSwyMy41NDUsMCwzMi41MjhjOC45ODIsOC45OCwyMy41NDUsOC45ODEsMzIuNTI4LDAgICAgQzQ4LjI0NSwzMC4yODEsNDguMjQ0LDE1LjcxOSwzOS4yNjQsNi43MzZ6IE0yNS45OTksMzNjMCwxLjY1Ny0xLjM0MywzLTMsM3MtMy0xLjM0My0zLTNWMjFjMC0xLjY1NywxLjM0My0zLDMtM3MzLDEuMzQzLDMsM1YzM3ogICAgIE0yMi45NDYsMTUuODcyYy0xLjcyOCwwLTIuODgtMS4yMjQtMi44NDQtMi43MzVjLTAuMDM2LTEuNTg0LDEuMTE2LTIuNzcxLDIuODc5LTIuNzcxYzEuNzY0LDAsMi44OCwxLjE4OCwyLjkxNywyLjc3MSAgICBDMjUuODk3LDE0LjY0OCwyNC43NDYsMTUuODcyLDIyLjk0NiwxNS44NzJ6IiBmaWxsPSIjMDA4ZmM4IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg==\" />\r\n      </span>\r\n      <ng-template #filtersTooltip>\r\n        <div class=\"dc-style--tooltip\">\r\n          <p>{{ filtersProps?.filtersTooltip.content }}</p>\r\n          <ul>\r\n            <li>{{ filtersProps?.filtersTooltip.list.first }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.second }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.third }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.fourth }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.fifth }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.sixth }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.seventh}}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.eighth }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.ninth }}</li>\r\n            <li>{{ filtersProps?.filtersTooltip.list.tenth }}</li>\r\n          </ul>\r\n        </div>\r\n      </ng-template>\r\n      <button type=\"submit\" class=\"btn btn-md btn-search\">{{ filtersProps.buttonSearch | uppercase }}</button>\r\n      <div class=\"checkboxes--container\">\r\n        <div class=\"item-checkbox\">\r\n          <label for=\"vehicles\">{{ filtersProps.vehicles | uppercase }}:</label>\r\n          <span name=\"vehicles\" class=\"values--container\">\r\n            <input type=\"checkbox\" class=\"checkbox\" name=\"onSale\" formControlName=\"onSaleCheck\"\r\n              id=\"onSaleCheck\">{{ filtersProps.onSaleVehicles | uppercase }}\r\n            <input type=\"checkbox\" class=\"checkbox\" name=\"sold\" formControlName=\"soldCheck\"\r\n              id=\"soldCheck\">{{ filtersProps.soldVehicles | uppercase }}\r\n          </span>\r\n        </div>\r\n        <div class=\"item-checkbox\" *ngIf=\"showSellerFilters\">\r\n          <label for=\"seller\">{{ filtersProps.seller | uppercase }}:</label>\r\n          <span name=\"seller\" class=\"values--container\">\r\n            <input type=\"checkbox\" class=\"checkbox\" name=\"dealer\" formControlName=\"dealerCheck\"\r\n              id=\"dealerCheck\">{{ filtersProps.dealerSeller | uppercase }}\r\n            <input type=\"checkbox\" class=\"checkbox\" name=\"private\" formControlName=\"privateCheck\"\r\n              id=\"privateCheck\">{{ filtersProps.privateSeller | uppercase }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}.collapsible-form{padding:0 2px}.accordion--container{padding-bottom:40px}@media (max-width: 992px){.accordion--container{padding-bottom:20px}}.filters--content{font-family:Aileron semibold;padding-top:10px}.filter--item{margin-bottom:10px;flex-wrap:nowrap}.toggle-filters--btn{font-family:Aileron bold;font-size:18px;margin-left:-5px;border:none;outline:none;background:none;color:#008fc8}label{color:#a1a9ac;font-size:16px;letter-spacing:1px}select{cursor:pointer;background-color:#fff!important;border-radius:4px!important;border:1px solid #adadad}.form-select:focus{border-color:#adadad}input:disabled,select:disabled,.checkbox:disabled{cursor:not-allowed}input:not(.checkbox),select{box-sizing:border-box;height:35px;border-radius:2px;background-color:#f5f7f7;box-shadow:inset 0 1px 3px #232c3226}input:not(.checkbox):focus,select:focus{box-shadow:none}select{box-shadow:0 1px 2px #232c3240}.btn-search{width:200px;height:30px;display:flex;justify-content:center;align-items:center;background-color:#a1a9ac;font-family:Aileron bold;color:#fff;transition:background 1s,color 1s;-webkit-box-shadow:2px 2px 3px 1px rgba(0,0,0,.5);-moz-box-shadow:2px 2px 3px 1px rgba(0,0,0,.5);box-shadow:2px 2px 3px 1px #00000080}.btn-search:hover{background-color:#dae0e1;color:#232c32;transition:background 1s,color 1s}.btn-search:active{-webkit-box-shadow:2px 2px 3px 1px rgba(0,0,0,.9);-moz-box-shadow:2px 2px 3px 1px rgba(0,0,0,.9);box-shadow:2px 2px 3px 1px #000000e6}@media (max-width: 992px){.btn-search{width:100%}}.filters--footer{position:relative;display:flex;justify-content:space-between}@media (max-width: 992px){.filters--footer{flex-direction:column-reverse;justify-content:center;align-items:center}}.checkboxes--container{display:flex}@media (max-width: 992px){.checkboxes--container{margin-bottom:10px}}@media (max-width: 992px){.checkboxes--container{flex-direction:column}}.checkbox{margin-right:5px}.checkbox:not(:first-child){margin-left:10px}.values--container{display:flex;align-items:center;margin-right:10px}.item-checkbox{display:flex;align-items:center;font-family:Aileron semibold;font-size:14px}.item-checkbox label{margin-bottom:0;margin-right:5px}span.tooltip-trigger{position:absolute;left:210px;top:0}@media (max-width: 992px){span.tooltip-trigger{left:5px;top:30px}}\n"] }]
        }], ctorParameters: () => [{ type: LiveRetailLibService }, { type: FiltersOptionsService }, { type: i3$1.UntypedFormBuilder }], propDecorators: { advertsUpdate: [{
                type: Output
            }], ownVehicle: [{
                type: Input
            }], collapseFiltersDiv: [{
                type: ViewChild,
                args: ['collapseFiltersDiv']
            }] } });

class VehicleDescriptionService {
    constructor(http) {
        this.http = http;
        // URL which returns list of JSON items (API end-point URL)
        this.URL = '/live-retail-api/vehicle/description';
    }
    // this method returns list-of-items in form of Observable
    // every HTTTP call returns Observable object
    resolveVhDescription(isoCountry, isoLanguage, natCode) {
        // console.log('Request is sent!');
        // Using the GET method
        return this.http.get(this.URL + '/' + isoCountry + '/' + isoLanguage + '/' + natCode, Headers);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: VehicleDescriptionService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: VehicleDescriptionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: VehicleDescriptionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class PriceHistoryService {
    constructor(http) {
        this.http = http;
        // URL which returns list of JSON items (API end-point URL)
        this.URL = '/live-retail-api/vehicle/priceHistory';
    }
    // every HTTTP call returns Observable object
    resolvePriceHistory(isoCountry, id) {
        // console.log('Request is sent!');
        return this.http.get(this.URL + '/' + isoCountry + '/' + id, Headers);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: PriceHistoryService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: PriceHistoryService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: PriceHistoryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class PriceChangesMappingPipe {
    constructor(dataService) {
        this.dataService = dataService;
        this.resultsProps = this.dataService.getLanguageProperties().results;
    }
    transform(val) {
        if (!val) {
            return;
        }
        // console.log(val);
        if (val == "n" || val == "original") {
            return this.resultsProps.tooltips.priceHistory.original;
        }
        if (val == 'up' || val == "price_change" || val == "price") {
            return this.resultsProps.tooltips.priceHistory.priceCh;
        }
        if (val == "d" || val == "removed") {
            return this.resultsProps.tooltips.priceHistory.removed;
        }
        if (val == "r" || val == "new" || val == "new_observation") {
            return this.resultsProps.tooltips.priceHistory.new;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: PriceChangesMappingPipe, deps: [{ token: LiveRetailLibService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: PriceChangesMappingPipe, name: "priceChangesMapping" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: PriceChangesMappingPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'priceChangesMapping'
                }]
        }], ctorParameters: () => [{ type: LiveRetailLibService }] });

const rotate = { 'asc': 'desc', 'desc': '', '': 'asc' };
const compare = (v1, v2) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
class NgbdSortableHeader {
    constructor() {
        this.sortable = '';
        this.direction = '';
        this.sort = new EventEmitter();
    }
    rotate() {
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.sortable, direction: this.direction });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: NgbdSortableHeader, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.11", type: NgbdSortableHeader, selector: "th[sortable]", inputs: { sortable: "sortable", direction: "direction" }, outputs: { sort: "sort" }, host: { listeners: { "click": "rotate()" }, properties: { "class.asc": "direction === \"asc\"", "class.desc": "direction === \"desc\"" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: NgbdSortableHeader, decorators: [{
            type: Directive,
            args: [{
                    selector: 'th[sortable]',
                    host: {
                        '[class.asc]': 'direction === "asc"',
                        '[class.desc]': 'direction === "desc"',
                        '(click)': 'rotate()'
                    }
                }]
        }], propDecorators: { sortable: [{
                type: Input
            }], direction: [{
                type: Input
            }], sort: [{
                type: Output
            }] } });
// ------
class ResultsComponent {
    constructor(dataService, VhDescriptionService, PriceHistoryService) {
        this.dataService = dataService;
        this.VhDescriptionService = VhDescriptionService;
        this.PriceHistoryService = PriceHistoryService;
        this.advertsSuscription = new Subscription();
        this.currencySymbolBefore = false;
    }
    ngOnInit() {
        this.lngProperties = this.dataService.getLanguageProperties().config;
        this.mktProps = this.dataService.getMarketConfig().config;
        this.resultsProps = this.dataService.getLanguageProperties().results;
        if (this.mktProps.currencySymbol == '£') {
            this.currencySymbolBefore = true;
        }
        else {
            this.currencySymbolBefore = false;
        }
    }
    ngAfterViewChecked() {
        this.addPriceBar(this.listOfVehicles);
        this.initialListOfVehicles = this.listOfVehicles;
        // console.log(this.initialListOfVehicles)
    }
    getVhDescription(natCode) {
        this.tooltipLoadingFlag = true;
        this.vhDescription$ = this.VhDescriptionService.resolveVhDescription(this.ownVehicle.ownVehicle.isoCountry, this.ownVehicle.ownVehicle.isoLanguage, natCode);
        this.vhDescription$.subscribe(a => {
            this.vehicleDescription = a;
            this.tooltipLoadingFlag = false;
            // console.log(this.vehicleDescription)
        });
    }
    getPriceHistory(id) {
        this.tooltipLoadingFlag = true;
        this.priceHistory$ = this.PriceHistoryService.resolvePriceHistory(this.ownVehicle.ownVehicle.isoCountry, id);
        this.priceHistory$.subscribe(a => {
            this.priceHistory = a;
            this.tooltipLoadingFlag = false;
            // console.log(this.priceHistory)
        });
    }
    addPriceBar(vehicles) {
        for (let i = 0; i <= vehicles?.length; i++) {
            if (vehicles[i]) {
                let askPrice = vehicles[i].askingPrice;
                let regionalPrice = vehicles[i].regionalAskingPrice;
                let priceDifference = Math.abs(askPrice - regionalPrice);
                let totalPrice = askPrice + regionalPrice + priceDifference;
                let askPricePercentage = (100 * askPrice) / totalPrice;
                let regionalPricePercentage = (100 * regionalPrice) / totalPrice;
                document.getElementById('priceBarOne' + i).style.width = askPricePercentage + '%';
                document.getElementById('priceBarTwo' + i).style.width = regionalPricePercentage + '%';
            }
        }
    }
    onSort({ column, direction }) {
        // resetting other headers
        this.headers.forEach(header => {
            if (header.sortable !== column) {
                header.direction = '';
            }
        });
        // sorting columns
        if (direction === '' || column === '') {
            this.listOfVehicles = this.initialListOfVehicles;
        }
        else {
            this.listOfVehicles = [...this.listOfVehicles].sort((a, b) => {
                const res = compare(a[column], b[column]);
                return direction === 'asc' ? res : -res;
            });
        }
    }
    checkAll(ev) {
        this.listOfVehicles.forEach(x => x.state = ev.target.checked);
        console.log(ev);
    }
    isAllChecked() {
        return this.listOfVehicles.every(_ => _.state);
    }
    ngOnDestroy() {
        this.advertsSuscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ResultsComponent, deps: [{ token: LiveRetailLibService }, { token: VehicleDescriptionService }, { token: PriceHistoryService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: ResultsComponent, selector: "app-results", inputs: { listOfVehicles: "listOfVehicles", ownVehicle: "ownVehicle" }, viewQueries: [{ propertyName: "headers", predicate: NgbdSortableHeader, descendants: true }], ngImport: i0, template: "<div class=\"table-responsive\">\r\n  <table class=\"table\">\r\n    <thead>\r\n      <tr>\r\n        <!-- <th scope=\"col\" class=\"txt-left\" style=\"padding-right: 0;\">\r\n          <input type=\"checkbox\" class=\"exportCheckboxes\" id=\"pdfExportGroupSelector\" name=\"all\" [checked]=\"isAllChecked()\" (change)=\"checkAll($event)\">\r\n        </th> -->\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"officialTypeDescription\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.vehicle | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"priceDifferenceCurrency\" (sort)=\"onSort($event)\">\r\n          <div class=\"priceBar--header\">\r\n            <div>{{ resultsProps.askPrice | uppercase }}</div>\r\n            <span style=\"margin: 0 5px 0 5px;\">{{ resultsProps.diffPrice | uppercase }}</span>\r\n            <div>{{ resultsProps.lrPrice | uppercase }}</div>\r\n          </div>\r\n        </th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"similarityCategory\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.similarity | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"distance\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.distance | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"odometer\" (sort)=\"onSort($event)\">\r\n          {{mktProps.odometerAbbreviation | uppercase }}</th> <!--{{ resultsProps.odometer -->\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"regDate\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.regDate | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"sellerName\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.company | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"stockDays\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.stockDays | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"numberOfPriceChanges\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.priceChanges | uppercase }}</th>\r\n      </tr>\r\n    </thead>\r\n    <div class=\"loader--container\">\r\n      <div *ngIf=\"!listOfVehicles\" class=\"lds-ellipsis\"><div></div><div></div><div></div><div></div></div>\r\n    </div>\r\n    <tbody>\r\n      <tr *ngFor=\"let i = index;let vehicle of listOfVehicles\">\r\n        <!-- <th scope=\"row\" class=\"checkbox--item\">\r\n          <input type=\"checkbox\" class=\"exportCheckboxes\" value=\"{{vehicle.id}}\" [(ngModel)]=\"vehicle.state\">\r\n        </th> -->\r\n        <td>\r\n          <div class=\"vh-desc\">\r\n            <span *ngIf=\"vehicle.advertisements?.length >= 1\" class=\"pic hasLinks\" [ngbTooltip]=\"adLinks\"\r\n              tooltipClass=\"tooltip-style-1\" placement=\"bottom-left\">\r\n              <ng-template #adLinks>\r\n                <div *ngIf=\"vehicle.imageLink\" class=\"img-tooltip--container\">\r\n                    <img [src]=\"vehicle.imageLink\" class=\"img-zoomed\">\r\n                </div>\r\n                <table class=\"table table-striped tooltip-table\">\r\n                  <thead>\r\n                    <tr>\r\n                      <th colspan=\"1\">{{resultsProps.adLinks | uppercase }}</th>\r\n                    </tr>\r\n                  </thead>\r\n                  <tbody>\r\n                    <tr *ngFor=\"let ad of vehicle.advertisements\">\r\n                      <td><a [href]=\"ad.originalWebAddress\" target=\"_blank\">{{ad.portalName}}</a></td>\r\n                    </tr>\r\n                  </tbody>\r\n                </table>\r\n              </ng-template>\r\n              <img *ngIf=\"vehicle.imageLink != null\" [src]=\"vehicle.imageLink || camaraImg\">\r\n              <img *ngIf=\"vehicle.imageLink == null\"\r\n                src=\"data:image/svg+xml;base64,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\" />\r\n            </span>\r\n            <span *ngIf=\"vehicle.advertisements == null && vehicle.dataOrigin != 'OwnVehicle' || vehicle.isSold\" class=\"pic\">\r\n              <img *ngIf=\"vehicle.imageLink != null\" [src]=\"vehicle.imageLink || camaraImg\">\r\n              <img *ngIf=\"vehicle.imageLink == null\"\r\n                src=\"data:image/svg+xml;base64,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\" />\r\n            </span>\r\n            <span *ngIf=\"vehicle.dataOrigin === 'OwnVehicle'\" class=\"pic ownVehicleFlagcontainer\">\r\n              <small style=\"display: flex;text-align: center;margin-top: 5px;\"> {{ resultsProps?.ownVehicle }} </small>\r\n            </span>\r\n            <span class=\"info tooltip-trigger d-none d-md-block\" [ngClass]=\"{isSoldVehicle: vehicle.isSold}\" [ngbTooltip]=\"vhDescription\" (click)=\"getVhDescription(vehicle.type.natCode)\"\r\n              tooltipClass=\"tooltip-style-1\" placement=\"bottom-left\">{{ vehicle.officialTypeDescription }}</span>\r\n            <span class=\"info d-md-none\" [ngClass]=\"{isSoldVehicle: vehicle.isSold}\">{{ vehicle.officialTypeDescription }}</span>\r\n            <!-- TOOLTIP CONTAINER: Vehicle description -->\r\n            <ng-template #vhDescription>\r\n              <table class=\"table table-striped tooltip-table\">\r\n                <thead>\r\n                  <tr>\r\n                    <th colspan=\"2\">{{ resultsProps.tooltips.vhDescription.header | uppercase }}</th>\r\n                  </tr>\r\n                </thead>\r\n                <div *ngIf=\"tooltipLoadingFlag\" class=\"lds-ellipsis lds-tooltip\"><div></div><div></div><div></div><div></div></div>\r\n                <tbody *ngIf=\"!tooltipLoadingFlag\">\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.make }}</td>\r\n                    <td>{{ vehicleDescription?.make }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.modelSeries }}</td>\r\n                    <td>{{ vehicleDescription?.modelSeries }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.type }}</td>\r\n                    <td>{{ vehicleDescription?.type }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.body }}</td>\r\n                    <td>{{ vehicleDescription?.body }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.doors }}</td>\r\n                    <td>{{ vehicleDescription?.doors }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.seats }}</td>\r\n                    <td>{{vehicleDescription?.seats }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.fuel }}</td>\r\n                    <td>{{ vehicleDescription?.fuel }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.powerKW }}</td>\r\n                    <td>{{ vehicleDescription?.powerKW }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.powerHP }}</td>\r\n                    <td>{{ vehicleDescription?.powerHP }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.cylCubic }}</td>\r\n                    <td>{{ vehicleDescription?.cylCubic }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.cylinders }}</td>\r\n                    <td>{{ vehicleDescription?.cylinders }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.gearBox }}</td>\r\n                    <td>{{ vehicleDescription?.gearBox }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.noOfGears }}</td>\r\n                    <td>{{ vehicleDescription?.noOfGears }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.drive }}</td>\r\n                    <td>{{ vehicleDescription?.drive }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.engineType }}</td>\r\n                    <td>{{ vehicleDescription?.engineType }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.wheelBase }}</td>\r\n                    <td>{{ vehicleDescription?.wheelbase }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.totalWeight }}</td>\r\n                    <td>{{ vehicleDescription?.totalWeight }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.payload }}</td>\r\n                    <td>{{ vehicleDescription?.payload }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.importBegin }}</td>\r\n                    <td>{{ vehicleDescription?.importBegin | date: mktProps.datePattern}}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.importEnd }}</td>\r\n                    <td>{{ vehicleDescription?.importEnd | date: mktProps.datePattern}}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.vhType }}</td>\r\n                    <td>{{ vehicleDescription?.vehicleType }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.nationalCode }}</td>\r\n                    <td>{{ vehicleDescription?.nationalCode }}</td>\r\n                  </tr>\r\n                </tbody>\r\n              </table>\r\n            </ng-template>\r\n            <!-- END OF TOOLTIP CONTAINER -->\r\n          </div>\r\n        </td>\r\n        <td class=\"txt-center\">\r\n          <div id=\"containerPriceBar\">\r\n            <div class=\"labels\">\r\n              <span>\r\n                <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.askingPrice | numberLocale :mktProps.valueSeparator}} {{mktProps.currencySymbol }}</ng-template>\r\n                <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.askingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>      \r\n              </span>\r\n              <span class=\"tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"priceTooltip\" tooltipClass=\"tooltip-style-1\"\r\n                [ngClass]=\"{diffDown: vehicle.priceDifferenceCurrency <= 0,\r\n                            diffUp: vehicle.priceDifferenceCurrency >= 0, \r\n                            diffSame: vehicle.askingPrice == vehicle.regionalAskingPrice}\">\r\n                <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator}} {{mktProps.currencySymbol }}</ng-template>\r\n                <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator }} </ng-template>\r\n              </span>\r\n              <span class=\"d-md-none\" [ngClass]=\"{\r\n                    diffDown: vehicle.priceDifferenceCurrency <= 0,\r\n                    diffUp: vehicle.priceDifferenceCurrency >= 0, \r\n                    diffSame: vehicle.askingPrice == vehicle.regionalAskingPrice}\">\r\n                    <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator}} {{mktProps.currencySymbol }}</ng-template>\r\n                    <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator }} </ng-template>\r\n                  <!-- TOOLTIP CONTAINER: price diff tooltip -->\r\n              <ng-template #priceTooltip>\r\n                <span *ngIf=\"!vehicle?.standardVehicle\">LOADING</span>\r\n                <table class=\"table table-striped tooltip-table price-tooltip--table\">\r\n                  <thead>\r\n                    <tr>\r\n                      <th colspan=\"3\">{{ resultsProps.tooltips.priceDiff.header | uppercase }}</th>\r\n                    </tr>\r\n                  </thead>\r\n                  <tbody>\r\n                    <tr>\r\n                      <td class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.standardVh}}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.standardVehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>        \r\n                      </td> \r\n                    </tr>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.standardVhOdometer }}</td>\r\n                      <td>{{ vehicle.standardVehicle.odometer | numberLocale :mktProps.odometerSeparator}} {{mktProps.odometerAbbreviation}}</td>\r\n                      <td></td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.standardVhRegDate }}</td>\r\n                      <td>{{ vehicle.standardVehicle.regDate | date: mktProps.datePattern }}</td>\r\n                      <td></td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.thisVh }}</td>\r\n                      <td></td>\r\n                      <td></td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.odometerEffect}}</td>\r\n                      <td>{{ vehicle.standardVehicle.odometerDiff | numberLocale :mktProps.odometerSeparator}} {{mktProps.odometerAbbreviation}}</td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.odometerEffect | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.standardVehicle.odometerEffect | numberLocale :mktProps.valueSeparator }}</ng-template>  \r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.ageEffect}}</td>\r\n                      <td>{{ vehicle.standardVehicle.ageDiffMonths }} {{lngProperties.monthsTraslation}}</td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.ageEffect }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.standardVehicle.ageEffect }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>\r\n                        {{ resultsProps.tooltips.priceDiff.regionalEffect}}\r\n                      </td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.regionalEffect | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.standardVehicle.regionalEffect | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr *ngIf=\"vehicle.standardVehicle.optionsAvailability == 'UNKNOWN' && vehicle.standardVehicle.typicalOptionEffect != NULL && vehicle.options.length == 0\">\r\n                      <td>{{ resultsProps.tooltips.priceDiff.equipmentAverage}}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.typicalOptionEffect | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{mktProps.currencySymbol }} {{ vehicle.standardVehicle.typicalOptionEffect | numberLocale :mktProps.valueSeparator }}</ng-template>    \r\n                      </td>\r\n                    </tr>\r\n                    <tr *ngIf=\"vehicle.standardVehicle.optionsAvailability == 'UNKNOWN' && vehicle.standardVehicle.typicalOptionEffect == NULL && vehicle.options.length == 0\">\r\n                      <td>{{ resultsProps.tooltips.priceDiff.options}}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        {{ resultsProps.tooltips.priceDiff.noOptions }}\r\n                      </td>\r\n                    </tr>\r\n\r\n                    <tr *ngIf=\"vehicle.standardVehicle.optionsAvailability == 'UNKNOWN' && \r\n                                vehicle.dataOrigin == 'OwnVehicle' && \r\n                                vehicle.standardVehicle.typicalOptionEffect == NULL && \r\n                                vehicle.options.length > 0\">\r\n                      <td>{{ resultsProps.tooltips.priceDiff.options}}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        {{vehicle?.options[0].value}} {{ mktProps.currencySymbol }}\r\n                      </td>\r\n                    </tr>\r\n\r\n                    <tr *ngIf=\"vehicle.standardVehicle.optionsAvailability != 'UNKNOWN'\">\r\n                      <td>{{ resultsProps.tooltips.priceDiff.options }}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"vehicle?.totalOptionValue == 0 && vehicle.dataOrigin == 'OwnVehicle'\">{{ resultsProps.tooltips.priceDiff.noOptions }}</ng-template>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore && vehicle?.totalOptionValue == 0 && vehicle.dataOrigin != 'OwnVehicle'\">{{ vehicle.totalOptionValue | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore && vehicle?.totalOptionValue == 0 && vehicle.dataOrigin != 'OwnVehicle'\">{{ mktProps.currencySymbol }} {{ vehicle.totalOptionValue | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore && vehicle?.totalOptionValue != 0\">{{ vehicle.totalOptionValue | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore && vehicle?.totalOptionValue != 0\">{{ mktProps.currencySymbol }} {{ vehicle.totalOptionValue | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <ng-template [ngIf]=\"vehicle.options?.length > 0 && vehicle.standardVehicle.optionsAvailability != 'UNKNOWN'\">\r\n                      <tr *ngFor=\"let option of vehicle.options\">\r\n                        <td>{{option?.description}}</td>\r\n                        <td></td>\r\n                        <td><img class=\"option-ok--img\" src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDUxNS41NTYgNTE1LjU1NiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBkPSJtMCAyNzQuMjI2IDE3Ni41NDkgMTc2Ljg4NiAzMzkuMDA3LTMzOC42NzItNDguNjctNDcuOTk3LTI5MC4zMzcgMjkwLTEyOC41NTMtMTI4LjU1MnoiIGZpbGw9IiMwMDhmYzgiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIHN0eWxlPSIiPjwvcGF0aD48L2c+PC9zdmc+\" /></td>\r\n                      </tr>\r\n                    </ng-template>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.totalEffects | numberLocale :mktProps.odometerSeparator}}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.totalEffects | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.standardVehicle.totalEffects | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.regionalAskingPrice }}</td>\r\n                      <td></td>\r\n                      <td class=\"td-bold\">\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr *ngIf=\"vehicle.sellingSpotPriceDiscount != null\"> <!--  Only on AT market -->\r\n                      <td class=\"\"><i>Nachlass</i></td>\r\n                      <td></td>\r\n                      <td class=\"\">\r\n                       {{ vehicle.sellingSpotPriceDiscount | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}\r\n                      </td>\r\n                    </tr>\r\n                    <tr *ngIf=\"vehicle.sellingSpotPriceDiscount != null\">\r\n                      <td class=\"td-bold\">Eurotax Verkaufskurs</td> <!--  Only on AT market -->\r\n                      <td></td>\r\n                      <td class=\"td-bold\">\r\n                        {{ vehicle.sellingSpotPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.askingPrice }}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.askingPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.askingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr style=\"border-top: 2px dashed #212529;\">\r\n                      <td *ngIf=\"vehicle.priceDifferenceCurrency < 0\"class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.underpriced }}</td>\r\n                      <td *ngIf=\"vehicle.priceDifferenceCurrency > 0\" class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.overpriced }}</td>\r\n                      <td *ngIf=\"vehicle.priceDifferenceCurrency === 0\" class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.priceDifference }}</td>\r\n                      <td></td>\r\n                      <td [ngClass]=\"{\r\n                        diffDown: vehicle.priceDifferenceCurrency < 0,\r\n                        diffUp: vehicle.priceDifferenceCurrency > 0}\" class=\"td-bold\">\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td class=\"td-bold\">{{resultsProps?.tooltips.priceDiff?.priceDiffPercentage}}</td>\r\n                      <td></td>\r\n                      <td [ngClass]=\"{\r\n                        diffDown: vehicle.priceDifferenceCurrency < 0,\r\n                        diffUp: vehicle.priceDifferenceCurrency > 0}\" class=\"td-bold\" >\r\n                        {{ vehicle.priceDifferencePercentage }} %\r\n                      </td>\r\n                    </tr>\r\n                  </tbody>\r\n                </table>\r\n              </ng-template>\r\n              <!-- END OF TOOLTIP CONTAINER -->\r\n            </span>\r\n              <span>\r\n                <ng-template [ngIf]=\"!currencySymbolBefore\">{{vehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{vehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n              </span>\r\n            </div>\r\n            <div class=\"cont\" [ngClass]=\"{\r\n                      contBackgroundLow: vehicle.askingPrice < vehicle.regionalAskingPrice,\r\n                      contBackgroundHigh: vehicle.askingPrice > vehicle.regionalAskingPrice, \r\n                      contBackgroundSame: vehicle.askingPrice == vehicle.regionalAskingPrice}\">\r\n              <div id=\"priceBarOne{{i}}\" class=\"one\"></div>\r\n              <div id=\"priceBarTwo{{i}}\" class=\"two\"></div>\r\n            </div>\r\n          </div>\r\n        </td>\r\n        <td class=\"txt-center\">\r\n          <span *ngIf=\"vehicle.dataOrigin != 'OwnVehicle'\" class=\"icon\" [ngClass]=\"{\r\n              'icon-green': vehicle.similarityCategory === 0,\r\n              'icon-blue': vehicle.similarityCategory === 1,\r\n              'icon-yellow': vehicle.similarityCategory === 2,\r\n              'icon-orange': vehicle.similarityCategory === 3\r\n            }\">\r\n          </span>\r\n          <span *ngIf=\"vehicle.dataOrigin === 'OwnVehicle'\">-</span>\r\n        </td>\r\n        <td class=\"txt-center nowrap\">{{ vehicle.distance }} {{mktProps.odometerAbbreviation }}</td>\r\n        <td class=\"txt-center\">{{ vehicle.odometer | numberLocale :mktProps.odometerSeparator }}</td>\r\n        <td class=\"txt-center\" style=\"position:relative\">{{ vehicle.regDate | date: mktProps.datePattern }} \r\n          <span style=\"position: absolute;left: 44%;bottom: 5px;float: right;\" *ngIf=\"vehicle.directImport == true\" class=\"info tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"directImportTooltip\" tooltipClass=\"tooltip-style-1\">\r\n            <img src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQ1Ljk5OSA0NS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTM5LjI2NCw2LjczNmMtOC45ODItOC45ODEtMjMuNTQ1LTguOTgyLTMyLjUyOCwwYy04Ljk4Miw4Ljk4Mi04Ljk4MSwyMy41NDUsMCwzMi41MjhjOC45ODIsOC45OCwyMy41NDUsOC45ODEsMzIuNTI4LDAgICAgQzQ4LjI0NSwzMC4yODEsNDguMjQ0LDE1LjcxOSwzOS4yNjQsNi43MzZ6IE0yNS45OTksMzNjMCwxLjY1Ny0xLjM0MywzLTMsM3MtMy0xLjM0My0zLTNWMjFjMC0xLjY1NywxLjM0My0zLDMtM3MzLDEuMzQzLDMsM1YzM3ogICAgIE0yMi45NDYsMTUuODcyYy0xLjcyOCwwLTIuODgtMS4yMjQtMi44NDQtMi43MzVjLTAuMDM2LTEuNTg0LDEuMTE2LTIuNzcxLDIuODc5LTIuNzcxYzEuNzY0LDAsMi44OCwxLjE4OCwyLjkxNywyLjc3MSAgICBDMjUuODk3LDE0LjY0OCwyNC43NDYsMTUuODcyLDIyLjk0NiwxNS44NzJ6IiBmaWxsPSIjMDA4ZmM4IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg==\" />\r\n          </span>\r\n          <ng-template #directImportTooltip>\r\n            <table style=\"width: 200px;\" class=\"table table-striped tooltip-table price-tooltip--table\">\r\n              <thead>\r\n                <tr>\r\n                  <th colspan=\"3\">{{ resultsProps.tooltips.directImportFlag.header | uppercase }}</th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr>\r\n                  <td style=\"text-align: left;\">\r\n                    {{ resultsProps.tooltips.directImportFlag.content}}\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n        </ng-template>\r\n        </td>\r\n        <td class=\"txt-right\" style=\"width: 150px;\"><span>{{ vehicle.sellerName }}</span></td>\r\n        <td class=\"txt-center\">{{ vehicle.stockDays }}</td>\r\n        <td class=\"txt-center\">\r\n          <span *ngIf=\"vehicle.dataOrigin != 'OwnVehicle'\" class=\"tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"changesTooltip\" tooltipClass=\"tooltip-style-1\" (click)=\"getPriceHistory(vehicle.vehicleId)\"\r\n            placement=\"bottom-right\">{{ vehicle.numberOfPriceChanges }}</span>\r\n          <span *ngIf=\"vehicle.dataOrigin === 'OwnVehicle'\" class=\"d-none d-md-block\">{{ vehicle.numberOfPriceChanges }}</span>\r\n          <span class=\"d-md-none\">{{ vehicle.numberOfPriceChanges }}</span>\r\n          <!-- TOOLTIP CONTAINER: price changes -->\r\n          <ng-template #changesTooltip>\r\n            <table class=\"table table-striped tooltip-table\">\r\n              <thead>\r\n                <tr>\r\n                  <th colspan=\"3\">{{ resultsProps.tooltips.priceHistory.header | uppercase }}</th>\r\n                </tr>\r\n              </thead>\r\n              <span *ngIf=\"tooltipLoadingFlag\"><div class=\"lds-ellipsis lds-tooltip\"><div></div><div></div><div></div><div></div></div></span>\r\n              <tbody *ngIf=\"!tooltipLoadingFlag\">\r\n                <tr *ngFor=\"let i = index; let item of priceHistory\">\r\n                  <td>{{ item.date | date: mktProps.datePattern }}</td>\r\n                  <td>{{ item.priceHistoryType | priceChangesMapping }}</td>\r\n                  <td>\r\n                    <ng-template [ngIf]=\"!currencySymbolBefore\"> {{ item.regionalAskingPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                    <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }}  {{ item.regionalAskingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>    \r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n            <table *ngIf=\"vehicle.isSold == true && vehicle.dateAdRemoved\" class=\"table table-striped tooltip-table\">\r\n              <thead>\r\n                <tr>\r\n                  <th colspan=\"3\">{{ resultsProps.tooltips.priceHistory.dateAdRemoved | uppercase }}</th>\r\n                </tr>\r\n              </thead>\r\n              <span *ngIf=\"tooltipLoadingFlag\"><div class=\"lds-ellipsis lds-tooltip\"><div></div><div></div><div></div><div></div></div></span>\r\n              <tbody *ngIf=\"!tooltipLoadingFlag\">\r\n                <tr>\r\n                  <td>{{ vehicle.dateAdRemoved | date: mktProps.datePattern }}</td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </ng-template>\r\n          <!-- END OF TOOLTIP CONTAINER -->\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}.table-responsive{border-top-right-radius:5px;border-top-left-radius:5px;border:1px solid #dae0e1}table{margin-bottom:0}table thead{background-color:#232c32}table thead th{background-color:#232c32;position:relative;border:none;border-top:1px solid #232C32;font-family:Aileron bold;color:#a1a9ac;font-size:12px;vertical-align:middle;padding:7px 5px}table thead th:hover{color:#fff;cursor:pointer}table thead th .priceBar--header{display:flex;justify-content:space-between;align-items:center}table tbody tr:hover{background-color:#dae0e1}table tbody tr td{vertical-align:middle}.tooltip-table thead tr:hover{background-color:#232c32}.tooltip-table th:hover{color:#a1a9ac!important;cursor:context-menu!important}.tooltip-table td{font-size:14px;font-weight:600}.tooltip-table .td-bold{font-weight:800}.price-tooltip--table td:last-child{text-align:right}.vh-desc{display:flex;font-family:Aileron bold;font-size:14px}.vh-desc span{display:flex;align-self:center}.vh-desc .pic{display:inline-table;width:40px;height:40px;margin-right:10px;margin-left:5px}.vh-desc .pic img{max-width:50px}.vh-desc .hasLinks:hover{cursor:help}.vh-desc .info{min-width:140px;max-width:180px;max-height:60px;overflow:hidden;text-overflow:ellipsis}.vh-desc .isSoldVehicle{text-decoration:line-through;color:#de4a39}.ownVehicleFlagcontainer{position:relative}.ownVehicleFlagcontainer:before{content:\"\";position:absolute;height:calc(100% + 10px);width:5px;top:-5px;left:-10px;border-radius:5px;background-color:#232c32}.option-ok--img{width:20px;height:20px}.icon{display:inline-block;height:10px;width:10px;transform:rotate(45deg);align-self:center}.icon-green{background-color:#00a76e}.icon-blue{background-color:#00a8be}.icon-yellow{background-color:#e1be2b}.icon-orange{background-color:#e36a44}#containerPriceBar{width:230px}#containerPriceBar .labels{display:flex;justify-content:space-between;color:#333;margin-bottom:5px;font-weight:600;font-size:14px}#containerPriceBar .cont{background:#fff;height:7px;border-radius:2px;width:100%;display:flex;justify-content:space-between;-webkit-transform:skew(-20deg);-moz-transform:skew(-20deg);-ms-transform:skew(-20deg);-o-transform:skew(-20deg);transform:skew(-20deg)}#containerPriceBar .one{background:#232c32;height:100%;width:50%;max-width:50%;border-right:2px solid #ffffff}#containerPriceBar .two{background:#a1a9ac;height:100%;width:50%;max-width:50%;border-left:2px solid #ffffff}#containerPriceBar .contBackgroundLow{background-color:#008fc8}#containerPriceBar .contBackgroundHigh{background-color:#de4a39}#containerPriceBar .contBackgroundSame{background-color:#00a76e}.diffUp{color:#de4a39}.diffDown{color:#008fc8}.diffSame{color:#00a76e}.checkbox--item{padding:0 0 0 5px;vertical-align:middle}th[sortable]{cursor:pointer;user-select:none;-webkit-user-select:none}th[sortable].desc:before,th[sortable].asc:before{content:\"\";position:absolute;display:block;background:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQxLjk5OSA0MS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnIHRyYW5zZm9ybT0ibWF0cml4KDYuMTIzMjMzOTk1NzM2NzY2ZS0xNywxLC0xLDYuMTIzMjMzOTk1NzM2NzY2ZS0xNyw0MS45OTk1MDk3NjY2OTc4OCwtMC4wMDA0OTAyMzMzMDIxMTYzOTQpIj4KPHBhdGggeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBkPSJNMzYuMDY4LDIwLjE3NmwtMjktMjBDNi43NjEtMC4wMzUsNi4zNjMtMC4wNTcsNi4wMzUsMC4xMTRDNS43MDYsMC4yODcsNS41LDAuNjI3LDUuNSwwLjk5OXY0MCAgYzAsMC4zNzIsMC4yMDYsMC43MTMsMC41MzUsMC44ODZjMC4xNDYsMC4wNzYsMC4zMDYsMC4xMTQsMC40NjUsMC4xMTRjMC4xOTksMCwwLjM5Ny0wLjA2LDAuNTY4LTAuMTc3bDI5LTIwICBjMC4yNzEtMC4xODcsMC40MzItMC40OTQsMC40MzItMC44MjNTMzYuMzM4LDIwLjM2MywzNi4wNjgsMjAuMTc2eiIgZmlsbD0iI2ZmZmZmZiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgc3R5bGU9IiIgY2xhc3M9IiI+PC9wYXRoPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8L2c+PC9zdmc+) no-repeat;background-size:10px;width:10px;height:10px;bottom:0;left:calc(50% - 5px)}th[sortable].desc:before{transform:rotate(180deg);-ms-transform:rotate(180deg);top:-1px;bottom:unset}.img-tooltip--container .img-zoomed{max-width:180px;height:auto}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { kind: "directive", type: NgbdSortableHeader, selector: "th[sortable]", inputs: ["sortable", "direction"], outputs: ["sort"] }, { kind: "pipe", type: i4.UpperCasePipe, name: "uppercase" }, { kind: "pipe", type: i4.DatePipe, name: "date" }, { kind: "pipe", type: NumberLocalePipe, name: "numberLocale" }, { kind: "pipe", type: PriceChangesMappingPipe, name: "priceChangesMapping" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ResultsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-results', template: "<div class=\"table-responsive\">\r\n  <table class=\"table\">\r\n    <thead>\r\n      <tr>\r\n        <!-- <th scope=\"col\" class=\"txt-left\" style=\"padding-right: 0;\">\r\n          <input type=\"checkbox\" class=\"exportCheckboxes\" id=\"pdfExportGroupSelector\" name=\"all\" [checked]=\"isAllChecked()\" (change)=\"checkAll($event)\">\r\n        </th> -->\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"officialTypeDescription\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.vehicle | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"priceDifferenceCurrency\" (sort)=\"onSort($event)\">\r\n          <div class=\"priceBar--header\">\r\n            <div>{{ resultsProps.askPrice | uppercase }}</div>\r\n            <span style=\"margin: 0 5px 0 5px;\">{{ resultsProps.diffPrice | uppercase }}</span>\r\n            <div>{{ resultsProps.lrPrice | uppercase }}</div>\r\n          </div>\r\n        </th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"similarityCategory\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.similarity | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"distance\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.distance | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"odometer\" (sort)=\"onSort($event)\">\r\n          {{mktProps.odometerAbbreviation | uppercase }}</th> <!--{{ resultsProps.odometer -->\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"regDate\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.regDate | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"sellerName\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.company | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"stockDays\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.stockDays | uppercase }}</th>\r\n        <th scope=\"col\" class=\"txt-center\" sortable=\"numberOfPriceChanges\" (sort)=\"onSort($event)\">\r\n          {{ resultsProps.priceChanges | uppercase }}</th>\r\n      </tr>\r\n    </thead>\r\n    <div class=\"loader--container\">\r\n      <div *ngIf=\"!listOfVehicles\" class=\"lds-ellipsis\"><div></div><div></div><div></div><div></div></div>\r\n    </div>\r\n    <tbody>\r\n      <tr *ngFor=\"let i = index;let vehicle of listOfVehicles\">\r\n        <!-- <th scope=\"row\" class=\"checkbox--item\">\r\n          <input type=\"checkbox\" class=\"exportCheckboxes\" value=\"{{vehicle.id}}\" [(ngModel)]=\"vehicle.state\">\r\n        </th> -->\r\n        <td>\r\n          <div class=\"vh-desc\">\r\n            <span *ngIf=\"vehicle.advertisements?.length >= 1\" class=\"pic hasLinks\" [ngbTooltip]=\"adLinks\"\r\n              tooltipClass=\"tooltip-style-1\" placement=\"bottom-left\">\r\n              <ng-template #adLinks>\r\n                <div *ngIf=\"vehicle.imageLink\" class=\"img-tooltip--container\">\r\n                    <img [src]=\"vehicle.imageLink\" class=\"img-zoomed\">\r\n                </div>\r\n                <table class=\"table table-striped tooltip-table\">\r\n                  <thead>\r\n                    <tr>\r\n                      <th colspan=\"1\">{{resultsProps.adLinks | uppercase }}</th>\r\n                    </tr>\r\n                  </thead>\r\n                  <tbody>\r\n                    <tr *ngFor=\"let ad of vehicle.advertisements\">\r\n                      <td><a [href]=\"ad.originalWebAddress\" target=\"_blank\">{{ad.portalName}}</a></td>\r\n                    </tr>\r\n                  </tbody>\r\n                </table>\r\n              </ng-template>\r\n              <img *ngIf=\"vehicle.imageLink != null\" [src]=\"vehicle.imageLink || camaraImg\">\r\n              <img *ngIf=\"vehicle.imageLink == null\"\r\n                src=\"data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjUxMXB0IiB2aWV3Qm94PSIwIC0yOSA1MTEuOTk4NDMgNTExIiB3aWR0aD0iNTExcHQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTMzNS4wODk4NDQgOTQuOTg0Mzc1di0yMC44MTI1YzAtOS4xOTkyMTkgNy40NTMxMjUtMTYuNjUyMzQ0IDE2LjY0ODQzNy0xNi42NTIzNDRoMjkuMTM2NzE5YzkuMTk1MzEyIDAgMTYuNjUyMzQ0IDcuNDU3MDMxIDE2LjY1MjM0NCAxNi42NTIzNDR2MjAuODEyNXptMCAwIiBmaWxsPSIjZDhkOGQ4Ii8+PHBhdGggZD0ibTM4MC44Nzg5MDYgNTcuNTE5NTMxaC0xOC43MzQzNzVjOS4xOTUzMTMgMCAxNi42NTIzNDQgNy40NTcwMzEgMTYuNjUyMzQ0IDE2LjY1MjM0NHYyMC44MTI1aDE4LjczMDQ2OXYtMjAuODEyNWMwLTkuMTk5MjE5LTcuNDUzMTI1LTE2LjY1MjM0NC0xNi42NDg0MzgtMTYuNjUyMzQ0em0wIDAiIGZpbGw9IiNiYWJhYmEiLz48cGF0aCBkPSJtNDA1Ljg1MTU2MiAzNTkuMTc5Njg4aC0yOTkuNzA3MDMxYy0yMi45ODgyODEgMC00MS42MjUtMTguNjM2NzE5LTQxLjYyNS00MS42Mjg5MDd2LTE4MS4wNzQyMTljMC0yMi45ODgyODEgMTguNjM2NzE5LTQxLjYyNSA0MS42MjUtNDEuNjI1aDI5OS43MDcwMzFjMjIuOTg4MjgyIDAgNDEuNjI1IDE4LjYzNjcxOSA0MS42MjUgNDEuNjI1djE4MS4wNzQyMTljLjAwMzkwNyAyMi45OTIxODgtMTguNjMyODEyIDQxLjYyODkwNy00MS42MjUgNDEuNjI4OTA3em0wIDAiIGZpbGw9IiM3NTc1NzUiLz48cGF0aCBkPSJtNDIxLjYyODkwNiA5Ny45NTMxMjVjMS4yNDIxODggMy45NDkyMTkgMS45MTQwNjMgOC4xNTIzNDQgMS45MTQwNjMgMTIuNTA3ODEzdjIwMS44ODY3MThjMCAxMS40OTYwOTQtOS4zMTY0MDcgMjAuODEyNS0yMC44MTI1IDIwLjgxMjVoLTMyMC41MTk1MzFjLTUuNTg1OTM4IDAtMTAuOTEwMTU3LTEuMTA1NDY4LTE1Ljc3NzM0NC0zLjEwMTU2MiA1LjMxMjUgMTYuODc4OTA2IDIxLjA4MjAzMSAyOS4xMTcxODcgMzkuNzEwOTM3IDI5LjExNzE4N2gyOTkuNzA3MDMxYzIyLjk4ODI4MiAwIDQxLjYyNS0xOC42MzY3MTkgNDEuNjI1LTQxLjYyNXYtMTgxLjA3NDIxOWMuMDAzOTA3LTE3LjQwMjM0My0xMC42ODM1OTMtMzIuMzA0Njg3LTI1Ljg0NzY1Ni0zOC41MjM0Mzd6bTAgMCIgZmlsbD0iIzU5NTk1OSIvPjxwYXRoIGQ9Im00NjkuNjI4OTA2IDMwNS44OTA2MjVjNy40NzI2NTYgNS40NTMxMjUgMTIuMjYxNzE5IDEzLjYyODkwNiAxMi4wOTM3NSAyMy43MjI2NTYtLjI3MzQzNyAxNi4zNzEwOTQtMTQuNTIzNDM3IDI5Ljc1MzkwNy0zMC44OTg0MzcgMjkuNzUzOTA3aC0xMDYuODYzMjgxdi0yMy4xOTE0MDdjMC04LjgyNDIxOS0xMC4yODkwNjMtMTMuNjQ0NTMxLTE3LjA3MDMxMy03Ljk5NjA5M2wtNjQuMTU2MjUgNTMuNDY0ODQzYy00Ljk5MjE4NyA0LjE2MDE1Ny00Ljk5MjE4NyAxMS44MjgxMjUgMCAxNS45ODgyODFsNjQuMTU2MjUgNTMuNDY0ODQ0YzYuNzgxMjUgNS42NDg0MzggMTcuMDcwMzEzLjgzMjAzMiAxNy4wNzAzMTMtNy45OTIxODd2LTIzLjE5MTQwN2gxMDYuNTg5ODQzYzMzLjI3MzQzOCAwIDYxLjAxMTcxOS0yNi40NzI2NTYgNjEuNDQxNDA3LTU5Ljc0MjE4Ny4zNDc2NTYtMjYuNzUzOTA2LTE2LjY2MDE1Ny00OS41ODU5MzctNDAuNDc2NTYzLTU3Ljk0OTIxOS0yLjI3MzQzNy0uNzk2ODc1LTMuODM1OTM3IDIuMjUtMS44ODY3MTkgMy42Njc5Njl6bTAgMCIgZmlsbD0iI2Q4ZDhkOCIvPjxwYXRoIGQ9Im0zNTAuNjk5MjE5IDIyNy4wMTU2MjVjMCA1Mi4zMDA3ODEtNDIuMzk4NDM4IDk0LjY5OTIxOS05NC42OTkyMTkgOTQuNjk5MjE5cy05NC42OTkyMTktNDIuMzk4NDM4LTk0LjY5OTIxOS05NC42OTkyMTkgNDIuMzk4NDM4LTk0LjY5OTIxOSA5NC42OTkyMTktOTQuNjk5MjE5IDk0LjY5OTIxOSA0Mi4zOTg0MzggOTQuNjk5MjE5IDk0LjY5OTIxOXptMCAwIiBmaWxsPSIjZDhkOGQ4Ii8+PHBhdGggZD0ibTMwNi40NzI2NTYgMTQ2Ljg4MjgxMmM5LjIyMjY1NiAxNC42MDkzNzYgMTQuNTY2NDA2IDMxLjkxNzk2OSAxNC41NjY0MDYgNTAuNDcyNjU3IDAgNTIuMzAwNzgxLTQyLjM5ODQzNyA5NC42OTkyMTktOTQuNjk5MjE4IDk0LjY5OTIxOS0xOC41NTQ2ODggMC0zNS44NjMyODItNS4zMzk4NDQtNTAuNDc2NTYzLTE0LjU2NjQwNyAxNi43NzM0MzggMjYuNTc0MjE5IDQ2LjM5MDYyNSA0NC4yMjY1NjMgODAuMTM2NzE5IDQ0LjIyNjU2MyA1Mi4zMDA3ODEgMCA5NC42OTkyMTktNDIuMzk4NDM4IDk0LjY5OTIxOS05NC42OTkyMTkgMC0zMy43NDYwOTQtMTcuNjUyMzQ0LTYzLjM2MzI4MS00NC4yMjY1NjMtODAuMTMyODEzem0wIDAiIGZpbGw9IiNiYWJhYmEiLz48cGF0aCBkPSJtMzE4LjQzNzUgMjI3LjAxNTYyNWMwIDM0LjQ4NDM3NS0yNy45NTMxMjUgNjIuNDM3NS02Mi40Mzc1IDYyLjQzNzVzLTYyLjQ0MTQwNi0yNy45NTMxMjUtNjIuNDQxNDA2LTYyLjQzNzUgMjcuOTU3MDMxLTYyLjQ0MTQwNiA2Mi40NDE0MDYtNjIuNDQxNDA2IDYyLjQzNzUgMjcuOTU3MDMxIDYyLjQzNzUgNjIuNDQxNDA2em0wIDAiIGZpbGw9IiM4ZmU3ZmYiLz48cGF0aCBkPSJtMjExLjc2OTUzMSAyNDUuMjI2NTYyYzAtMzQuNDg0Mzc0IDI3Ljk1NzAzMS02Mi40NDE0MDYgNjIuNDQxNDA3LTYyLjQ0MTQwNiAxMi41ODIwMzEgMCAyNC4yODUxNTYgMy43MzgyODIgMzQuMDg5ODQzIDEwLjE0MDYyNS0xMS4xNDQ1MzEtMTcuMDY2NDA2LTMwLjQwMjM0My0yOC4zNTE1NjItNTIuMzAwNzgxLTI4LjM1MTU2Mi0zNC40ODQzNzUgMC02Mi40NDE0MDYgMjcuOTU3MDMxLTYyLjQ0MTQwNiA2Mi40NDE0MDYgMCAyMS45MDIzNDQgMTEuMjg1MTU2IDQxLjE1NjI1IDI4LjM1MTU2MiA1Mi4zMDA3ODEtNi40MDIzNDQtOS44MDQ2ODctMTAuMTQwNjI1LTIxLjUwNzgxMi0xMC4xNDA2MjUtMzQuMDg5ODQ0em0wIDAiIGZpbGw9IiM1M2RhZjkiLz48cGF0aCBkPSJtNDIuNTY2NDA2IDE0OC4yMDcwMzFjLTcuNTUwNzgxLTUuNDQ5MjE5LTEyLjQ1NzAzMS0xMy42NDQ1MzEtMTIuMjg5MDYyLTIzLjc4MTI1LjI2NTYyNS0xNi4zNzg5MDYgMTQuNTE5NTMxLTI5Ljc2MTcxOSAzMC44OTg0MzctMjkuNzYxNzE5aDEwNi44NTkzNzV2MjMuMTkxNDA3YzAgOC44MjQyMTkgMTAuMjkyOTY5IDEzLjY0NDUzMSAxNy4wNzAzMTMgNy45OTYwOTNsNjQuMTU2MjUtNTMuNDY0ODQzYzQuOTk2MDkzLTQuMTYwMTU3IDQuOTk2MDkzLTExLjgzMjAzMSAwLTE1Ljk5MjE4OGwtNjQuMTU2MjUtNTMuNDY0ODQzYy02Ljc3NzM0NC01LjY0ODQzOC0xNy4wNzAzMTMtLjgyODEyNi0xNy4wNzAzMTMgNy45OTYwOTN2MjMuMTkxNDA3aC0xMDYuNTg1OTM3Yy0zMy4yNzczNDQgMC02MS4wMTE3MTkgMjYuNDY4NzUtNjEuNDQ1MzEyNzUgNTkuNzQyMTg3LS4zNDc2NTYyNSAyNi44MjgxMjUgMTYuNzU3ODEyNzUgNDkuNzEwOTM3IDQwLjY3NTc4MTc1IDU4LjAxOTUzMSAyLjI3NzM0My43ODkwNjMgMy44Mzk4NDMtMi4yNjE3MTggMS44ODY3MTgtMy42NzE4NzV6bTAgMCIgZmlsbD0iI2Q4ZDhkOCIvPjxwYXRoIGQ9Im0xNDIuNTY2NDA2IDE1OC4zMzIwMzFjMCAxMS40OTYwOTQtOS4zMTY0MDYgMjAuODEyNS0yMC44MTI1IDIwLjgxMjUtMTEuNDkyMTg3IDAtMjAuODEyNS05LjMxNjQwNi0yMC44MTI1LTIwLjgxMjUgMC0xMS40OTYwOTMgOS4zMjAzMTMtMjAuODEyNSAyMC44MTI1LTIwLjgxMjUgMTEuNDk2MDk0IDAgMjAuODEyNSA5LjMxNjQwNyAyMC44MTI1IDIwLjgxMjV6bTAgMCIgZmlsbD0iI2ZmNWY1ZiIvPjwvc3ZnPg==\" />\r\n            </span>\r\n            <span *ngIf=\"vehicle.advertisements == null && vehicle.dataOrigin != 'OwnVehicle' || vehicle.isSold\" class=\"pic\">\r\n              <img *ngIf=\"vehicle.imageLink != null\" [src]=\"vehicle.imageLink || camaraImg\">\r\n              <img *ngIf=\"vehicle.imageLink == null\"\r\n                src=\"data:image/svg+xml;base64,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\" />\r\n            </span>\r\n            <span *ngIf=\"vehicle.dataOrigin === 'OwnVehicle'\" class=\"pic ownVehicleFlagcontainer\">\r\n              <small style=\"display: flex;text-align: center;margin-top: 5px;\"> {{ resultsProps?.ownVehicle }} </small>\r\n            </span>\r\n            <span class=\"info tooltip-trigger d-none d-md-block\" [ngClass]=\"{isSoldVehicle: vehicle.isSold}\" [ngbTooltip]=\"vhDescription\" (click)=\"getVhDescription(vehicle.type.natCode)\"\r\n              tooltipClass=\"tooltip-style-1\" placement=\"bottom-left\">{{ vehicle.officialTypeDescription }}</span>\r\n            <span class=\"info d-md-none\" [ngClass]=\"{isSoldVehicle: vehicle.isSold}\">{{ vehicle.officialTypeDescription }}</span>\r\n            <!-- TOOLTIP CONTAINER: Vehicle description -->\r\n            <ng-template #vhDescription>\r\n              <table class=\"table table-striped tooltip-table\">\r\n                <thead>\r\n                  <tr>\r\n                    <th colspan=\"2\">{{ resultsProps.tooltips.vhDescription.header | uppercase }}</th>\r\n                  </tr>\r\n                </thead>\r\n                <div *ngIf=\"tooltipLoadingFlag\" class=\"lds-ellipsis lds-tooltip\"><div></div><div></div><div></div><div></div></div>\r\n                <tbody *ngIf=\"!tooltipLoadingFlag\">\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.make }}</td>\r\n                    <td>{{ vehicleDescription?.make }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.modelSeries }}</td>\r\n                    <td>{{ vehicleDescription?.modelSeries }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.type }}</td>\r\n                    <td>{{ vehicleDescription?.type }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.body }}</td>\r\n                    <td>{{ vehicleDescription?.body }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.doors }}</td>\r\n                    <td>{{ vehicleDescription?.doors }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.seats }}</td>\r\n                    <td>{{vehicleDescription?.seats }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.fuel }}</td>\r\n                    <td>{{ vehicleDescription?.fuel }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.powerKW }}</td>\r\n                    <td>{{ vehicleDescription?.powerKW }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.powerHP }}</td>\r\n                    <td>{{ vehicleDescription?.powerHP }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.cylCubic }}</td>\r\n                    <td>{{ vehicleDescription?.cylCubic }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.cylinders }}</td>\r\n                    <td>{{ vehicleDescription?.cylinders }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.gearBox }}</td>\r\n                    <td>{{ vehicleDescription?.gearBox }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.noOfGears }}</td>\r\n                    <td>{{ vehicleDescription?.noOfGears }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.drive }}</td>\r\n                    <td>{{ vehicleDescription?.drive }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.engineType }}</td>\r\n                    <td>{{ vehicleDescription?.engineType }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.wheelBase }}</td>\r\n                    <td>{{ vehicleDescription?.wheelbase }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.totalWeight }}</td>\r\n                    <td>{{ vehicleDescription?.totalWeight }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.payload }}</td>\r\n                    <td>{{ vehicleDescription?.payload }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.importBegin }}</td>\r\n                    <td>{{ vehicleDescription?.importBegin | date: mktProps.datePattern}}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.importEnd }}</td>\r\n                    <td>{{ vehicleDescription?.importEnd | date: mktProps.datePattern}}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.vhType }}</td>\r\n                    <td>{{ vehicleDescription?.vehicleType }}</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>{{ resultsProps.tooltips.vhDescription.nationalCode }}</td>\r\n                    <td>{{ vehicleDescription?.nationalCode }}</td>\r\n                  </tr>\r\n                </tbody>\r\n              </table>\r\n            </ng-template>\r\n            <!-- END OF TOOLTIP CONTAINER -->\r\n          </div>\r\n        </td>\r\n        <td class=\"txt-center\">\r\n          <div id=\"containerPriceBar\">\r\n            <div class=\"labels\">\r\n              <span>\r\n                <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.askingPrice | numberLocale :mktProps.valueSeparator}} {{mktProps.currencySymbol }}</ng-template>\r\n                <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.askingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>      \r\n              </span>\r\n              <span class=\"tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"priceTooltip\" tooltipClass=\"tooltip-style-1\"\r\n                [ngClass]=\"{diffDown: vehicle.priceDifferenceCurrency <= 0,\r\n                            diffUp: vehicle.priceDifferenceCurrency >= 0, \r\n                            diffSame: vehicle.askingPrice == vehicle.regionalAskingPrice}\">\r\n                <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator}} {{mktProps.currencySymbol }}</ng-template>\r\n                <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator }} </ng-template>\r\n              </span>\r\n              <span class=\"d-md-none\" [ngClass]=\"{\r\n                    diffDown: vehicle.priceDifferenceCurrency <= 0,\r\n                    diffUp: vehicle.priceDifferenceCurrency >= 0, \r\n                    diffSame: vehicle.askingPrice == vehicle.regionalAskingPrice}\">\r\n                    <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator}} {{mktProps.currencySymbol }}</ng-template>\r\n                    <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator }} </ng-template>\r\n                  <!-- TOOLTIP CONTAINER: price diff tooltip -->\r\n              <ng-template #priceTooltip>\r\n                <span *ngIf=\"!vehicle?.standardVehicle\">LOADING</span>\r\n                <table class=\"table table-striped tooltip-table price-tooltip--table\">\r\n                  <thead>\r\n                    <tr>\r\n                      <th colspan=\"3\">{{ resultsProps.tooltips.priceDiff.header | uppercase }}</th>\r\n                    </tr>\r\n                  </thead>\r\n                  <tbody>\r\n                    <tr>\r\n                      <td class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.standardVh}}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.standardVehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>        \r\n                      </td> \r\n                    </tr>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.standardVhOdometer }}</td>\r\n                      <td>{{ vehicle.standardVehicle.odometer | numberLocale :mktProps.odometerSeparator}} {{mktProps.odometerAbbreviation}}</td>\r\n                      <td></td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.standardVhRegDate }}</td>\r\n                      <td>{{ vehicle.standardVehicle.regDate | date: mktProps.datePattern }}</td>\r\n                      <td></td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.thisVh }}</td>\r\n                      <td></td>\r\n                      <td></td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.odometerEffect}}</td>\r\n                      <td>{{ vehicle.standardVehicle.odometerDiff | numberLocale :mktProps.odometerSeparator}} {{mktProps.odometerAbbreviation}}</td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.odometerEffect | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.standardVehicle.odometerEffect | numberLocale :mktProps.valueSeparator }}</ng-template>  \r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.ageEffect}}</td>\r\n                      <td>{{ vehicle.standardVehicle.ageDiffMonths }} {{lngProperties.monthsTraslation}}</td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.ageEffect }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.standardVehicle.ageEffect }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>\r\n                        {{ resultsProps.tooltips.priceDiff.regionalEffect}}\r\n                      </td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.regionalEffect | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.standardVehicle.regionalEffect | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr *ngIf=\"vehicle.standardVehicle.optionsAvailability == 'UNKNOWN' && vehicle.standardVehicle.typicalOptionEffect != NULL && vehicle.options.length == 0\">\r\n                      <td>{{ resultsProps.tooltips.priceDiff.equipmentAverage}}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.typicalOptionEffect | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{mktProps.currencySymbol }} {{ vehicle.standardVehicle.typicalOptionEffect | numberLocale :mktProps.valueSeparator }}</ng-template>    \r\n                      </td>\r\n                    </tr>\r\n                    <tr *ngIf=\"vehicle.standardVehicle.optionsAvailability == 'UNKNOWN' && vehicle.standardVehicle.typicalOptionEffect == NULL && vehicle.options.length == 0\">\r\n                      <td>{{ resultsProps.tooltips.priceDiff.options}}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        {{ resultsProps.tooltips.priceDiff.noOptions }}\r\n                      </td>\r\n                    </tr>\r\n\r\n                    <tr *ngIf=\"vehicle.standardVehicle.optionsAvailability == 'UNKNOWN' && \r\n                                vehicle.dataOrigin == 'OwnVehicle' && \r\n                                vehicle.standardVehicle.typicalOptionEffect == NULL && \r\n                                vehicle.options.length > 0\">\r\n                      <td>{{ resultsProps.tooltips.priceDiff.options}}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        {{vehicle?.options[0].value}} {{ mktProps.currencySymbol }}\r\n                      </td>\r\n                    </tr>\r\n\r\n                    <tr *ngIf=\"vehicle.standardVehicle.optionsAvailability != 'UNKNOWN'\">\r\n                      <td>{{ resultsProps.tooltips.priceDiff.options }}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"vehicle?.totalOptionValue == 0 && vehicle.dataOrigin == 'OwnVehicle'\">{{ resultsProps.tooltips.priceDiff.noOptions }}</ng-template>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore && vehicle?.totalOptionValue == 0 && vehicle.dataOrigin != 'OwnVehicle'\">{{ vehicle.totalOptionValue | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore && vehicle?.totalOptionValue == 0 && vehicle.dataOrigin != 'OwnVehicle'\">{{ mktProps.currencySymbol }} {{ vehicle.totalOptionValue | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore && vehicle?.totalOptionValue != 0\">{{ vehicle.totalOptionValue | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore && vehicle?.totalOptionValue != 0\">{{ mktProps.currencySymbol }} {{ vehicle.totalOptionValue | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <ng-template [ngIf]=\"vehicle.options?.length > 0 && vehicle.standardVehicle.optionsAvailability != 'UNKNOWN'\">\r\n                      <tr *ngFor=\"let option of vehicle.options\">\r\n                        <td>{{option?.description}}</td>\r\n                        <td></td>\r\n                        <td><img class=\"option-ok--img\" src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDUxNS41NTYgNTE1LjU1NiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBkPSJtMCAyNzQuMjI2IDE3Ni41NDkgMTc2Ljg4NiAzMzkuMDA3LTMzOC42NzItNDguNjctNDcuOTk3LTI5MC4zMzcgMjkwLTEyOC41NTMtMTI4LjU1MnoiIGZpbGw9IiMwMDhmYzgiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIHN0eWxlPSIiPjwvcGF0aD48L2c+PC9zdmc+\" /></td>\r\n                      </tr>\r\n                    </ng-template>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.totalEffects | numberLocale :mktProps.odometerSeparator}}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.standardVehicle.totalEffects | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.standardVehicle.totalEffects | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.regionalAskingPrice }}</td>\r\n                      <td></td>\r\n                      <td class=\"td-bold\">\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr *ngIf=\"vehicle.sellingSpotPriceDiscount != null\"> <!--  Only on AT market -->\r\n                      <td class=\"\"><i>Nachlass</i></td>\r\n                      <td></td>\r\n                      <td class=\"\">\r\n                       {{ vehicle.sellingSpotPriceDiscount | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}\r\n                      </td>\r\n                    </tr>\r\n                    <tr *ngIf=\"vehicle.sellingSpotPriceDiscount != null\">\r\n                      <td class=\"td-bold\">Eurotax Verkaufskurs</td> <!--  Only on AT market -->\r\n                      <td></td>\r\n                      <td class=\"td-bold\">\r\n                        {{ vehicle.sellingSpotPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td>{{ resultsProps.tooltips.priceDiff.askingPrice }}</td>\r\n                      <td></td>\r\n                      <td>\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.askingPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.askingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr style=\"border-top: 2px dashed #212529;\">\r\n                      <td *ngIf=\"vehicle.priceDifferenceCurrency < 0\"class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.underpriced }}</td>\r\n                      <td *ngIf=\"vehicle.priceDifferenceCurrency > 0\" class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.overpriced }}</td>\r\n                      <td *ngIf=\"vehicle.priceDifferenceCurrency === 0\" class=\"td-bold\">{{ resultsProps.tooltips.priceDiff.priceDifference }}</td>\r\n                      <td></td>\r\n                      <td [ngClass]=\"{\r\n                        diffDown: vehicle.priceDifferenceCurrency < 0,\r\n                        diffUp: vehicle.priceDifferenceCurrency > 0}\" class=\"td-bold\">\r\n                        <ng-template [ngIf]=\"!currencySymbolBefore\">{{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                        <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{ vehicle.priceDifferenceCurrency | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n                      </td>\r\n                    </tr>\r\n                    <tr>\r\n                      <td class=\"td-bold\">{{resultsProps?.tooltips.priceDiff?.priceDiffPercentage}}</td>\r\n                      <td></td>\r\n                      <td [ngClass]=\"{\r\n                        diffDown: vehicle.priceDifferenceCurrency < 0,\r\n                        diffUp: vehicle.priceDifferenceCurrency > 0}\" class=\"td-bold\" >\r\n                        {{ vehicle.priceDifferencePercentage }} %\r\n                      </td>\r\n                    </tr>\r\n                  </tbody>\r\n                </table>\r\n              </ng-template>\r\n              <!-- END OF TOOLTIP CONTAINER -->\r\n            </span>\r\n              <span>\r\n                <ng-template [ngIf]=\"!currencySymbolBefore\">{{vehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }} {{vehicle.regionalAskingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>\r\n              </span>\r\n            </div>\r\n            <div class=\"cont\" [ngClass]=\"{\r\n                      contBackgroundLow: vehicle.askingPrice < vehicle.regionalAskingPrice,\r\n                      contBackgroundHigh: vehicle.askingPrice > vehicle.regionalAskingPrice, \r\n                      contBackgroundSame: vehicle.askingPrice == vehicle.regionalAskingPrice}\">\r\n              <div id=\"priceBarOne{{i}}\" class=\"one\"></div>\r\n              <div id=\"priceBarTwo{{i}}\" class=\"two\"></div>\r\n            </div>\r\n          </div>\r\n        </td>\r\n        <td class=\"txt-center\">\r\n          <span *ngIf=\"vehicle.dataOrigin != 'OwnVehicle'\" class=\"icon\" [ngClass]=\"{\r\n              'icon-green': vehicle.similarityCategory === 0,\r\n              'icon-blue': vehicle.similarityCategory === 1,\r\n              'icon-yellow': vehicle.similarityCategory === 2,\r\n              'icon-orange': vehicle.similarityCategory === 3\r\n            }\">\r\n          </span>\r\n          <span *ngIf=\"vehicle.dataOrigin === 'OwnVehicle'\">-</span>\r\n        </td>\r\n        <td class=\"txt-center nowrap\">{{ vehicle.distance }} {{mktProps.odometerAbbreviation }}</td>\r\n        <td class=\"txt-center\">{{ vehicle.odometer | numberLocale :mktProps.odometerSeparator }}</td>\r\n        <td class=\"txt-center\" style=\"position:relative\">{{ vehicle.regDate | date: mktProps.datePattern }} \r\n          <span style=\"position: absolute;left: 44%;bottom: 5px;float: right;\" *ngIf=\"vehicle.directImport == true\" class=\"info tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"directImportTooltip\" tooltipClass=\"tooltip-style-1\">\r\n            <img src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQ1Ljk5OSA0NS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTM5LjI2NCw2LjczNmMtOC45ODItOC45ODEtMjMuNTQ1LTguOTgyLTMyLjUyOCwwYy04Ljk4Miw4Ljk4Mi04Ljk4MSwyMy41NDUsMCwzMi41MjhjOC45ODIsOC45OCwyMy41NDUsOC45ODEsMzIuNTI4LDAgICAgQzQ4LjI0NSwzMC4yODEsNDguMjQ0LDE1LjcxOSwzOS4yNjQsNi43MzZ6IE0yNS45OTksMzNjMCwxLjY1Ny0xLjM0MywzLTMsM3MtMy0xLjM0My0zLTNWMjFjMC0xLjY1NywxLjM0My0zLDMtM3MzLDEuMzQzLDMsM1YzM3ogICAgIE0yMi45NDYsMTUuODcyYy0xLjcyOCwwLTIuODgtMS4yMjQtMi44NDQtMi43MzVjLTAuMDM2LTEuNTg0LDEuMTE2LTIuNzcxLDIuODc5LTIuNzcxYzEuNzY0LDAsMi44OCwxLjE4OCwyLjkxNywyLjc3MSAgICBDMjUuODk3LDE0LjY0OCwyNC43NDYsMTUuODcyLDIyLjk0NiwxNS44NzJ6IiBmaWxsPSIjMDA4ZmM4IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg==\" />\r\n          </span>\r\n          <ng-template #directImportTooltip>\r\n            <table style=\"width: 200px;\" class=\"table table-striped tooltip-table price-tooltip--table\">\r\n              <thead>\r\n                <tr>\r\n                  <th colspan=\"3\">{{ resultsProps.tooltips.directImportFlag.header | uppercase }}</th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr>\r\n                  <td style=\"text-align: left;\">\r\n                    {{ resultsProps.tooltips.directImportFlag.content}}\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n        </ng-template>\r\n        </td>\r\n        <td class=\"txt-right\" style=\"width: 150px;\"><span>{{ vehicle.sellerName }}</span></td>\r\n        <td class=\"txt-center\">{{ vehicle.stockDays }}</td>\r\n        <td class=\"txt-center\">\r\n          <span *ngIf=\"vehicle.dataOrigin != 'OwnVehicle'\" class=\"tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"changesTooltip\" tooltipClass=\"tooltip-style-1\" (click)=\"getPriceHistory(vehicle.vehicleId)\"\r\n            placement=\"bottom-right\">{{ vehicle.numberOfPriceChanges }}</span>\r\n          <span *ngIf=\"vehicle.dataOrigin === 'OwnVehicle'\" class=\"d-none d-md-block\">{{ vehicle.numberOfPriceChanges }}</span>\r\n          <span class=\"d-md-none\">{{ vehicle.numberOfPriceChanges }}</span>\r\n          <!-- TOOLTIP CONTAINER: price changes -->\r\n          <ng-template #changesTooltip>\r\n            <table class=\"table table-striped tooltip-table\">\r\n              <thead>\r\n                <tr>\r\n                  <th colspan=\"3\">{{ resultsProps.tooltips.priceHistory.header | uppercase }}</th>\r\n                </tr>\r\n              </thead>\r\n              <span *ngIf=\"tooltipLoadingFlag\"><div class=\"lds-ellipsis lds-tooltip\"><div></div><div></div><div></div><div></div></div></span>\r\n              <tbody *ngIf=\"!tooltipLoadingFlag\">\r\n                <tr *ngFor=\"let i = index; let item of priceHistory\">\r\n                  <td>{{ item.date | date: mktProps.datePattern }}</td>\r\n                  <td>{{ item.priceHistoryType | priceChangesMapping }}</td>\r\n                  <td>\r\n                    <ng-template [ngIf]=\"!currencySymbolBefore\"> {{ item.regionalAskingPrice | numberLocale :mktProps.valueSeparator }} {{mktProps.currencySymbol }}</ng-template>\r\n                    <ng-template [ngIf]=\"currencySymbolBefore\">{{ mktProps.currencySymbol }}  {{ item.regionalAskingPrice | numberLocale :mktProps.valueSeparator }}</ng-template>    \r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n            <table *ngIf=\"vehicle.isSold == true && vehicle.dateAdRemoved\" class=\"table table-striped tooltip-table\">\r\n              <thead>\r\n                <tr>\r\n                  <th colspan=\"3\">{{ resultsProps.tooltips.priceHistory.dateAdRemoved | uppercase }}</th>\r\n                </tr>\r\n              </thead>\r\n              <span *ngIf=\"tooltipLoadingFlag\"><div class=\"lds-ellipsis lds-tooltip\"><div></div><div></div><div></div><div></div></div></span>\r\n              <tbody *ngIf=\"!tooltipLoadingFlag\">\r\n                <tr>\r\n                  <td>{{ vehicle.dateAdRemoved | date: mktProps.datePattern }}</td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </ng-template>\r\n          <!-- END OF TOOLTIP CONTAINER -->\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}.table-responsive{border-top-right-radius:5px;border-top-left-radius:5px;border:1px solid #dae0e1}table{margin-bottom:0}table thead{background-color:#232c32}table thead th{background-color:#232c32;position:relative;border:none;border-top:1px solid #232C32;font-family:Aileron bold;color:#a1a9ac;font-size:12px;vertical-align:middle;padding:7px 5px}table thead th:hover{color:#fff;cursor:pointer}table thead th .priceBar--header{display:flex;justify-content:space-between;align-items:center}table tbody tr:hover{background-color:#dae0e1}table tbody tr td{vertical-align:middle}.tooltip-table thead tr:hover{background-color:#232c32}.tooltip-table th:hover{color:#a1a9ac!important;cursor:context-menu!important}.tooltip-table td{font-size:14px;font-weight:600}.tooltip-table .td-bold{font-weight:800}.price-tooltip--table td:last-child{text-align:right}.vh-desc{display:flex;font-family:Aileron bold;font-size:14px}.vh-desc span{display:flex;align-self:center}.vh-desc .pic{display:inline-table;width:40px;height:40px;margin-right:10px;margin-left:5px}.vh-desc .pic img{max-width:50px}.vh-desc .hasLinks:hover{cursor:help}.vh-desc .info{min-width:140px;max-width:180px;max-height:60px;overflow:hidden;text-overflow:ellipsis}.vh-desc .isSoldVehicle{text-decoration:line-through;color:#de4a39}.ownVehicleFlagcontainer{position:relative}.ownVehicleFlagcontainer:before{content:\"\";position:absolute;height:calc(100% + 10px);width:5px;top:-5px;left:-10px;border-radius:5px;background-color:#232c32}.option-ok--img{width:20px;height:20px}.icon{display:inline-block;height:10px;width:10px;transform:rotate(45deg);align-self:center}.icon-green{background-color:#00a76e}.icon-blue{background-color:#00a8be}.icon-yellow{background-color:#e1be2b}.icon-orange{background-color:#e36a44}#containerPriceBar{width:230px}#containerPriceBar .labels{display:flex;justify-content:space-between;color:#333;margin-bottom:5px;font-weight:600;font-size:14px}#containerPriceBar .cont{background:#fff;height:7px;border-radius:2px;width:100%;display:flex;justify-content:space-between;-webkit-transform:skew(-20deg);-moz-transform:skew(-20deg);-ms-transform:skew(-20deg);-o-transform:skew(-20deg);transform:skew(-20deg)}#containerPriceBar .one{background:#232c32;height:100%;width:50%;max-width:50%;border-right:2px solid #ffffff}#containerPriceBar .two{background:#a1a9ac;height:100%;width:50%;max-width:50%;border-left:2px solid #ffffff}#containerPriceBar .contBackgroundLow{background-color:#008fc8}#containerPriceBar .contBackgroundHigh{background-color:#de4a39}#containerPriceBar .contBackgroundSame{background-color:#00a76e}.diffUp{color:#de4a39}.diffDown{color:#008fc8}.diffSame{color:#00a76e}.checkbox--item{padding:0 0 0 5px;vertical-align:middle}th[sortable]{cursor:pointer;user-select:none;-webkit-user-select:none}th[sortable].desc:before,th[sortable].asc:before{content:\"\";position:absolute;display:block;background:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQxLjk5OSA0MS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnIHRyYW5zZm9ybT0ibWF0cml4KDYuMTIzMjMzOTk1NzM2NzY2ZS0xNywxLC0xLDYuMTIzMjMzOTk1NzM2NzY2ZS0xNyw0MS45OTk1MDk3NjY2OTc4OCwtMC4wMDA0OTAyMzMzMDIxMTYzOTQpIj4KPHBhdGggeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBkPSJNMzYuMDY4LDIwLjE3NmwtMjktMjBDNi43NjEtMC4wMzUsNi4zNjMtMC4wNTcsNi4wMzUsMC4xMTRDNS43MDYsMC4yODcsNS41LDAuNjI3LDUuNSwwLjk5OXY0MCAgYzAsMC4zNzIsMC4yMDYsMC43MTMsMC41MzUsMC44ODZjMC4xNDYsMC4wNzYsMC4zMDYsMC4xMTQsMC40NjUsMC4xMTRjMC4xOTksMCwwLjM5Ny0wLjA2LDAuNTY4LTAuMTc3bDI5LTIwICBjMC4yNzEtMC4xODcsMC40MzItMC40OTQsMC40MzItMC44MjNTMzYuMzM4LDIwLjM2MywzNi4wNjgsMjAuMTc2eiIgZmlsbD0iI2ZmZmZmZiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgc3R5bGU9IiIgY2xhc3M9IiI+PC9wYXRoPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8L2c+PC9zdmc+) no-repeat;background-size:10px;width:10px;height:10px;bottom:0;left:calc(50% - 5px)}th[sortable].desc:before{transform:rotate(180deg);-ms-transform:rotate(180deg);top:-1px;bottom:unset}.img-tooltip--container .img-zoomed{max-width:180px;height:auto}\n"] }]
        }], ctorParameters: () => [{ type: LiveRetailLibService }, { type: VehicleDescriptionService }, { type: PriceHistoryService }], propDecorators: { listOfVehicles: [{
                type: Input
            }], ownVehicle: [{
                type: Input
            }], headers: [{
                type: ViewChildren,
                args: [NgbdSortableHeader]
            }] } });

class MatchesComponent {
    constructor(dataService) {
        this.dataService = dataService;
    }
    ngOnInit() {
        this.lngConfig = this.dataService.getLanguageConfig();
        this.matchesProps = this.dataService.getLanguageProperties().matches;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: MatchesComponent, deps: [{ token: LiveRetailLibService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: MatchesComponent, selector: "app-matches", inputs: { advertsObject: "advertsObject" }, ngImport: i0, template: "<div class=\"matches--content\">\r\n  <div class=\"item--container\">\r\n    <div class=\"item\">\r\n      <span class=\"param\">{{ matchesProps.exact | uppercase }}</span>\r\n      <span class=\"icon icon-green\"></span>\r\n      <span class=\"value\">{{advertsObject?.exactMatches}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <span class=\"param\">{{ matchesProps.best | uppercase }}</span>\r\n      <span class=\"icon icon-blue\"></span>\r\n      <span class=\"value\">{{advertsObject?.veryHighMatches}}</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"item--container\">\r\n    <div class=\"item\">\r\n      <span class=\"param\">{{ matchesProps.close | uppercase }}</span>\r\n      <span class=\"icon icon-yellow\"></span>\r\n      <span class=\"value\">{{advertsObject?.highMatches}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <span class=\"param\">{{ matchesProps.similar | uppercase }}</span>\r\n      <span class=\"icon icon-orange\"></span>\r\n      <span class=\"value\">{{advertsObject?.mediumMatches}}</span>\r\n    </div>\r\n  </div>\r\n  <span class=\"info tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"matchesTooltip\" placement=\"bottom-right\" tooltipClass=\"tooltip-style-1\">\r\n    <img style=\"vertical-align: super;\"\r\n      src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQ1Ljk5OSA0NS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTM5LjI2NCw2LjczNmMtOC45ODItOC45ODEtMjMuNTQ1LTguOTgyLTMyLjUyOCwwYy04Ljk4Miw4Ljk4Mi04Ljk4MSwyMy41NDUsMCwzMi41MjhjOC45ODIsOC45OCwyMy41NDUsOC45ODEsMzIuNTI4LDAgICAgQzQ4LjI0NSwzMC4yODEsNDguMjQ0LDE1LjcxOSwzOS4yNjQsNi43MzZ6IE0yNS45OTksMzNjMCwxLjY1Ny0xLjM0MywzLTMsM3MtMy0xLjM0My0zLTNWMjFjMC0xLjY1NywxLjM0My0zLDMtM3MzLDEuMzQzLDMsM1YzM3ogICAgIE0yMi45NDYsMTUuODcyYy0xLjcyOCwwLTIuODgtMS4yMjQtMi44NDQtMi43MzVjLTAuMDM2LTEuNTg0LDEuMTE2LTIuNzcxLDIuODc5LTIuNzcxYzEuNzY0LDAsMi44OCwxLjE4OCwyLjkxNywyLjc3MSAgICBDMjUuODk3LDE0LjY0OCwyNC43NDYsMTUuODcyLDIyLjk0NiwxNS44NzJ6IiBmaWxsPSIjMDA4ZmM4IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg==\" />\r\n  </span>\r\n  <ng-template #matchesTooltip>\r\n    <div class=\"dc-style--tooltip\">\r\n      <p>{{ matchesProps?.matchesTooltip.content }}</p>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}.matches--content{font-family:Aileron semibold;display:flex;justify-content:flex-end;margin:-25px 0 20px;width:auto;align-self:flex-end;position:relative;color:#a1a9ac}.matches--content .item--container{display:flex;position:relative}.matches--content .item--container:not(:first-child){margin-left:40px}.matches--content .item{display:flex}.matches--content .item:not(:first-child){margin-left:40px}.matches--content .param{margin-right:10px;box-sizing:none}.matches--content .icon{height:10px;width:10px;transform:rotate(45deg);align-self:center}.matches--content .icon-green{background-color:#00a76e}.matches--content .icon-blue{background-color:#00a8be}.matches--content .icon-yellow{background-color:#e1be2b}.matches--content .icon-orange{background-color:#e36a44}.matches--content .value{font-size:14px;margin-left:7px;line-height:14px;align-self:center;color:#232c32}@media (max-width: 1080px){.matches--content .item:not(:first-child){margin-left:15px}.matches--content .item--container:not(:first-child){margin-left:15px}}@media (max-width: 992px){.matches--content{margin-top:10px;justify-content:center}}@media (max-width: 600px){.matches--content{flex-direction:column;align-items:center}.matches--content .item{font-size:14px;text-align:center}.matches--content .item:not(:first-child){margin-left:10px}.matches--content .item--container:not(:first-child){margin-left:0}.matches--content .value{margin-left:5px}}span.tooltip-trigger{z-index:9;align-self:center;width:15px;height:15px;margin-left:20px;margin-right:10px}@media (max-width: 1080px){span.tooltip-trigger{left:-10px}}\n"], dependencies: [{ kind: "directive", type: i5.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { kind: "pipe", type: i4.UpperCasePipe, name: "uppercase" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: MatchesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-matches', template: "<div class=\"matches--content\">\r\n  <div class=\"item--container\">\r\n    <div class=\"item\">\r\n      <span class=\"param\">{{ matchesProps.exact | uppercase }}</span>\r\n      <span class=\"icon icon-green\"></span>\r\n      <span class=\"value\">{{advertsObject?.exactMatches}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <span class=\"param\">{{ matchesProps.best | uppercase }}</span>\r\n      <span class=\"icon icon-blue\"></span>\r\n      <span class=\"value\">{{advertsObject?.veryHighMatches}}</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"item--container\">\r\n    <div class=\"item\">\r\n      <span class=\"param\">{{ matchesProps.close | uppercase }}</span>\r\n      <span class=\"icon icon-yellow\"></span>\r\n      <span class=\"value\">{{advertsObject?.highMatches}}</span>\r\n    </div>\r\n    <div class=\"item\">\r\n      <span class=\"param\">{{ matchesProps.similar | uppercase }}</span>\r\n      <span class=\"icon icon-orange\"></span>\r\n      <span class=\"value\">{{advertsObject?.mediumMatches}}</span>\r\n    </div>\r\n  </div>\r\n  <span class=\"info tooltip-trigger d-none d-md-block\" [ngbTooltip]=\"matchesTooltip\" placement=\"bottom-right\" tooltipClass=\"tooltip-style-1\">\r\n    <img style=\"vertical-align: super;\"\r\n      src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDQ1Ljk5OSA0NS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPGc+CgkJPHBhdGggZD0iTTM5LjI2NCw2LjczNmMtOC45ODItOC45ODEtMjMuNTQ1LTguOTgyLTMyLjUyOCwwYy04Ljk4Miw4Ljk4Mi04Ljk4MSwyMy41NDUsMCwzMi41MjhjOC45ODIsOC45OCwyMy41NDUsOC45ODEsMzIuNTI4LDAgICAgQzQ4LjI0NSwzMC4yODEsNDguMjQ0LDE1LjcxOSwzOS4yNjQsNi43MzZ6IE0yNS45OTksMzNjMCwxLjY1Ny0xLjM0MywzLTMsM3MtMy0xLjM0My0zLTNWMjFjMC0xLjY1NywxLjM0My0zLDMtM3MzLDEuMzQzLDMsM1YzM3ogICAgIE0yMi45NDYsMTUuODcyYy0xLjcyOCwwLTIuODgtMS4yMjQtMi44NDQtMi43MzVjLTAuMDM2LTEuNTg0LDEuMTE2LTIuNzcxLDIuODc5LTIuNzcxYzEuNzY0LDAsMi44OCwxLjE4OCwyLjkxNywyLjc3MSAgICBDMjUuODk3LDE0LjY0OCwyNC43NDYsMTUuODcyLDIyLjk0NiwxNS44NzJ6IiBmaWxsPSIjMDA4ZmM4IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBzdHlsZT0iIiBjbGFzcz0iIj48L3BhdGg+Cgk8L2c+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPC9nPgo8ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8L2c+CjxnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjwvZz4KPC9nPjwvc3ZnPg==\" />\r\n  </span>\r\n  <ng-template #matchesTooltip>\r\n    <div class=\"dc-style--tooltip\">\r\n      <p>{{ matchesProps?.matchesTooltip.content }}</p>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}.matches--content{font-family:Aileron semibold;display:flex;justify-content:flex-end;margin:-25px 0 20px;width:auto;align-self:flex-end;position:relative;color:#a1a9ac}.matches--content .item--container{display:flex;position:relative}.matches--content .item--container:not(:first-child){margin-left:40px}.matches--content .item{display:flex}.matches--content .item:not(:first-child){margin-left:40px}.matches--content .param{margin-right:10px;box-sizing:none}.matches--content .icon{height:10px;width:10px;transform:rotate(45deg);align-self:center}.matches--content .icon-green{background-color:#00a76e}.matches--content .icon-blue{background-color:#00a8be}.matches--content .icon-yellow{background-color:#e1be2b}.matches--content .icon-orange{background-color:#e36a44}.matches--content .value{font-size:14px;margin-left:7px;line-height:14px;align-self:center;color:#232c32}@media (max-width: 1080px){.matches--content .item:not(:first-child){margin-left:15px}.matches--content .item--container:not(:first-child){margin-left:15px}}@media (max-width: 992px){.matches--content{margin-top:10px;justify-content:center}}@media (max-width: 600px){.matches--content{flex-direction:column;align-items:center}.matches--content .item{font-size:14px;text-align:center}.matches--content .item:not(:first-child){margin-left:10px}.matches--content .item--container:not(:first-child){margin-left:0}.matches--content .value{margin-left:5px}}span.tooltip-trigger{z-index:9;align-self:center;width:15px;height:15px;margin-left:20px;margin-right:10px}@media (max-width: 1080px){span.tooltip-trigger{left:-10px}}\n"] }]
        }], ctorParameters: () => [{ type: LiveRetailLibService }], propDecorators: { advertsObject: [{
                type: Input
            }] } });

class ScatterGraphComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.exactMatchValues = [];
        this.bestMatchValues = [];
        this.closeMatchValues = [];
        this.similarMatchValues = [];
        this.ownVehicleValues = [];
        this.exactMatchesVehicles = [];
        this.bestMatchesVehicles = [];
        this.closeMatchesVehicles = [];
        this.similarMatchesVehicles = [];
        this.currencySymbolBefore = false;
        this.tooltipLoadingFlag = true;
        this.scatterLoading = true;
    }
    ngOnInit() {
        this.matchesProps = this.dataService.getLanguageProperties().matches;
        this.reportProps = this.dataService.getLanguageProperties().report;
        this.resultsProps = this.dataService.getLanguageProperties().results;
        this.mktProps = this.dataService.getMarketConfig().config;
        if (this.mktProps.currencySymbol == '£') {
            this.currencySymbolBefore = true;
        }
        else {
            this.currencySymbolBefore = false;
        }
    }
    ngOnChanges() {
        this.getGraphData();
    }
    openGraph() {
        this.scatterLoading = true;
        setTimeout(() => this.scatterLoading = false, 1000);
    }
    getGraphData() {
        this.tooltipLoadingFlag = true;
        // console.log(this.listOfVehicles)
        if (this.listOfVehicles && this.listOfVehicles.length > 1 && this.listOfVehicles[0]) {
            for (let i = 0; i < this.listOfVehicles.length; i++) {
                if (this.listOfVehicles[i].similarityCategory === 0 && this.listOfVehicles[i].isOwnVehicle === false) {
                    this.exactMatchValues.push([
                        this.listOfVehicles[i].regionalAskingPrice,
                        this.listOfVehicles[i].askingPrice
                    ]);
                    this.exactMatchesVehicles.push(this.listOfVehicles[i]);
                }
                //set own vehicle.
                if (this.listOfVehicles[i].isOwnVehicle === true) {
                    this.ownVehiclePriceDifferenceCurrency = this.listOfVehicles[i].priceDifferenceCurrency;
                    this.ownVehicleValues.push([
                        this.listOfVehicles[i].regionalAskingPrice,
                        this.listOfVehicles[i].askingPrice
                    ]);
                }
            }
            for (let i = 0; i < this.listOfVehicles.length; i++) {
                if (this.listOfVehicles[i].similarityCategory === 1) {
                    this.bestMatchValues.push([
                        this.listOfVehicles[i].regionalAskingPrice,
                        this.listOfVehicles[i].askingPrice
                    ]);
                    this.bestMatchesVehicles.push(this.listOfVehicles[i]);
                }
            }
            for (let i = 0; i < this.listOfVehicles.length; i++) {
                if (this.listOfVehicles[i].similarityCategory === 2) {
                    this.closeMatchValues.push([
                        this.listOfVehicles[i].regionalAskingPrice,
                        this.listOfVehicles[i].askingPrice
                    ]);
                    this.closeMatchesVehicles.push(this.listOfVehicles[i]);
                }
            }
            for (let i = 0; i < this.listOfVehicles.length; i++) {
                if (this.listOfVehicles[i].similarityCategory === 3) {
                    this.similarMatchValues.push([
                        this.listOfVehicles[i].regionalAskingPrice,
                        this.listOfVehicles[i].askingPrice
                    ]);
                    this.similarMatchesVehicles.push(this.listOfVehicles[i]);
                }
            }
            this.tooltipLoadingFlag = false;
            this.graphConfig();
        }
        else {
            this.exactMatchValues = [];
            this.bestMatchValues = [];
            this.closeMatchValues = [];
            this.similarMatchValues = [];
            this.ownVehicleValues = [];
            this.bestMatchesVehicles = [];
            this.exactMatchesVehicles = [];
            this.closeMatchesVehicles = [];
            this.similarMatchesVehicles = [];
            this.tooltipLoadingFlag = true;
        }
    }
    graphConfig() {
        var exactVehicles = this.exactMatchesVehicles;
        var bestVehicles = this.bestMatchesVehicles;
        var closeVehicles = this.closeMatchesVehicles;
        var similarVehicles = this.similarMatchesVehicles;
        var ownVehicle = this.ownVehicleValues;
        var exactKey = this.matchesProps.exact.toUpperCase();
        var bestKey = this.matchesProps.best.toUpperCase();
        var closeKey = this.matchesProps.close.toUpperCase();
        var similarKey = this.matchesProps.similar.toUpperCase();
        function findAdExact(val) {
            if (exactVehicles[val]?.advertisementUrl && exactVehicles[val]?.advertisementUrl != '#') {
                window.open(exactVehicles[val].advertisementUrl);
            }
        }
        function findAdBest(val) {
            if (bestVehicles[val]?.advertisementUrl && bestVehicles[val]?.advertisementUrl != '#') {
                window.open(bestVehicles[val].advertisementUrl);
            }
        }
        function findAdClose(val) {
            if (closeVehicles[val]?.advertisementUrl && closeVehicles[val]?.advertisementUrl != '#') {
                window.open(closeVehicles[val].advertisementUrl);
            }
        }
        function findAdSimilar(val) {
            if (similarVehicles[val]?.advertisementUrl && similarVehicles[val]?.advertisementUrl != '#') {
                window.open(similarVehicles[val].advertisementUrl);
            }
        }
        var exactMatchSerie = {
            name: this.matchesProps.exact.toUpperCase(),
            data: this.exactMatchValues
        };
        var bestMatchSerie = {
            name: this.matchesProps.best.toUpperCase(),
            data: this.bestMatchValues
        };
        var closeMatchSerie = {
            name: this.matchesProps.close.toUpperCase(),
            data: this.closeMatchValues
        };
        var similarMatchSerie = {
            name: this.matchesProps.similar.toUpperCase(),
            data: this.similarMatchValues
        };
        var ownVehicleSerie = {
            name: this.resultsProps.ownVehicle.toUpperCase(),
            data: this.ownVehicleValues
        };
        var seriesObject;
        var colorsObject;
        var currencySymbol = this.mktProps.currencySymbol;
        var thousandSymbol = this.mktProps.valueSeparator;
        var graphTextAvg = this.reportProps.graph.avg.toUpperCase();
        var graphTextLiveRetailPrice = this.reportProps.graph.liveRetailPrice.toUpperCase();
        var graphTextAsking = this.resultsProps.askPrice.toUpperCase();
        var graphTextLrp = this.reportProps.graph.lrp.toUpperCase();
        var overpricedTxt = this.resultsProps.tooltips.priceDiff.overpriced;
        var underpricedTxt = this.resultsProps.tooltips.priceDiff.underpriced;
        var priceDiff;
        var ownVhPriceDiff = this.ownVehiclePriceDifferenceCurrency;
        // console.log(ownVhPriceDiff)
        function setPriceDiffLabel(value) {
            switch (value.seriesIndex) {
                case 0:
                    // console.log(exactVehicles[value.dataPointIndex].priceDifferenceCurrency);
                    if (exactVehicles[value.dataPointIndex].priceDifferenceCurrency > 0) {
                        if (currencySymbolBefore) {
                            priceDiff = `<span style="color: #DE4A39;">[ ${overpricedTxt}: ${currencySymbol} ${exactVehicles[value.dataPointIndex].priceDifferenceCurrency} ]</span>`;
                        }
                        else {
                            priceDiff = `<span style="color: #DE4A39;">[ ${overpricedTxt}: ${exactVehicles[value.dataPointIndex].priceDifferenceCurrency} ${currencySymbol} ]</span>`;
                        }
                    }
                    else if (exactVehicles[value.dataPointIndex].priceDifferenceCurrency < 0) {
                        if (currencySymbolBefore) {
                            priceDiff = `<span style="color: #008FC8;">[ ${underpricedTxt}: ${currencySymbol} ${exactVehicles[value.dataPointIndex].priceDifferenceCurrency} ]</span>`;
                        }
                        else {
                            priceDiff = `<span style="color: #008FC8;">[ ${underpricedTxt}: ${exactVehicles[value.dataPointIndex].priceDifferenceCurrency} ${currencySymbol} ]</span>`;
                        }
                    }
                    else {
                        priceDiff = '';
                    }
                    return priceDiff;
                case 1:
                    // console.log(bestVehicles[value.dataPointIndex].priceDifferenceCurrency);
                    if (bestVehicles[value.dataPointIndex].priceDifferenceCurrency > 0) {
                        if (currencySymbolBefore) {
                            priceDiff = `<span style="color: #DE4A39;">[ ${overpricedTxt}: ${currencySymbol} ${bestVehicles[value.dataPointIndex].priceDifferenceCurrency} ]</span>`;
                        }
                        else {
                            priceDiff = `<span style="color: #DE4A39;">[ ${overpricedTxt}: ${bestVehicles[value.dataPointIndex].priceDifferenceCurrency} ${currencySymbol} ]</span>`;
                        }
                    }
                    else if (bestVehicles[value.dataPointIndex].priceDifferenceCurrency < 0) {
                        if (currencySymbolBefore) {
                            priceDiff = `<span style="color: #008FC8;">[ ${underpricedTxt}: ${currencySymbol} ${bestVehicles[value.dataPointIndex].priceDifferenceCurrency} ]</span>`;
                        }
                        else {
                            priceDiff = `<span style="color: #008FC8;">[ ${underpricedTxt}: ${bestVehicles[value.dataPointIndex].priceDifferenceCurrency} ${currencySymbol} ]</span>`;
                        }
                    }
                    else {
                        priceDiff = '';
                    }
                    return priceDiff;
                case 2:
                    // console.log(closeVehicles[value.dataPointIndex].priceDifferenceCurrency);
                    if (closeVehicles[value.dataPointIndex].priceDifferenceCurrency > 0) {
                        if (currencySymbolBefore) {
                            priceDiff = `<span style="color: #DE4A39;">[ ${overpricedTxt}: ${currencySymbol} ${closeVehicles[value.dataPointIndex].priceDifferenceCurrency} ]</span>`;
                        }
                        else {
                            priceDiff = `<span style="color: #DE4A39;">[ ${overpricedTxt}: ${closeVehicles[value.dataPointIndex].priceDifferenceCurrency} ${currencySymbol} ]</span>`;
                        }
                    }
                    else if (closeVehicles[value.dataPointIndex].priceDifferenceCurrency < 0) {
                        if (currencySymbolBefore) {
                            priceDiff = `<span style="color: #008FC8;">[ ${underpricedTxt}: ${currencySymbol} ${closeVehicles[value.dataPointIndex].priceDifferenceCurrency} ]</span>`;
                        }
                        else {
                            priceDiff = `<span style="color: #008FC8;">[ ${underpricedTxt}: ${closeVehicles[value.dataPointIndex].priceDifferenceCurrency} ${currencySymbol} ]</span>`;
                        }
                    }
                    else {
                        priceDiff = '';
                    }
                    return priceDiff;
                case 3:
                    // console.log(similarVehicles[value.dataPointIndex].priceDifferenceCurrency);
                    if (similarVehicles[value.dataPointIndex].priceDifferenceCurrency > 0) {
                        if (currencySymbolBefore) {
                            priceDiff = `<span style="color: #DE4A39;">[ ${overpricedTxt}: ${currencySymbol} ${similarVehicles[value.dataPointIndex].priceDifferenceCurrency} ]</span>`;
                        }
                        else {
                            priceDiff = `<span style="color: #DE4A39;">[ ${overpricedTxt}: ${similarVehicles[value.dataPointIndex].priceDifferenceCurrency} ${currencySymbol} ]</span>`;
                        }
                    }
                    else if (similarVehicles[value.dataPointIndex].priceDifferenceCurrency < 0) {
                        if (currencySymbolBefore) {
                            priceDiff = `<span style="color: #008FC8;">[ ${underpricedTxt}: ${currencySymbol} ${similarVehicles[value.dataPointIndex].priceDifferenceCurrency} ]</span>`;
                        }
                        else {
                            priceDiff = `<span style="color: #008FC8;">[ ${underpricedTxt}: ${similarVehicles[value.dataPointIndex].priceDifferenceCurrency} ${currencySymbol} ]</span>`;
                        }
                    }
                    else {
                        priceDiff = '';
                    }
                    return priceDiff;
                case 4:
                    if (ownVhPriceDiff > 0) {
                        if (currencySymbolBefore) {
                            priceDiff = `<span style="color: #DE4A39;">[ ${overpricedTxt}: ${currencySymbol} ${ownVhPriceDiff} ]</span>`;
                        }
                        else {
                            priceDiff = `<span style="color: #DE4A39;">[ ${overpricedTxt}: ${ownVhPriceDiff} ${currencySymbol} ]</span>`;
                        }
                    }
                    else if (ownVhPriceDiff < 0) {
                        if (currencySymbolBefore) {
                            priceDiff = `<span style="color: #008FC8;">[ ${underpricedTxt}: ${currencySymbol} ${ownVhPriceDiff} ]</span>`;
                        }
                        else {
                            priceDiff = `<span style="color: #008FC8;">[ ${underpricedTxt}: ${ownVhPriceDiff} ${currencySymbol} ]</span>`;
                        }
                    }
                    else {
                        priceDiff = '';
                    }
                    return priceDiff;
            }
        }
        var currencySymbolBefore = false;
        if (currencySymbol == '£')
            currencySymbolBefore = true;
        seriesObject = [exactMatchSerie, bestMatchSerie, closeMatchSerie, similarMatchSerie, ownVehicleSerie];
        colorsObject = ['#00A76E', '#00A8BE', '#E1BE2B', '#DE4A39', '#111'];
        this.chartOptions = {
            annotations: {},
            tooltip: {
                shared: false,
                intersect: true,
                x: {
                    style: {
                        color: '#A1A9AC',
                        fontSize: '11px'
                    },
                    formatter: (value) => {
                        if (currencySymbolBefore) {
                            return `${graphTextLrp} ${currencySymbol} ${numberWithCommas(value)}`;
                        }
                        else {
                            return `${graphTextLrp} ${numberWithCommas(value)} ${currencySymbol}`;
                        }
                        function numberWithCommas(x) {
                            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol);
                        }
                    }
                },
                y: {
                    style: {
                        color: '#A1A9AC',
                        fontSize: '11px'
                    },
                    formatter: (value) => {
                        if (currencySymbolBefore) {
                            return `${graphTextAsking} ${currencySymbol} ${numberWithCommas(value)}  ${priceDiff}`;
                        }
                        else {
                            return `${graphTextAsking} ${numberWithCommas(value)} ${currencySymbol}  ${priceDiff}`;
                        }
                        function numberWithCommas(x) {
                            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol);
                        }
                    }
                }
            },
            series: seriesObject,
            colors: colorsObject,
            legend: {
                show: true,
                showForSingleSeries: true,
                showForNullSeries: true,
                showForZeroSeries: true,
                position: 'bottom',
            },
            chart: {
                animations: {
                    enabled: false
                },
                height: 350,
                width: 600,
                type: 'scatter',
                zoom: {
                    enabled: false
                },
                events: {
                    dataPointSelection: function (event, chartContext, opts) {
                        // console.log(opts.w.config.series[opts.seriesIndex].name);
                        switch (opts.w.config.series[opts.seriesIndex].name) {
                            case exactKey:
                                findAdExact(opts.selectedDataPoints[0][0]);
                                break;
                            case bestKey:
                                findAdBest(opts.selectedDataPoints[1][0]);
                                break;
                            case closeKey:
                                findAdClose(opts.selectedDataPoints[2][0]);
                                break;
                            case similarKey:
                                findAdSimilar(opts.selectedDataPoints[3][0]);
                                break;
                        }
                    },
                    dataPointMouseEnter: function (event, chartContext, opts) {
                        // console.log(opts.w.config.series[opts.seriesIndex].name);
                        setPriceDiffLabel(opts);
                    }
                }
            },
            xaxis: {
                tooltip: {
                    enabled: false
                },
                tickAmount: 10,
                labels: {
                    style: {
                        color: '#A1A9AC',
                        fontSize: '11px'
                    },
                    formatter: function numberWithCommas(x) {
                        if (currencySymbolBefore) {
                            return currencySymbol + ' ' + Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol);
                        }
                        else {
                            return Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol) + ' ' + currencySymbol;
                        }
                    }
                },
                title: {
                    text: graphTextLiveRetailPrice
                }
            },
            yaxis: {
                tooltip: {
                    enabled: false
                },
                tickAmount: 10,
                labels: {
                    style: {
                        color: '#A1A9AC',
                        fontSize: '11px'
                    },
                    formatter: function numberWithCommas(x) {
                        if (currencySymbolBefore) {
                            return currencySymbol + ' ' + Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol);
                        }
                        else {
                            return Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol) + ' ' + currencySymbol;
                        }
                    }
                },
                title: {
                    text: graphTextAsking
                }
            },
            grid: {
                show: true,
                borderColor: '#90A4AE',
                strokeDashArray: 0,
                position: 'back',
                xaxis: {
                    lines: {
                        show: true
                    }
                },
                yaxis: {
                    lines: {
                        show: true
                    }
                }
            },
            markers: {
                size: 7,
                shape: "square",
                radius: 1,
                hover: {
                    size: 10
                }
            }
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ScatterGraphComponent, deps: [{ token: LiveRetailLibService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: ScatterGraphComponent, selector: "app-scatter-graph", inputs: { listOfVehicles: "listOfVehicles" }, viewQueries: [{ propertyName: "chart", first: true, predicate: ["chart"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "\r\n<div class=\"scatter-graph-container\">\r\n  <span *ngIf=\"tooltipLoadingFlag\" class=\"scatterGraph--trigger d-none d-md-block\"><div class=\"loader--container\"><div class=\"lds-ellipsis lds-tooltip\"><div></div><div></div><div></div><div></div></div></div></span>\r\n  <span *ngIf=\"!tooltipLoadingFlag\" class=\"tooltip-trigger scatterGraph--trigger d-none d-md-block\" [ngbTooltip]=\"scatterGraph\" tooltipClass=\"tooltip-style-1\" (click)=\"openGraph()\"><img class=\"scatter--icon\" src=\"data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTEyIDUxMiIgaGVpZ2h0PSI1MTIiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im0zOTIgNTEyaC0yNzJjLTY2LjE2OCAwLTEyMC01My44MzItMTIwLTEyMHYtMjcyYzAtNjYuMTY4IDUzLjgzMi0xMjAgMTIwLTEyMGgyNzJjNjYuMTY4IDAgMTIwIDUzLjgzMiAxMjAgMTIwdjI3MmMwIDY2LjE2OC01My44MzIgMTIwLTEyMCAxMjB6bS0yNzItNDcyYy00NC4xMTIgMC04MCAzNS44ODgtODAgODB2MjcyYzAgNDQuMTEyIDM1Ljg4OCA4MCA4MCA4MGgyNzJjNDQuMTEyIDAgODAtMzUuODg4IDgwLTgwdi0yNzJjMC00NC4xMTItMzUuODg4LTgwLTgwLTgwem0xODUgMTAyYy0xMy44MDcgMC0yNSAxMS4xOTMtMjUgMjVzMTEuMTkzIDI1IDI1IDI1IDI1LTExLjE5MyAyNS0yNS0xMS4xOTMtMjUtMjUtMjV6bS04NiAyNmMtMTMuODA3IDAtMjUgMTEuMTkzLTI1IDI1czExLjE5MyAyNSAyNSAyNSAyNS0xMS4xOTMgMjUtMjUtMTEuMTkzLTI1LTI1LTI1em0xNzAtNjNjLTEzLjgwNyAwLTI1IDExLjE5My0yNSAyNXMxMS4xOTMgMjUgMjUgMjUgMjUtMTEuMTkzIDI1LTI1LTExLjE5My0yNS0yNS0yNXptLTE2NC45NzEgMjIwLjA4Yy0xNS40MDQtMS4yMTUtMjguMTYzIDExLjU0NC0yNi45NDkgMjYuOTQ4Ljk1NiAxMi4xMTggMTAuNzczIDIxLjkzNiAyMi44OTEgMjIuODkxIDE1LjQwNCAxLjIxNSAyOC4xNjMtMTEuNTQ0IDI2Ljk0OC0yNi45NDgtLjk1NS0xMi4xMTgtMTAuNzcyLTIxLjkzNS0yMi44OS0yMi44OTF6bS0xMDEuMDI5IDI2LjkyYy0xMy44MDcgMC0yNSAxMS4xOTMtMjUgMjVzMTEuMTkzIDI1IDI1IDI1IDI1LTExLjE5MyAyNS0yNS0xMS4xOTMtMjUtMjUtMjV6bTI3LTkxYy0xMy44MDcgMC0yNSAxMS4xOTMtMjUgMjVzMTEuMTkzIDI1IDI1IDI1IDI1LTExLjE5MyAyNS0yNS0xMS4xOTMtMjUtMjUtMjV6bTExOC0xNGMtMTMuODA3IDAtMjUgMTEuMTkzLTI1IDI1czExLjE5MyAyNSAyNSAyNSAyNS0xMS4xOTMgMjUtMjUtMTEuMTkzLTI1LTI1LTI1em05NS0yMmMtMTMuODA3IDAtMjUgMTEuMTkzLTI1IDI1czExLjE5MyAyNSAyNSAyNSAyNS0xMS4xOTMgMjUtMjUtMTEuMTkzLTI1LTI1LTI1eiIvPjwvc3ZnPg==\" /></span>\r\n  <ng-template #scatterGraph>\r\n    <div *ngIf=\"scatterLoading\" class=\"loader--container\"><div class=\"lds-ellipsis lds-tooltip\"><div></div><div></div><div></div><div></div></div></div>\r\n      <div *ngIf=\"!scatterLoading\" id=\"chart\">\r\n          <apx-chart\r\n            [series]=\"chartOptions.series\"\r\n            [chart]=\"chartOptions.chart\"\r\n            [xaxis]=\"chartOptions.xaxis\"\r\n            [yaxis]=\"chartOptions.yaxis\"\r\n            [colors]=\"chartOptions.colors\"\r\n            [annotations]=\"chartOptions.annotations\"\r\n            [grid]=\"chartOptions.grid\"\r\n            [tooltip]=\"chartOptions.tooltip\"\r\n            [legend]=\"chartOptions.legend\"\r\n            [markers]=\"chartOptions.markers\"\r\n          ></apx-chart>\r\n        </div>\r\n  </ng-template>\r\n</div>\r\n", styles: [".scatter-graph-container{position:relative}.scatterGraph--trigger{z-index:1;width:80px;height:40px;background:#dae0e1;display:block;position:absolute;right:0;top:5px;border:none;border-radius:4px}.scatterGraph--trigger:hover{border:1px solid black}.lds-tooltip div{top:13px!important}.scatter--icon{margin:5px auto auto;width:30px;display:block}.loader--container{position:relative}\n"], dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.ChartComponent, selector: "apx-chart", inputs: ["chart", "annotations", "colors", "dataLabels", "series", "stroke", "labels", "legend", "markers", "noData", "fill", "tooltip", "plotOptions", "responsive", "xaxis", "yaxis", "forecastDataPoints", "grid", "states", "title", "subtitle", "theme", "autoUpdateSeries"], outputs: ["chartReady"] }, { kind: "directive", type: i5.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "popperOptions", "triggers", "positionTarget", "container", "disableTooltip", "tooltipClass", "tooltipContext", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ScatterGraphComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-scatter-graph', template: "\r\n<div class=\"scatter-graph-container\">\r\n  <span *ngIf=\"tooltipLoadingFlag\" class=\"scatterGraph--trigger d-none d-md-block\"><div class=\"loader--container\"><div class=\"lds-ellipsis lds-tooltip\"><div></div><div></div><div></div><div></div></div></div></span>\r\n  <span *ngIf=\"!tooltipLoadingFlag\" class=\"tooltip-trigger scatterGraph--trigger d-none d-md-block\" [ngbTooltip]=\"scatterGraph\" tooltipClass=\"tooltip-style-1\" (click)=\"openGraph()\"><img class=\"scatter--icon\" src=\"data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTEyIDUxMiIgaGVpZ2h0PSI1MTIiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im0zOTIgNTEyaC0yNzJjLTY2LjE2OCAwLTEyMC01My44MzItMTIwLTEyMHYtMjcyYzAtNjYuMTY4IDUzLjgzMi0xMjAgMTIwLTEyMGgyNzJjNjYuMTY4IDAgMTIwIDUzLjgzMiAxMjAgMTIwdjI3MmMwIDY2LjE2OC01My44MzIgMTIwLTEyMCAxMjB6bS0yNzItNDcyYy00NC4xMTIgMC04MCAzNS44ODgtODAgODB2MjcyYzAgNDQuMTEyIDM1Ljg4OCA4MCA4MCA4MGgyNzJjNDQuMTEyIDAgODAtMzUuODg4IDgwLTgwdi0yNzJjMC00NC4xMTItMzUuODg4LTgwLTgwLTgwem0xODUgMTAyYy0xMy44MDcgMC0yNSAxMS4xOTMtMjUgMjVzMTEuMTkzIDI1IDI1IDI1IDI1LTExLjE5MyAyNS0yNS0xMS4xOTMtMjUtMjUtMjV6bS04NiAyNmMtMTMuODA3IDAtMjUgMTEuMTkzLTI1IDI1czExLjE5MyAyNSAyNSAyNSAyNS0xMS4xOTMgMjUtMjUtMTEuMTkzLTI1LTI1LTI1em0xNzAtNjNjLTEzLjgwNyAwLTI1IDExLjE5My0yNSAyNXMxMS4xOTMgMjUgMjUgMjUgMjUtMTEuMTkzIDI1LTI1LTExLjE5My0yNS0yNS0yNXptLTE2NC45NzEgMjIwLjA4Yy0xNS40MDQtMS4yMTUtMjguMTYzIDExLjU0NC0yNi45NDkgMjYuOTQ4Ljk1NiAxMi4xMTggMTAuNzczIDIxLjkzNiAyMi44OTEgMjIuODkxIDE1LjQwNCAxLjIxNSAyOC4xNjMtMTEuNTQ0IDI2Ljk0OC0yNi45NDgtLjk1NS0xMi4xMTgtMTAuNzcyLTIxLjkzNS0yMi44OS0yMi44OTF6bS0xMDEuMDI5IDI2LjkyYy0xMy44MDcgMC0yNSAxMS4xOTMtMjUgMjVzMTEuMTkzIDI1IDI1IDI1IDI1LTExLjE5MyAyNS0yNS0xMS4xOTMtMjUtMjUtMjV6bTI3LTkxYy0xMy44MDcgMC0yNSAxMS4xOTMtMjUgMjVzMTEuMTkzIDI1IDI1IDI1IDI1LTExLjE5MyAyNS0yNS0xMS4xOTMtMjUtMjUtMjV6bTExOC0xNGMtMTMuODA3IDAtMjUgMTEuMTkzLTI1IDI1czExLjE5MyAyNSAyNSAyNSAyNS0xMS4xOTMgMjUtMjUtMTEuMTkzLTI1LTI1LTI1em05NS0yMmMtMTMuODA3IDAtMjUgMTEuMTkzLTI1IDI1czExLjE5MyAyNSAyNSAyNSAyNS0xMS4xOTMgMjUtMjUtMTEuMTkzLTI1LTI1LTI1eiIvPjwvc3ZnPg==\" /></span>\r\n  <ng-template #scatterGraph>\r\n    <div *ngIf=\"scatterLoading\" class=\"loader--container\"><div class=\"lds-ellipsis lds-tooltip\"><div></div><div></div><div></div><div></div></div></div>\r\n      <div *ngIf=\"!scatterLoading\" id=\"chart\">\r\n          <apx-chart\r\n            [series]=\"chartOptions.series\"\r\n            [chart]=\"chartOptions.chart\"\r\n            [xaxis]=\"chartOptions.xaxis\"\r\n            [yaxis]=\"chartOptions.yaxis\"\r\n            [colors]=\"chartOptions.colors\"\r\n            [annotations]=\"chartOptions.annotations\"\r\n            [grid]=\"chartOptions.grid\"\r\n            [tooltip]=\"chartOptions.tooltip\"\r\n            [legend]=\"chartOptions.legend\"\r\n            [markers]=\"chartOptions.markers\"\r\n          ></apx-chart>\r\n        </div>\r\n  </ng-template>\r\n</div>\r\n", styles: [".scatter-graph-container{position:relative}.scatterGraph--trigger{z-index:1;width:80px;height:40px;background:#dae0e1;display:block;position:absolute;right:0;top:5px;border:none;border-radius:4px}.scatterGraph--trigger:hover{border:1px solid black}.lds-tooltip div{top:13px!important}.scatter--icon{margin:5px auto auto;width:30px;display:block}.loader--container{position:relative}\n"] }]
        }], ctorParameters: () => [{ type: LiveRetailLibService }], propDecorators: { chart: [{
                type: ViewChild,
                args: ['chart']
            }], listOfVehicles: [{
                type: Input
            }] } });

class ScrollUpButtonComponent {
    constructor(document) {
        this.document = document;
    }
    onWindowScroll() {
        if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
            this.windowScrolled = true;
        }
        else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
            this.windowScrolled = false;
        }
    }
    scrollToTop() {
        (function smoothscroll() {
            var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
            if (currentScroll > 0) {
                window.requestAnimationFrame(smoothscroll);
                window.scrollTo(0, currentScroll - (currentScroll / 8));
            }
        })();
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ScrollUpButtonComponent, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: ScrollUpButtonComponent, selector: "scroll-up-button", host: { listeners: { "window:scroll": "onWindowScroll()" } }, ngImport: i0, template: "<!--Scroll to top-->\r\n<div class=\"scroll-to-top\" [ngClass]=\"{'show-scrollTop': windowScrolled}\">\r\n    <button (click)=\"scrollToTop()\" type=\"button\">\r\n      <img src=\"data:image/svg+xml;base64,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\" />\r\n    </button>\r\n  </div>\r\n", styles: [".scroll-to-top{z-index:9;position:fixed;bottom:15px;right:15px;opacity:0;transition:all .2s ease-in-out}.scroll-to-top img{width:20px;height:20px}.scroll-to-top button{border-radius:4px;text-align:center;text-decoration:none;display:inline-block;border:none;background:none;padding-bottom:4px}.scroll-to-top button:hover{background:#d3d3d3;transition:all .2s ease-in-out}.scroll-to-top button:focus{outline:none}.show-scrollTop{opacity:1;transition:all .2s ease-in-out}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ScrollUpButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'scroll-up-button', template: "<!--Scroll to top-->\r\n<div class=\"scroll-to-top\" [ngClass]=\"{'show-scrollTop': windowScrolled}\">\r\n    <button (click)=\"scrollToTop()\" type=\"button\">\r\n      <img src=\"data:image/svg+xml;base64,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\" />\r\n    </button>\r\n  </div>\r\n", styles: [".scroll-to-top{z-index:9;position:fixed;bottom:15px;right:15px;opacity:0;transition:all .2s ease-in-out}.scroll-to-top img{width:20px;height:20px}.scroll-to-top button{border-radius:4px;text-align:center;text-decoration:none;display:inline-block;border:none;background:none;padding-bottom:4px}.scroll-to-top button:hover{background:#d3d3d3;transition:all .2s ease-in-out}.scroll-to-top button:focus{outline:none}.show-scrollTop{opacity:1;transition:all .2s ease-in-out}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { onWindowScroll: [{
                type: HostListener,
                args: ["window:scroll", []]
            }] } });

class LiveRetailLibComponent {
    constructor(config, LiveRetailLibService, advertsService, dataService) {
        this.LiveRetailLibService = LiveRetailLibService;
        this.advertsService = advertsService;
        this.dataService = dataService;
        this.listOfVehicles = null;
        this.initialListOfVehicles = null;
        this.advertsObject = null;
        this.noDataProvidedFlag = false;
        this.onlyOwnVhFlag = false;
        this.wrongDataProvidedFlag = false;
        this.noAskingOrMileageProvidedFlag = false;
        //TOOLTIP COMMON CONFIG.
        config.placement = 'bottom';
        config.triggers = 'click:blur';
        config.autoClose = 'outside';
    }
    ngOnInit() {
        let ownVh = this.ownVehicleParams.ownVehicle;
        if (!ownVh) {
            this.noDataProvidedFlag = true;
        }
        else {
            if (!ownVh.isoLanguage || !ownVh.isoCountry || !ownVh.natCode ||
                !ownVh.vehicleType || !ownVh.regDate ||
                !ownVh.zipcode) {
                this.wrongDataProvidedFlag = true;
            }
            if (!ownVh.askingPrice || ownVh.askingPrice < 1 || !ownVh.odometer || ownVh.odometer < 1) {
                this.noAskingOrMileageProvidedFlag = true;
            }
        }
        this.LiveRetailLibService.getLanguageConfig(this.ownVehicleParams.ownVehicle.isoLanguage, this.ownVehicleParams.ownVehicle.isoCountry);
        this.adverts$ = this.advertsService.resolveAdverts(this.ownVehicleParams, null);
        this.getVehicles();
        this.getAdvertsObject();
        this.lngProps = this.dataService.getLanguageProperties();
    }
    getVehicles() {
        this.advertsSuscription = this.adverts$.subscribe((a) => {
            this.listOfVehicles = a.vehicles;
            if (this.listOfVehicles.length == 1) {
                this.onlyOwnVhFlag = true;
            }
        });
    }
    getAdvertsObject() {
        this.adverts$.subscribe((a) => {
            this.advertsObject = a;
            // console.log(this.advertsObject)
        });
    }
    updateAdvertsFromFilters(data) {
        // console.log("Search Params from parent", data);
        this.listOfVehicles = null;
        this.adverts$ = this.advertsService.resolveAdverts(null, data);
        this.adverts$.subscribe((a) => {
            this.listOfVehicles = a.vehicles;
            this.advertsObject = a;
            // console.log("advertsObject from parent", this.advertsObject)
        });
    }
    closeModal() {
        this.onlyOwnVhFlag = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: LiveRetailLibComponent, deps: [{ token: i5.NgbTooltipConfig }, { token: LiveRetailLibService }, { token: AdvertsService }, { token: LiveRetailLibService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: LiveRetailLibComponent, selector: "liveRetail-lib", inputs: { ownVehicleParams: "ownVehicleParams" }, providers: [NgbTooltipConfig, LiveRetailLibService], ngImport: i0, template: "<main id=\"liveRetailLibContainer\" class=\"container-lg\">\r\n  <!-- Error modal (Only appears when no params provided) -->\r\n  <div *ngIf=\"noDataProvidedFlag\" class=\"row error-modal\"> \r\n    <div>\r\n      <h4>No parameters provided</h4>\r\n      <strong> Expected: ownVehicle(Object)</strong>\r\n      <br>\r\n      <i> Recieved: {{ownVehicleParams | json}} </i>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"onlyOwnVhFlag\" class=\"row error-modal\"> \r\n    <div>\r\n      <h4>{{lngProps.errorCode.onlyOwnVh}}</h4>\r\n      <button class=\"btn btn-md btn-primary\" (click)=\"closeModal()\">CLOSE</button>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"noAskingOrMileageProvidedFlag\" class=\"row error-modal\"> \r\n    <div>\r\n    <strong>{{lngProps.errorCode.wrongAskingOrMileage}}</strong>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"wrongDataProvidedFlag\" class=\"row error-modal\"> \r\n    <div>\r\n      <h4>Missing mandatory parameters</h4>\r\n      <strong>Be sure that the object follows the interface of OwnVehicleParams</strong>\r\n      <!-- <p>Parameters: <br> <i> {{ownVehicleParams.ownVehicle | json}} </i></p>  -->\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"row information--container\">\r\n    <section id=\"report--container\" class=\"col-md-7\">\r\n      <app-scatter-graph [listOfVehicles]=\"listOfVehicles\"></app-scatter-graph>\r\n      <app-report [advertsObject]=\"advertsObject\"></app-report>\r\n    </section>\r\n\r\n    <section id=\"summary--container\" class=\"col-md-5\">\r\n      <app-summary [advertsObject]=\"advertsObject\"></app-summary>\r\n    </section>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <section id=\"filters--container\" class=\"col-md-12\">\r\n      <app-filters (advertsUpdate)=\"updateAdvertsFromFilters($event)\" [ownVehicle]=\"ownVehicleParams\"></app-filters>\r\n    </section>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <section id=\"matches--container\" class=\"col align-self-end\">\r\n      <app-matches [advertsObject]=\"advertsObject\"></app-matches>\r\n    </section>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <section id=\"results--container\" class=\"col-md-12\">\r\n      <app-results [listOfVehicles]=\"listOfVehicles\" [ownVehicle]=\"ownVehicleParams\"></app-results>\r\n    </section>\r\n  </div>\r\n\r\n  <scroll-up-button></scroll-up-button>\r\n\r\n</main>\r\n", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main#liveRetailLibContainer{border-radius:5px;background-color:#fff;position:relative}#report--container{height:250px;padding-left:0;margin-bottom:20px;align-self:flex-end}#summary--container{border-radius:5px;min-height:250px;border:1px solid #dae0e1;background-color:#232c32;margin-bottom:20px;padding:0}#filters--container{padding:0;z-index:1}#matches--container{padding:0}#results--container{padding:0;background-color:#fff;min-height:200px;margin-bottom:10px}.tooltip.show{opacity:1!important}.tooltip-style-1 .tooltip-inner{background-color:#fff;color:#232c32;padding:0;-webkit-box-shadow:4px 4px 10px 1px rgba(0,0,0,.5);-moz-box-shadow:4px 4px 10px 1px rgba(0,0,0,.5);box-shadow:4px 4px 10px 1px #00000080;font-size:16px;opacity:1;max-width:none}.tooltip-style-1 .tooltip-inner table thead>tr>th{padding:5px 10px}.tooltip-style-1 .tooltip-inner table td{text-align:left;padding:0 5px}.tooltip-style-1 .arrow:before{border-top-color:#006400}.tooltip-style-2 .tooltip-inner{background-color:#006400;font-size:125%}.tooltip-style-2 .arrow:before{border-top-color:#006400}.tooltip-trigger{cursor:help}.tooltip-trigger:hover{text-decoration:underline}ngb-tooltip-window.bs-tooltip-bottom-left .arrow{left:0!important}ngb-tooltip-window.bs-tooltip-bottom-right .arrow{right:0!important}@media (max-width: 767px){.information--container{flex-flow:wrap-reverse}#report--container{padding-right:0}#summary--container{height:auto;margin-bottom:0}}.loader--container{width:100%;display:flex;position:absolute}.lds-ellipsis{display:inline-block;position:relative;margin:auto;width:80px;height:80px}.lds-tooltip{height:40px!important}.lds-ellipsis div{position:absolute;top:33px;width:13px;height:13px;border-radius:50%;background:#00a8be;animation-timing-function:cubic-bezier(0,1,1,0)}.lds-tooltip div{top:17px!important}.lds-ellipsis div:nth-child(1){left:8px;animation:lds-ellipsis1 .6s infinite}.lds-ellipsis div:nth-child(2){left:8px;animation:lds-ellipsis2 .6s infinite}.lds-ellipsis div:nth-child(3){left:32px;animation:lds-ellipsis2 .6s infinite}.lds-ellipsis div:nth-child(4){left:56px;animation:lds-ellipsis3 .6s infinite}@keyframes lds-ellipsis1{0%{transform:scale(0)}to{transform:scale(1)}}@keyframes lds-ellipsis3{0%{transform:scale(1)}to{transform:scale(0)}}@keyframes lds-ellipsis2{0%{transform:translate(0)}to{transform:translate(24px)}}.multiselect-dropdown .dropdown-btn{max-height:35px;overflow:hidden}.multiselect-dropdown .dropdown-btn .selected-item{font-size:12px!important;float:none!important}.multiselect-dropdown .dropdown-btn span:last-child span:first-of-type{right:22px}.multiselect-dropdown .dropdown-btn .dropdown-down,.multiselect-dropdown .dropdown-btn .dropdown-up{position:absolute!important;right:5px!important;top:13px!important}.multiselect-item-checkbox{font-size:14px}.multiselect-item-checkbox div{padding-left:22px!important}.dropdown-list li{padding:5px!important}.scroll-to-top{position:fixed;bottom:15px;right:15px;opacity:0;transition:all .2s ease-in-out}.show-scrollTop{opacity:1;transition:all .2s ease-in-out}.dc-style--tooltip{text-align:left;max-width:400px;padding:20px}span.tooltip-trigger:not(.scatterGraph--trigger) img{width:15px;transition:all .2s ease-in-out}span.tooltip-trigger:not(.scatterGraph--trigger) img:hover{transition:all .2s ease-in-out;width:20px}.error-modal{z-index:999;position:absolute;background-color:gray;width:100%;height:100%;display:flex;justify-content:center;align-items:flex-start;opacity:.95}.error-modal div{background-color:#fff;width:auto;max-width:300px;padding:40px 20px;text-align:center;min-height:180px;border-radius:4px;margin-top:50px}.error-modal div h4{font-family:Aileron;font-size:18px}.error-modal div strong{margin-bottom:15px;display:block}.error-modal div i{margin-top:10px;font-size:16px}\n"], dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ReportComponent, selector: "app-report", inputs: ["advertsObject", "annotations", "colors", "dataLabels", "series", "stroke", "labels", "tooltip", "xaxis", "yaxis", "grid"] }, { kind: "component", type: SummaryComponent, selector: "app-summary", inputs: ["advertsObject"] }, { kind: "component", type: FiltersComponent, selector: "app-filters", inputs: ["ownVehicle"], outputs: ["advertsUpdate"] }, { kind: "component", type: ResultsComponent, selector: "app-results", inputs: ["listOfVehicles", "ownVehicle"] }, { kind: "component", type: MatchesComponent, selector: "app-matches", inputs: ["advertsObject"] }, { kind: "component", type: ScatterGraphComponent, selector: "app-scatter-graph", inputs: ["listOfVehicles"] }, { kind: "component", type: ScrollUpButtonComponent, selector: "scroll-up-button" }, { kind: "pipe", type: i4.JsonPipe, name: "json" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: LiveRetailLibComponent, decorators: [{
            type: Component,
            args: [{ selector: 'liveRetail-lib', providers: [NgbTooltipConfig, LiveRetailLibService], encapsulation: ViewEncapsulation.None, template: "<main id=\"liveRetailLibContainer\" class=\"container-lg\">\r\n  <!-- Error modal (Only appears when no params provided) -->\r\n  <div *ngIf=\"noDataProvidedFlag\" class=\"row error-modal\"> \r\n    <div>\r\n      <h4>No parameters provided</h4>\r\n      <strong> Expected: ownVehicle(Object)</strong>\r\n      <br>\r\n      <i> Recieved: {{ownVehicleParams | json}} </i>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"onlyOwnVhFlag\" class=\"row error-modal\"> \r\n    <div>\r\n      <h4>{{lngProps.errorCode.onlyOwnVh}}</h4>\r\n      <button class=\"btn btn-md btn-primary\" (click)=\"closeModal()\">CLOSE</button>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"noAskingOrMileageProvidedFlag\" class=\"row error-modal\"> \r\n    <div>\r\n    <strong>{{lngProps.errorCode.wrongAskingOrMileage}}</strong>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"wrongDataProvidedFlag\" class=\"row error-modal\"> \r\n    <div>\r\n      <h4>Missing mandatory parameters</h4>\r\n      <strong>Be sure that the object follows the interface of OwnVehicleParams</strong>\r\n      <!-- <p>Parameters: <br> <i> {{ownVehicleParams.ownVehicle | json}} </i></p>  -->\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"row information--container\">\r\n    <section id=\"report--container\" class=\"col-md-7\">\r\n      <app-scatter-graph [listOfVehicles]=\"listOfVehicles\"></app-scatter-graph>\r\n      <app-report [advertsObject]=\"advertsObject\"></app-report>\r\n    </section>\r\n\r\n    <section id=\"summary--container\" class=\"col-md-5\">\r\n      <app-summary [advertsObject]=\"advertsObject\"></app-summary>\r\n    </section>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <section id=\"filters--container\" class=\"col-md-12\">\r\n      <app-filters (advertsUpdate)=\"updateAdvertsFromFilters($event)\" [ownVehicle]=\"ownVehicleParams\"></app-filters>\r\n    </section>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <section id=\"matches--container\" class=\"col align-self-end\">\r\n      <app-matches [advertsObject]=\"advertsObject\"></app-matches>\r\n    </section>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <section id=\"results--container\" class=\"col-md-12\">\r\n      <app-results [listOfVehicles]=\"listOfVehicles\" [ownVehicle]=\"ownVehicleParams\"></app-results>\r\n    </section>\r\n  </div>\r\n\r\n  <scroll-up-button></scroll-up-button>\r\n\r\n</main>\r\n", styles: ["@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main{font-family:Aileron}.w100{width:100%!important}.w50{width:50%!important}.mw160{min-width:160px!important}.h35{height:35px!important}.txt-center{text-align:center}.txt-right{text-align:right}.txt-left{text-align:left}.nowrap{white-space:nowrap}body::-webkit-scrollbar{width:12px}body::-webkit-scrollbar-track{background:#d3d3d3}body::-webkit-scrollbar-thumb{background-color:gray;border-radius:20px;border:3px solid lightgray}@font-face{font-family:Aileron light;src:url(/assets/aileron/Aileron-Light.woff) format(\"woff\");font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Aileron;src:url(/assets/aileron/Aileron-Regular.woff) format(\"woff\");font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Aileron semibold;src:url(/assets/aileron/Aileron-SemiBold.woff) format(\"woff\");font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Aileron bold;src:url(/assets/aileron/Aileron-Bold.woff) format(\"woff\");font-weight:700;font-style:normal;font-display:swap}main#liveRetailLibContainer{border-radius:5px;background-color:#fff;position:relative}#report--container{height:250px;padding-left:0;margin-bottom:20px;align-self:flex-end}#summary--container{border-radius:5px;min-height:250px;border:1px solid #dae0e1;background-color:#232c32;margin-bottom:20px;padding:0}#filters--container{padding:0;z-index:1}#matches--container{padding:0}#results--container{padding:0;background-color:#fff;min-height:200px;margin-bottom:10px}.tooltip.show{opacity:1!important}.tooltip-style-1 .tooltip-inner{background-color:#fff;color:#232c32;padding:0;-webkit-box-shadow:4px 4px 10px 1px rgba(0,0,0,.5);-moz-box-shadow:4px 4px 10px 1px rgba(0,0,0,.5);box-shadow:4px 4px 10px 1px #00000080;font-size:16px;opacity:1;max-width:none}.tooltip-style-1 .tooltip-inner table thead>tr>th{padding:5px 10px}.tooltip-style-1 .tooltip-inner table td{text-align:left;padding:0 5px}.tooltip-style-1 .arrow:before{border-top-color:#006400}.tooltip-style-2 .tooltip-inner{background-color:#006400;font-size:125%}.tooltip-style-2 .arrow:before{border-top-color:#006400}.tooltip-trigger{cursor:help}.tooltip-trigger:hover{text-decoration:underline}ngb-tooltip-window.bs-tooltip-bottom-left .arrow{left:0!important}ngb-tooltip-window.bs-tooltip-bottom-right .arrow{right:0!important}@media (max-width: 767px){.information--container{flex-flow:wrap-reverse}#report--container{padding-right:0}#summary--container{height:auto;margin-bottom:0}}.loader--container{width:100%;display:flex;position:absolute}.lds-ellipsis{display:inline-block;position:relative;margin:auto;width:80px;height:80px}.lds-tooltip{height:40px!important}.lds-ellipsis div{position:absolute;top:33px;width:13px;height:13px;border-radius:50%;background:#00a8be;animation-timing-function:cubic-bezier(0,1,1,0)}.lds-tooltip div{top:17px!important}.lds-ellipsis div:nth-child(1){left:8px;animation:lds-ellipsis1 .6s infinite}.lds-ellipsis div:nth-child(2){left:8px;animation:lds-ellipsis2 .6s infinite}.lds-ellipsis div:nth-child(3){left:32px;animation:lds-ellipsis2 .6s infinite}.lds-ellipsis div:nth-child(4){left:56px;animation:lds-ellipsis3 .6s infinite}@keyframes lds-ellipsis1{0%{transform:scale(0)}to{transform:scale(1)}}@keyframes lds-ellipsis3{0%{transform:scale(1)}to{transform:scale(0)}}@keyframes lds-ellipsis2{0%{transform:translate(0)}to{transform:translate(24px)}}.multiselect-dropdown .dropdown-btn{max-height:35px;overflow:hidden}.multiselect-dropdown .dropdown-btn .selected-item{font-size:12px!important;float:none!important}.multiselect-dropdown .dropdown-btn span:last-child span:first-of-type{right:22px}.multiselect-dropdown .dropdown-btn .dropdown-down,.multiselect-dropdown .dropdown-btn .dropdown-up{position:absolute!important;right:5px!important;top:13px!important}.multiselect-item-checkbox{font-size:14px}.multiselect-item-checkbox div{padding-left:22px!important}.dropdown-list li{padding:5px!important}.scroll-to-top{position:fixed;bottom:15px;right:15px;opacity:0;transition:all .2s ease-in-out}.show-scrollTop{opacity:1;transition:all .2s ease-in-out}.dc-style--tooltip{text-align:left;max-width:400px;padding:20px}span.tooltip-trigger:not(.scatterGraph--trigger) img{width:15px;transition:all .2s ease-in-out}span.tooltip-trigger:not(.scatterGraph--trigger) img:hover{transition:all .2s ease-in-out;width:20px}.error-modal{z-index:999;position:absolute;background-color:gray;width:100%;height:100%;display:flex;justify-content:center;align-items:flex-start;opacity:.95}.error-modal div{background-color:#fff;width:auto;max-width:300px;padding:40px 20px;text-align:center;min-height:180px;border-radius:4px;margin-top:50px}.error-modal div h4{font-family:Aileron;font-size:18px}.error-modal div strong{margin-bottom:15px;display:block}.error-modal div i{margin-top:10px;font-size:16px}\n"] }]
        }], ctorParameters: () => [{ type: i5.NgbTooltipConfig }, { type: LiveRetailLibService }, { type: AdvertsService }, { type: LiveRetailLibService }], propDecorators: { ownVehicleParams: [{
                type: Input
            }] } });

class LiveRetailLibModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: LiveRetailLibModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: LiveRetailLibModule, declarations: [LiveRetailLibComponent,
            ReportComponent,
            SummaryComponent,
            FiltersComponent,
            ResultsComponent,
            MatchesComponent,
            NumberLocalePipe,
            PriceChangesMappingPipe,
            NgbdSortableHeader,
            ScatterGraphComponent,
            RoundPipe,
            ScrollUpButtonComponent], imports: [HttpClientModule,
            FormsModule,
            CommonModule,
            ReactiveFormsModule,
            NgApexchartsModule,
            NgbTooltipModule,
            NgMultiSelectDropDownModule], exports: [LiveRetailLibComponent,
            ReportComponent,
            SummaryComponent,
            FiltersComponent,
            ResultsComponent,
            MatchesComponent,
            NumberLocalePipe,
            PriceChangesMappingPipe,
            NgbdSortableHeader,
            ScatterGraphComponent,
            RoundPipe,
            ScrollUpButtonComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: LiveRetailLibModule, imports: [HttpClientModule,
            FormsModule,
            CommonModule,
            ReactiveFormsModule,
            NgApexchartsModule,
            NgbTooltipModule,
            NgMultiSelectDropDownModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: LiveRetailLibModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        LiveRetailLibComponent,
                        ReportComponent,
                        SummaryComponent,
                        FiltersComponent,
                        ResultsComponent,
                        MatchesComponent,
                        NumberLocalePipe,
                        PriceChangesMappingPipe,
                        NgbdSortableHeader,
                        ScatterGraphComponent,
                        RoundPipe,
                        ScrollUpButtonComponent
                    ],
                    imports: [
                        HttpClientModule,
                        FormsModule,
                        CommonModule,
                        ReactiveFormsModule,
                        NgApexchartsModule,
                        NgbTooltipModule,
                        NgMultiSelectDropDownModule,
                    ],
                    exports: [
                        LiveRetailLibComponent,
                        ReportComponent,
                        SummaryComponent,
                        FiltersComponent,
                        ResultsComponent,
                        MatchesComponent,
                        NumberLocalePipe,
                        PriceChangesMappingPipe,
                        NgbdSortableHeader,
                        ScatterGraphComponent,
                        RoundPipe,
                        ScrollUpButtonComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of liveRetail-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FiltersComponent, LiveRetailLibComponent, LiveRetailLibModule, LiveRetailLibService, MatchesComponent, NgbdSortableHeader, NumberLocalePipe, PriceChangesMappingPipe, ReportComponent, ResultsComponent, RoundPipe, ScatterGraphComponent, ScrollUpButtonComponent, SummaryComponent };
